var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _g266, _g267, _g268, _g269, _g270, _g271, _g272, _g273, _g274, _g275, _g276, _g277, _g278, _g279, _g280, _g281, _g282, _g283, _g284, _g285, _g286, _g287, _g288, _g289, _g290, _g291, _g292, _g293, _g294, _g295, _g296, _g297, _g298, _g299, _g300, _g301, _g302, _g303, _g304, _g305, _g306, _g307, _g308, _g309, _g310, _g311, _g312, _g313, _g314, _g315, _g316, _g317, _g318, _g319, _g320, _g321, _g322, _g323, _g324, _g325, _g326, _g327, _g328, _g329, _g330, _g331, _g332, _g333, _g334, _g335, _g336, _g337, _g338, _g339, _g340, _g341, _g342, _g343, _g344, _g345, _g346, _g347, _g348, _g349, _g350, _g351, _g352, _g353, _g354, _g355, _g356, _g357, _g358, _g359, _g360, _g361, _g362, _g363, _g364, _g365, _g366, _g367, _g368, _g369, _g370, _g371, _g372, _g373, _g374, _g375, _g376, _g377, _g378, _g379, _g380, _g381, _g382, _g383, _g384, _g385, _g386, _g387, _g388, _g389, _g390, _g391, _g392, _g393, _g394, _g395, _g396, _g397, _g398, _g399, _g400, _g401, _g402, _g403, _g404, _g405, _g406, _g407, _g408, _g409, _g410, _g411, _g412, _g413, _g414, _g415, _g416, _g417, _g418, _g419, _g420, _g421, _g422, _g423, _g424, _g425, _g426, _g427, _g428, _g429, _g430, _g431, _g432, _g433, _g434, _g435, _g436, _g437, _g438, _g439, _g440, _g441, _g442, _g443, _g444, _g445, _g446, _g447, _g448, _g449, _g450, _g451, _g452, _g453, _g454, _g455, _g456, _g457, _g458, _g459, _g460, _g461, _g462, _g463, _g464, _g465, _g466, _g467, _g468, _g469, _g470, _g471, _g472, _g473, _g474, _g475, _g476, _g477, _g478, _g479, _g480, _g481, _g482, _g483, _g484, _g485, _g486, _g487, _g488, _g489, _g490, _g491, _g492, _g493, _g494, _g495, _g496, _g497, _g498, _g499, _g500, _g501, _g502, _g503, _g504, _g505, _g506, _g507, _g508, _g509, _g510, _g511, _g512, _g513, _g514, _g515, _g516, _g517, _g518, _g519, _g520, _g521, _g522, _g523, _g524, _g525, _g526, _g527, _g528, _g529, _g530, _g531, _g532, _g533, _g534, _g535, _g536, _g537, _g538, _g539, _g540, _g541, _g542, _g543, _g544, _g545, _g546, _g547, _g548, _g549, _g550, _g551, _g552, _g553, _g554, _g555, _g556, _g557, _g558;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNordicRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 523 477",
    width: 523,
    height: 477,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 0.00 477.00  L 523.00 477.00 L 523.00 0.00 L 0.00 0.00 L 0.00 477.00 M 143.00 122.00  C 149.65 127.20 154.77 138.87 159.00 146.00 C 160.93 148.59 163.16 151.15 165.00 154.00 C 167.81 158.35 170.55 162.65 173.00 167.00 C 175.18 170.05 178.63 172.20 180.00 176.00 C 180.16 176.44 180.00 177.00 180.00 177.00 C 182.70 178.76 182.79 180.36 184.00 183.00 C 186.67 188.84 184.07 189.71 178.00 188.00 C 176.68 187.63 175.34 187.41 174.00 187.00 C 171.57 186.25 169.10 184.82 167.00 184.00 C 162.67 182.77 158.22 181.71 154.00 180.00 C 150.53 181.24 152.31 186.52 152.00 190.00 C 158.79 189.54 165.16 193.59 171.00 196.00 C 173.60 197.07 176.37 197.40 178.00 200.00 C 178.43 200.17 179.00 200.00 179.00 200.00 C 190.41 204.12 199.90 217.79 204.00 227.00 C 205.67 229.40 206.82 230.77 208.00 235.00 C 209.25 238.08 211.79 241.00 212.00 245.00 C 212.05 245.99 212.00 247.01 212.00 248.00 C 213.98 257.31 213.75 265.78 212.00 275.00 C 212.02 279.29 211.38 282.18 210.00 286.00 C 208.86 289.16 207.40 292.20 206.00 295.00 C 203.90 299.20 201.86 303.07 199.00 307.00 C 197.15 309.53 190.97 318.92 188.00 317.00 C 187.69 316.80 187.20 316.32 187.00 316.00 C 183.46 313.25 179.52 309.21 178.00 305.00 C 177.84 304.56 178.00 304.00 178.00 304.00 C 174.82 301.93 173.51 298.31 172.00 295.00 C 171.07 292.96 170.58 291.22 170.00 289.00 C 168.54 285.36 166.45 281.28 166.00 277.00 C 165.80 275.05 166.00 272.96 166.00 271.00 C 165.57 266.60 165.58 261.34 166.00 257.00 C 166.00 252.35 166.51 249.15 168.00 245.00 C 169.29 241.43 170.86 237.99 173.00 235.00 C 174.27 233.22 175.67 231.64 177.00 230.00 C 178.93 227.63 181.21 224.36 184.00 223.00 C 184.40 222.80 185.00 223.00 185.00 223.00 C 185.49 222.76 185.73 221.38 186.00 221.00 C 184.13 221.79 181.98 222.41 180.00 223.00 C 176.71 224.95 173.82 228.81 171.00 231.00 C 168.89 233.42 167.70 236.24 165.00 238.00 C 164.84 238.44 165.00 239.00 165.00 239.00 C 164.02 241.51 162.55 244.06 161.00 246.00 C 160.89 246.47 161.00 247.00 161.00 247.00 C 160.42 249.48 158.67 251.90 158.00 254.00 C 157.72 255.38 157.08 258.07 157.00 260.00 C 156.68 268.14 157.55 276.21 158.00 284.00 C 158.06 285.09 156.11 286.59 157.00 288.00 C 160.20 286.46 161.88 298.22 164.92 303.08 C 167.96 307.94 171.26 315.75 175.00 320.00 C 176.45 321.82 179.43 323.00 179.00 326.00 C 177.66 326.73 176.36 327.34 175.00 328.00 C 169.93 330.86 164.29 332.74 158.00 334.00 C 156.27 334.52 155.31 335.73 153.00 336.00 C 150.74 336.26 148.28 336.00 146.00 336.00 C 141.28 336.45 135.65 336.45 131.00 336.00 C 129.04 336.00 126.95 336.21 125.00 336.00 C 122.72 335.76 121.67 334.51 120.00 334.00 C 115.13 333.02 111.46 331.99 107.00 330.00 C 103.65 328.50 100.56 326.67 98.00 324.00 C 97.56 323.84 97.00 324.00 97.00 324.00 C 90.89 319.33 83.65 313.92 80.00 307.00 C 77.67 302.58 78.58 302.86 80.00 299.00 C 80.14 298.34 81.23 293.33 81.00 294.00 C 81.72 289.77 83.19 284.91 85.00 280.00 C 86.27 276.55 87.69 271.06 91.00 269.00 C 91.17 268.57 91.00 268.00 91.00 268.00 C 94.94 257.07 106.12 246.81 115.00 240.00 C 118.00 234.97 124.92 231.54 130.00 229.00 C 134.20 226.37 138.22 223.97 143.00 222.00 C 150.93 217.58 160.77 215.50 170.00 215.00 C 171.98 214.68 176.08 213.26 178.00 213.00 C 163.10 212.71 150.20 214.45 136.00 219.00 C 133.35 220.23 131.13 222.27 128.00 223.00 C 127.53 223.11 127.00 223.00 127.00 223.00 C 125.59 225.25 123.21 225.73 121.00 227.00 C 116.51 229.58 112.06 233.16 108.00 236.00 C 103.37 239.80 99.97 245.52 95.00 249.00 C 94.91 249.48 95.00 250.00 95.00 250.00 C 91.44 254.66 86.94 259.05 84.00 264.00 C 81.90 268.49 80.31 273.24 77.25 277.25 C 74.19 281.25 75.34 290.12 70.00 291.00 C 72.04 287.41 66.64 285.14 68.00 281.00 C 67.28 278.64 66.20 276.96 66.00 274.00 C 65.82 271.36 66.00 268.65 66.00 266.00 C 65.70 262.93 65.31 260.14 66.00 257.00 C 66.00 256.00 66.00 255.00 66.00 254.00 C 66.00 240.71 71.87 227.29 80.00 217.00 C 84.99 210.68 90.30 205.41 97.00 201.00 C 103.78 196.54 111.10 193.55 119.00 192.00 C 121.27 191.26 123.77 188.61 127.00 190.00 C 126.04 187.27 129.15 178.51 125.00 180.00 C 120.53 181.32 115.17 183.72 110.78 184.78 C 106.38 185.84 99.76 191.13 95.00 189.00 C 91.22 187.31 93.47 182.58 96.00 181.00 C 96.23 180.64 96.00 180.00 96.00 180.00 C 98.92 175.31 105.72 161.10 111.00 160.00 C 111.74 156.23 114.42 152.84 117.00 150.00 C 118.56 147.58 118.37 146.09 121.00 145.00 C 121.16 144.56 121.00 144.00 121.00 144.00 C 122.11 140.94 124.81 138.10 127.00 136.00 C 127.16 135.56 127.00 135.00 127.00 135.00 C 128.14 131.85 131.25 127.79 134.00 126.00 C 134.22 125.64 134.00 125.00 134.00 125.00 C 135.82 119.95 139.17 119.01 143.00 122.00 M 319.00 169.00  C 321.48 170.72 324.42 173.03 325.00 176.00 C 325.09 176.48 325.00 177.00 325.00 177.00 C 327.63 179.01 327.02 182.89 327.00 186.00 C 326.99 187.33 327.00 188.67 327.00 190.00 C 327.00 195.54 329.54 210.52 325.00 214.00 C 324.76 214.18 325.00 215.00 325.00 215.00 C 324.34 218.40 320.16 221.86 317.00 223.00 C 316.56 223.16 316.00 223.00 316.00 223.00 C 311.73 225.33 304.11 226.34 300.00 223.00 C 299.51 222.92 299.00 223.00 299.00 223.00 C 295.10 222.14 289.85 217.35 290.00 213.00 C 290.02 212.50 290.00 212.00 290.00 212.00 C 289.42 211.13 289.16 211.32 289.00 210.00 C 286.15 203.00 287.24 188.09 289.00 181.00 C 289.15 179.30 288.93 179.15 290.00 178.00 C 290.00 177.50 290.00 177.00 290.00 177.00 C 290.91 172.84 294.32 169.86 298.00 168.00 C 304.39 164.77 313.11 164.92 319.00 169.00 M 462.00 168.00  C 462.50 168.01 463.00 168.00 463.00 168.00 C 466.51 169.27 469.71 172.56 471.00 176.00 C 471.95 178.54 472.71 182.15 472.00 185.00 C 471.64 186.44 462.66 189.49 461.00 186.00 C 460.53 185.01 461.16 183.10 461.00 182.00 C 460.21 178.97 455.77 177.89 453.00 178.00 C 452.50 178.02 451.45 177.85 451.00 178.00 C 449.11 179.29 447.30 184.33 447.00 186.00 C 446.51 191.20 446.46 199.11 447.00 205.00 C 447.20 206.25 449.28 212.30 451.00 213.00 C 456.98 214.76 462.55 209.29 461.00 204.00 C 465.63 204.65 473.74 203.33 472.00 211.00 C 471.76 215.96 467.37 222.50 462.00 223.00 C 461.50 223.05 461.00 223.00 461.00 223.00 C 456.28 225.06 452.68 224.56 448.00 223.00 C 442.76 221.25 437.18 218.08 437.00 212.00 C 434.46 205.04 431.81 185.38 437.00 179.00 C 437.00 178.50 437.00 178.00 437.00 178.00 C 437.33 173.52 440.38 170.87 444.00 169.00 C 446.43 167.75 447.31 167.63 450.00 167.00 C 454.18 166.03 458.05 165.84 462.00 168.00 M 255.00 168.00  C 255.52 168.50 255.67 169.41 256.00 170.00 C 261.91 180.45 265.98 190.24 271.00 201.00 C 273.32 191.24 271.35 179.51 272.00 169.00 C 271.65 168.95 270.90 168.19 271.00 168.00 C 272.58 165.18 279.38 168.05 282.00 167.00 C 281.33 185.50 283.33 205.32 281.00 223.00 C 275.82 223.47 270.76 224.10 268.00 220.00 C 262.38 211.64 261.49 200.20 256.00 193.00 C 256.51 195.94 254.63 204.23 255.00 208.00 C 255.37 211.77 256.41 220.68 254.00 223.00 C 252.19 223.16 245.41 223.99 244.00 223.00 C 238.99 219.49 245.36 207.01 243.00 201.00 C 240.64 194.99 245.74 184.78 243.00 178.00 C 240.26 171.22 247.95 161.11 255.00 168.00 M 356.00 168.00  C 356.50 168.00 357.00 168.00 357.00 168.00 C 357.50 168.00 358.00 168.00 358.00 168.00 C 360.53 168.58 363.33 170.18 365.00 172.00 C 365.76 172.82 366.49 174.04 367.00 175.00 C 367.72 176.37 367.97 177.10 368.00 179.00 C 369.35 184.41 370.63 187.51 368.00 193.00 C 368.18 193.08 368.08 194.51 368.00 195.00 C 367.51 198.04 363.88 201.34 361.00 202.00 C 363.56 207.94 365.99 213.77 368.00 220.00 C 368.25 220.78 371.05 221.31 370.00 223.00 C 366.33 221.28 357.20 226.19 356.00 220.00 C 353.48 216.25 353.29 212.08 352.00 208.00 C 350.85 205.44 348.41 203.06 345.00 204.00 C 344.34 210.16 346.32 217.66 344.00 223.00 C 340.85 223.28 337.15 223.29 334.00 223.00 C 329.58 218.74 334.06 203.34 333.00 197.00 C 331.94 190.66 332.88 176.04 333.00 170.00 C 333.12 163.96 353.56 166.19 356.00 168.00 M 395.00 168.00  C 406.76 170.11 408.98 174.71 411.00 186.00 C 411.35 187.96 411.95 190.43 412.00 193.00 C 412.13 199.31 411.55 204.62 410.00 210.00 C 409.66 219.06 402.33 222.55 394.00 223.00 C 388.21 223.31 381.78 223.52 376.00 223.00 C 372.51 219.64 375.73 211.24 375.00 206.00 C 374.27 200.76 375.08 192.74 375.00 187.00 C 374.92 181.26 374.47 173.83 375.00 168.00 C 378.23 164.64 391.29 167.34 395.00 168.00 M 425.00 168.00  C 426.51 167.90 427.64 166.75 429.00 168.00 C 432.24 170.97 429.54 181.41 430.00 186.00 C 430.46 190.59 430.53 200.56 430.00 205.00 C 429.47 209.44 432.36 220.65 429.00 223.00 C 427.45 224.09 419.99 223.18 418.00 223.00 C 414.52 219.65 418.00 213.17 417.00 208.00 C 416.00 202.83 417.76 196.96 417.00 191.00 C 416.24 185.04 418.03 182.22 417.00 175.00 C 415.97 167.78 419.06 167.60 425.00 168.00 M 322.00 235.00  C 330.24 237.14 332.32 244.26 334.00 249.00 C 336.86 257.05 335.89 272.89 334.00 281.00 C 332.88 285.82 331.70 288.30 328.00 291.00 C 326.03 292.93 325.60 294.01 323.00 295.00 C 321.16 295.71 320.05 295.85 318.00 296.00 C 314.22 296.70 310.72 296.69 307.00 296.00 C 304.93 295.85 303.87 295.74 302.00 295.00 C 297.74 293.31 292.97 288.40 292.00 284.00 C 291.90 283.52 292.00 283.00 292.00 283.00 C 286.63 276.39 289.24 254.11 292.00 247.00 C 292.13 244.60 292.92 243.97 294.00 242.00 C 295.79 238.71 297.98 235.88 302.00 235.00 C 302.48 234.90 303.00 235.00 303.00 235.00 C 306.68 230.20 317.94 233.37 322.00 235.00 M 244.00 236.00  C 244.35 236.23 245.00 236.00 245.00 236.00 C 249.07 232.99 261.64 234.80 267.00 235.00 C 270.07 235.12 272.71 234.67 275.00 237.00 C 275.25 237.25 276.00 237.00 276.00 237.00 C 279.36 238.30 280.66 241.07 282.00 244.00 C 284.09 248.57 284.28 252.78 284.00 258.00 C 283.85 260.72 284.27 263.26 282.00 265.00 C 281.84 265.44 282.00 266.00 282.00 266.00 C 281.18 270.22 276.18 270.89 276.00 275.00 C 275.98 275.50 276.00 276.00 276.00 276.00 C 278.53 277.94 278.82 281.13 280.00 284.00 C 281.48 286.65 284.84 291.63 283.00 294.00 C 282.76 294.31 283.00 295.00 283.00 295.00 C 282.80 294.71 271.74 298.25 269.00 292.00 C 267.99 290.62 268.34 289.56 268.00 288.00 C 267.53 287.04 266.53 286.21 266.00 285.00 C 265.02 282.77 264.91 280.18 264.00 278.00 C 262.56 275.63 259.98 274.42 257.00 275.00 C 257.00 281.33 257.00 287.67 257.00 294.00 C 256.23 297.60 246.75 296.29 245.00 295.00 C 244.70 294.78 244.22 294.30 244.00 294.00 C 240.83 289.69 243.97 280.31 243.00 275.00 C 242.03 269.69 243.92 258.72 243.00 254.00 C 242.08 249.28 244.06 236.04 244.00 236.00 M 359.00 284.00  C 359.40 284.20 360.00 284.00 360.00 284.00 C 362.02 284.00 365.08 284.59 367.00 284.00 C 369.48 282.75 370.49 280.53 371.00 278.00 C 370.50 272.52 371.78 260.85 371.00 256.00 C 370.22 251.15 372.11 236.07 372.00 236.00 C 372.35 236.23 373.00 236.00 373.00 236.00 C 375.35 234.26 380.84 234.71 384.00 235.00 C 388.51 239.34 383.84 253.41 385.00 260.00 C 386.16 266.59 385.70 279.29 383.00 285.00 C 377.34 296.96 360.18 300.83 349.00 292.00 C 345.95 289.59 343.28 286.98 343.00 283.00 C 342.96 282.50 343.00 281.50 343.00 281.00 C 340.83 275.88 341.35 263.79 342.00 258.00 C 342.65 252.21 339.10 238.75 343.00 235.00 C 346.97 234.64 351.02 235.27 355.00 235.00 C 357.01 251.10 350.59 269.93 359.00 284.00 M 429.00 236.00  C 430.71 237.71 430.72 244.34 429.00 246.00 C 428.74 246.25 428.00 246.00 428.00 246.00 C 424.33 246.00 420.67 246.00 417.00 246.00 C 417.61 252.79 417.80 264.58 417.00 271.00 C 416.20 277.42 420.23 290.91 416.00 295.00 C 415.74 295.25 415.00 295.00 415.00 295.00 C 412.93 296.53 405.94 296.94 404.00 295.00 C 399.30 290.48 404.69 277.66 403.00 271.00 C 401.31 264.34 404.27 253.08 403.00 246.00 C 399.54 244.57 393.66 247.97 391.00 246.00 C 388.50 243.60 390.81 238.24 390.00 235.00 C 402.83 235.67 416.99 233.67 429.00 236.00 M 448.00 246.00  C 448.00 250.00 448.00 254.00 448.00 258.00 C 451.96 257.64 464.45 256.34 467.00 259.00 C 467.26 261.86 467.92 268.10 466.00 270.00 C 462.67 273.30 452.10 267.28 448.00 271.00 C 448.00 274.67 448.00 278.33 448.00 282.00 C 450.00 282.00 452.00 282.00 454.00 282.00 C 457.45 281.69 466.71 280.71 469.00 283.00 C 470.82 284.82 470.39 291.30 470.00 294.00 C 469.95 294.35 469.35 294.96 469.00 295.00 C 468.50 295.05 468.00 295.00 468.00 295.00 C 463.94 298.01 455.15 295.29 451.00 295.00 C 446.98 295.16 443.24 295.64 439.00 295.00 C 433.07 294.52 434.62 285.40 435.00 279.00 C 435.38 272.60 433.74 262.59 435.00 257.00 C 436.26 251.41 431.71 238.00 436.00 235.00 C 439.80 232.34 448.31 236.39 453.00 235.00 C 457.69 233.61 465.06 236.04 470.00 235.00 C 470.00 238.67 470.00 242.33 470.00 246.00 C 462.67 246.00 455.33 246.00 448.00 246.00 M 255.00 312.00  C 254.13 313.81 253.67 314.48 251.00 314.00 C 251.00 318.00 251.00 322.00 251.00 326.00 C 250.00 326.00 249.00 326.00 248.00 326.00 C 245.98 324.06 246.74 316.92 247.00 314.00 C 244.06 314.07 243.71 312.87 244.00 310.00 C 247.50 310.77 253.02 308.14 255.00 312.00 M 265.00 311.00  C 267.13 312.55 267.07 314.21 267.00 317.00 C 266.99 317.29 266.74 325.41 267.00 325.00 C 264.48 329.04 261.20 322.71 261.00 321.00 C 261.00 322.67 261.00 324.33 261.00 326.00 C 259.72 325.72 257.50 326.76 257.00 325.00 C 256.94 324.99 257.00 324.00 257.00 324.00 C 257.00 321.33 257.00 318.67 257.00 316.00 C 257.00 315.50 257.00 315.00 257.00 315.00 C 252.83 309.79 262.15 308.92 265.00 311.00 M 278.00 315.00  C 279.32 318.63 280.33 322.18 281.00 326.00 C 279.39 325.99 276.57 326.59 277.00 324.00 C 274.12 323.99 273.88 325.74 272.00 326.00 C 270.69 326.18 269.31 325.86 268.00 326.00 C 269.70 321.77 270.31 317.24 272.00 313.00 C 275.11 307.81 276.42 310.65 278.00 315.00 M 293.00 326.00  C 290.24 327.62 287.95 322.34 287.00 321.00 C 287.08 322.68 287.56 325.07 286.00 326.00 C 285.26 326.44 283.79 325.65 283.00 326.00 C 283.00 321.00 283.00 316.00 283.00 311.00 C 285.46 307.14 288.84 314.89 290.00 316.00 C 289.65 312.85 289.54 308.70 294.00 310.00 C 293.35 315.16 295.31 321.66 293.00 326.00 M 304.00 311.00  C 304.49 311.05 305.00 311.00 305.00 311.00 C 306.71 312.67 306.59 317.01 303.00 316.00 C 303.24 317.88 305.55 317.46 306.00 319.00 C 307.71 323.89 303.49 329.76 298.00 326.00 C 296.14 324.73 295.67 325.01 296.01 321.99 C 296.35 318.97 300.99 322.95 300.00 323.00 C 302.45 322.07 302.87 323.48 302.00 321.00 C 300.77 318.71 294.94 318.18 296.01 313.99 C 297.08 309.80 300.95 308.62 304.00 311.00 M 316.00 311.00  C 316.50 311.00 317.00 311.00 317.00 311.00 C 320.07 311.92 320.18 320.16 317.00 321.00 C 316.09 321.24 314.88 320.68 314.00 321.00 C 311.48 322.73 314.71 326.56 310.00 326.00 C 307.70 323.78 308.70 314.35 309.00 311.00 C 310.69 309.24 314.30 309.74 316.00 311.00 M 332.00 314.00  C 335.22 322.72 325.20 332.96 321.00 322.00 C 320.06 319.54 319.21 316.42 321.00 314.00 C 321.00 313.50 321.00 313.00 321.00 313.00 C 322.51 307.21 330.50 309.94 332.00 314.00 M 342.00 311.00  C 343.91 311.95 343.01 311.03 344.00 313.00 C 345.53 316.05 344.45 318.56 344.00 322.00 C 343.78 323.68 346.35 323.49 344.66 325.68 C 342.98 327.86 340.91 323.98 341.00 324.00 C 338.30 323.52 340.39 324.46 338.00 325.00 C 337.45 325.12 336.18 326.80 335.00 326.00 C 335.00 321.00 335.00 316.00 335.00 311.00 C 336.52 308.83 340.40 310.21 342.00 311.00 M 357.00 311.00  C 357.23 311.16 357.24 312.82 357.00 313.00 C 355.89 313.82 354.70 314.34 353.00 314.00 C 351.85 317.71 355.79 326.16 350.00 326.00 C 350.00 322.00 350.00 318.00 350.00 314.00 C 346.96 314.91 345.27 312.97 346.00 310.00 C 349.50 310.62 354.32 308.73 357.00 311.00 M 375.00 320.00  C 375.75 321.85 374.49 323.73 376.00 326.00 C 375.00 326.00 374.00 326.00 373.00 326.00 C 369.36 327.52 367.04 326.48 366.00 325.00 C 364.10 322.30 363.43 316.87 365.00 313.00 C 367.79 306.15 376.20 312.09 372.00 318.00 C 373.28 317.73 374.72 318.77 375.00 320.00 M 386.00 311.00  C 386.36 314.97 385.73 319.02 386.00 323.00 C 386.87 323.61 390.39 322.20 391.00 323.00 C 391.96 317.87 391.01 310.41 398.00 310.00 C 406.42 309.51 405.39 321.97 401.92 325.92 C 398.44 329.86 395.48 324.36 394.00 324.00 C 390.63 323.18 393.74 325.09 391.00 326.00 C 389.96 326.35 383.85 326.59 383.00 326.00 C 379.41 323.49 383.61 313.74 382.00 310.00 C 383.28 310.28 385.50 309.24 386.00 311.00 M 414.00 315.00  C 409.38 315.40 407.44 321.60 414.00 323.00 C 411.45 320.18 411.80 316.82 417.00 318.00 C 419.90 318.20 418.71 321.58 417.00 324.00 C 414.70 327.25 412.28 327.29 408.00 326.00 C 407.94 322.66 405.31 317.72 407.00 313.00 C 409.53 307.72 419.60 309.22 418.00 316.00 C 416.72 315.72 414.50 316.76 414.00 315.00 M 424.00 326.00  C 421.60 326.89 421.75 325.27 421.00 324.00 C 419.45 321.37 419.12 314.53 421.00 312.00 C 421.00 311.50 421.00 311.00 421.00 311.00 C 422.06 309.92 423.34 309.87 425.00 310.00 C 424.35 315.16 426.31 321.66 424.00 326.00 M 437.00 321.00  C 437.43 325.92 433.23 328.26 429.00 326.00 C 424.41 323.55 427.59 318.88 431.00 323.00 C 431.44 323.16 432.95 323.15 433.00 323.00 C 434.08 319.86 422.30 316.34 428.26 311.26 C 434.22 306.18 440.29 315.04 434.00 316.00 C 434.66 317.93 437.39 318.67 437.00 321.00 M 449.00 311.00  C 449.23 311.35 449.24 312.80 449.00 313.00 C 448.16 313.68 447.41 314.35 446.00 314.00 C 445.37 317.83 447.28 322.99 445.00 326.00 C 444.65 326.23 443.35 326.23 443.00 326.00 C 440.05 324.08 443.14 316.96 442.00 314.00 C 441.00 313.89 439.27 314.47 439.00 313.00 C 438.76 312.80 438.77 311.35 439.00 311.00 C 440.15 309.24 447.88 309.28 449.00 311.00 M 452.00 326.00  C 452.00 320.67 452.00 315.33 452.00 310.00 C 456.80 310.21 456.89 325.77 452.00 326.00 M 463.00 316.00  C 463.36 313.16 465.77 307.70 469.00 311.00 C 469.11 311.02 469.00 312.00 469.00 312.00 C 468.51 314.13 466.23 316.81 466.36 318.70 C 466.49 320.59 471.05 324.68 468.00 326.00 C 464.46 327.53 465.24 323.12 464.00 322.00 C 460.22 320.40 463.55 325.48 461.00 325.00 C 460.52 324.91 459.46 324.87 459.00 325.00 C 457.56 325.41 457.74 313.92 458.00 311.00 C 461.67 307.23 461.79 314.64 463.00 316.00 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B1BEB7",
    strokeOpacity: 0.08,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 134.00 125.00  C 136.91 122.22 138.44 119.55 143.00 122.00 C 139.17 119.01 135.82 119.95 134.00 125.00 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#296B4E",
    strokeOpacity: 0.95,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 134.00 125.00  C 134.00 125.00 134.22 125.64 134.00 126.00 C 132.05 129.14 130.12 132.97 127.00 135.00 C 127.00 135.00 127.16 135.56 127.00 136.00 C 125.89 139.07 123.19 141.90 121.00 144.00 C 121.00 144.00 121.16 144.56 121.00 145.00 C 120.12 147.45 118.56 148.27 117.00 150.00 C 114.42 152.84 111.74 156.23 111.00 160.00 C 110.91 160.48 111.00 161.00 111.00 161.00 C 109.50 163.41 107.75 165.00 106.00 167.00 C 103.38 170.93 100.07 177.35 96.00 180.00 C 96.00 180.00 96.23 180.64 96.00 181.00 C 94.91 182.73 92.46 187.31 95.00 189.00 C 99.76 191.13 106.38 185.84 110.78 184.78 C 115.17 183.72 120.53 181.32 125.00 180.00 C 125.76 179.78 126.33 176.92 128.00 178.00 C 129.16 185.74 128.27 193.03 119.00 192.00 C 111.10 193.55 103.78 196.54 97.00 201.00 C 95.68 202.11 94.33 203.86 93.00 205.00 C 89.36 208.64 85.70 214.70 81.00 217.00 C 80.60 217.20 80.00 217.00 80.00 217.00 C 71.87 227.29 66.00 240.71 66.00 254.00 C 66.30 257.15 68.35 261.83 66.00 265.00 C 66.00 265.50 66.00 266.00 66.00 266.00 C 66.00 268.65 65.82 271.36 66.00 274.00 C 66.30 275.86 67.57 278.70 68.00 281.00 C 66.64 285.14 72.04 287.41 70.00 291.00 C 75.34 290.12 74.19 281.25 77.25 277.25 C 80.31 273.24 81.90 268.49 84.00 264.00 C 85.86 260.03 88.71 256.70 91.00 253.00 C 92.58 250.44 93.72 248.95 96.00 247.00 C 100.04 243.55 103.70 239.01 108.00 236.00 C 112.06 233.16 116.51 229.58 121.00 227.00 C 123.05 225.42 124.23 223.61 127.00 223.00 C 127.00 223.00 127.53 223.11 128.00 223.00 C 130.54 220.96 132.92 219.99 136.00 219.00 C 150.20 214.45 163.10 212.71 178.00 213.00 C 179.30 213.03 180.71 212.83 182.00 213.00 C 183.36 212.82 185.96 211.09 188.00 212.00 C 190.08 208.91 186.18 207.52 185.00 205.00 C 182.74 203.32 180.57 202.40 179.00 200.00 C 179.00 200.00 178.43 200.17 178.00 200.00 C 175.44 198.99 173.16 197.21 171.00 196.00 C 165.16 193.59 158.79 189.54 152.00 190.00 C 151.50 190.03 151.00 190.00 151.00 190.00 C 150.07 190.62 148.85 179.05 151.00 179.00 C 152.76 178.96 152.85 179.53 154.00 180.00 C 158.22 181.71 162.67 182.77 167.00 184.00 C 169.71 184.77 171.67 185.99 174.00 187.00 C 175.34 187.41 176.68 187.63 178.00 188.00 C 180.29 188.31 182.70 187.77 185.00 188.00 C 185.23 186.17 184.93 184.53 184.00 183.00 C 182.92 180.87 178.12 179.71 180.00 177.00 C 180.00 177.00 180.16 176.44 180.00 176.00 C 176.95 174.02 174.75 170.11 173.00 167.00 C 170.55 162.65 167.81 158.35 165.00 154.00 C 162.79 151.28 160.84 149.11 159.00 146.00 C 154.77 138.87 149.65 127.20 143.00 122.00 C 138.44 119.55 136.91 122.22 134.00 125.00 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ABBCAE",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 127.00 135.00  C 130.12 132.97 132.05 129.14 134.00 126.00 C 131.25 127.79 128.14 131.85 127.00 135.00 Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#AEC1B6",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 121.00 144.00  C 123.19 141.90 125.89 139.07 127.00 136.00 C 124.81 138.10 122.11 140.94 121.00 144.00 Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#8BAA91",
    strokeOpacity: 0.17,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 117.00 150.00  C 118.56 148.27 120.12 147.45 121.00 145.00 C 118.37 146.09 118.56 147.58 117.00 150.00 Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A6B8AE",
    strokeOpacity: 0.08,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 165.00 154.00  C 163.16 151.15 160.93 148.59 159.00 146.00 C 160.84 149.11 162.79 151.28 165.00 154.00 Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BECFC5",
    strokeOpacity: 0.06,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 96.00 180.00  C 100.07 177.35 103.38 170.93 106.00 167.00 C 107.63 164.55 108.49 162.75 111.00 161.00 C 111.00 161.00 110.91 160.48 111.00 160.00 C 105.72 161.10 98.92 175.31 96.00 180.00 Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#2F4E3D",
    strokeOpacity: 0.56,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 106.00 167.00  C 107.75 165.00 109.50 163.41 111.00 161.00 C 108.49 162.75 107.63 164.55 106.00 167.00 Z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#182E47",
    strokeOpacity: 0.96,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 298.00 168.00  C 294.57 170.19 292.71 174.23 290.00 177.00 C 290.00 177.00 290.00 177.50 290.00 178.00 C 290.00 189.33 289.99 200.67 290.00 212.00 C 290.00 212.00 290.02 212.50 290.00 213.00 C 291.98 217.09 295.91 219.77 299.00 223.00 C 299.00 223.00 299.51 222.92 300.00 223.00 C 305.70 223.94 310.33 223.13 316.00 223.00 C 316.00 223.00 316.56 223.16 317.00 223.00 C 317.75 222.28 318.17 221.64 319.00 221.00 C 321.18 218.84 322.52 215.57 325.00 214.00 C 325.22 213.64 325.00 212.50 325.00 212.00 C 325.00 201.00 325.00 190.00 325.00 179.00 C 325.00 178.50 325.00 177.50 325.00 177.00 C 325.00 177.00 325.09 176.48 325.00 176.00 C 323.73 174.02 320.89 170.54 319.00 169.00 C 313.11 164.92 304.39 164.77 298.00 168.00 M 311.00 178.00  C 312.70 177.80 311.62 177.07 313.00 178.00 C 317.96 181.35 315.85 191.11 316.00 196.00 C 316.15 200.89 317.93 212.56 311.00 213.00 C 310.50 213.03 310.00 213.00 310.00 213.00 C 306.86 215.45 302.69 213.45 301.00 210.00 C 300.80 209.60 301.00 209.00 301.00 209.00 C 297.27 207.30 299.03 199.80 299.00 196.00 C 298.97 192.20 298.06 184.47 300.00 181.00 C 300.53 180.05 302.89 178.47 304.00 178.00 C 306.79 176.82 308.57 177.87 311.00 178.00 Z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#CECFD8",
    strokeOpacity: 0.07,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 450.00 167.00  C 454.31 166.52 457.88 167.90 462.00 168.00 C 458.05 165.84 454.18 166.03 450.00 167.00 Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A8BFAE",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 180.00 176.00  C 178.63 172.20 175.18 170.05 173.00 167.00 C 174.75 170.11 176.95 174.02 180.00 176.00 Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C4C6CD",
    strokeOpacity: 0.05,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 244.00 223.00  C 244.00 204.67 244.00 186.33 244.00 168.00 C 247.67 168.00 251.33 168.00 255.00 168.00 C 247.95 161.11 240.26 171.22 243.00 178.00 C 245.74 184.78 240.64 194.99 243.00 201.00 C 245.36 207.01 238.99 219.49 244.00 223.00 Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B5B9C4",
    strokeOpacity: 0.15,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 271.00 168.00  C 272.19 167.62 279.03 167.32 280.00 168.00 C 283.65 170.55 280.06 180.25 281.00 185.00 C 281.94 189.75 280.67 197.51 281.00 203.00 C 281.33 208.49 281.00 216.30 281.00 222.00 C 281.00 222.50 281.00 223.00 281.00 223.00 C 283.33 205.32 281.33 185.50 282.00 167.00 C 279.38 168.05 272.58 165.18 271.00 168.00 Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B2B4BE",
    strokeOpacity: 0.07,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 334.00 223.00  C 333.96 223.00 334.00 222.00 334.00 222.00 C 334.00 204.00 334.00 186.00 334.00 168.00 C 341.33 168.00 348.67 168.00 356.00 168.00 C 353.56 166.19 333.12 163.96 333.00 170.00 C 332.88 176.04 331.94 190.66 333.00 197.00 C 334.06 203.34 329.58 218.74 334.00 223.00 Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#9FA4AD",
    strokeOpacity: 0.08,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 375.00 168.00  C 375.00 167.96 376.00 168.00 376.00 168.00 C 382.33 168.00 388.67 168.00 395.00 168.00 C 391.29 167.34 378.23 164.64 375.00 168.00 Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#888C99",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 418.00 223.00  C 417.96 223.00 418.00 222.00 418.00 222.00 C 418.00 204.58 416.43 186.34 418.00 169.00 C 419.62 167.31 422.67 168.15 425.00 168.00 C 419.06 167.60 415.97 167.78 417.00 175.00 C 418.03 182.22 416.24 185.04 417.00 191.00 C 417.76 196.96 416.00 202.83 417.00 208.00 C 418.00 213.17 414.52 219.65 418.00 223.00 Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#202538",
    strokeOpacity: 0.6,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 425.00 168.00  C 422.67 168.15 419.62 167.31 418.00 169.00 C 418.00 168.96 419.00 169.00 419.00 169.00 C 432.30 169.00 427.42 179.42 428.00 190.00 C 428.58 200.58 427.57 210.49 428.00 221.00 C 424.63 221.40 422.42 221.40 419.00 221.00 C 418.95 221.35 418.12 221.74 418.00 222.00 C 418.00 222.00 417.96 223.00 418.00 223.00 C 419.99 223.18 427.45 224.09 429.00 223.00 C 428.44 217.34 429.75 210.55 429.00 205.00 C 428.25 199.45 430.44 192.14 429.00 187.00 C 427.56 181.86 431.92 172.14 429.00 168.00 C 427.64 166.75 426.51 167.90 425.00 168.00 Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#1B2F47",
    strokeOpacity: 0.92,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 444.00 169.00  C 441.11 170.96 438.52 174.86 437.00 178.00 C 437.00 178.00 437.00 178.50 437.00 179.00 C 437.00 180.00 437.00 181.00 437.00 182.00 C 437.00 191.00 437.00 200.00 437.00 209.00 C 437.00 210.00 436.97 211.00 437.00 212.00 C 437.18 218.08 442.76 221.25 448.00 223.00 C 452.77 224.02 456.25 222.68 461.00 223.00 C 461.00 223.00 461.50 223.05 462.00 223.00 C 465.84 219.92 471.29 216.39 472.00 211.00 C 473.74 203.33 465.63 204.65 461.00 204.00 C 462.55 209.29 456.98 214.76 451.00 213.00 C 447.53 211.98 447.26 207.83 447.00 205.00 C 446.46 199.11 446.51 191.20 447.00 186.00 C 447.27 183.09 447.56 179.13 451.00 178.00 C 451.45 177.85 452.50 178.02 453.00 178.00 C 456.07 176.60 460.38 177.79 461.00 182.00 C 461.16 183.10 460.53 185.01 461.00 186.00 C 463.95 185.00 470.05 187.78 472.00 185.00 C 472.71 182.15 471.95 178.54 471.00 176.00 C 469.54 172.98 465.26 170.36 463.00 168.00 C 463.00 168.00 462.50 168.01 462.00 168.00 C 457.88 167.90 454.31 166.52 450.00 167.00 C 447.31 167.63 446.43 167.75 444.00 169.00 Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#1A2233",
    strokeOpacity: 0.6,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 244.00 223.00  C 245.41 223.99 252.19 223.16 254.00 223.00 C 254.04 223.00 254.00 222.00 254.00 222.00 C 251.02 221.73 247.98 222.20 245.00 222.00 C 245.00 204.33 245.00 186.67 245.00 169.00 C 248.75 168.22 253.77 169.84 256.00 170.00 C 255.67 169.41 255.52 168.50 255.00 168.00 C 251.33 168.00 247.67 168.00 244.00 168.00 C 244.00 186.33 244.00 204.67 244.00 223.00 Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#14192A",
    strokeOpacity: 0.66,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 272.00 169.00  C 274.39 169.34 278.40 169.53 280.00 168.00 C 279.03 167.32 272.19 167.62 271.00 168.00 C 270.90 168.19 271.65 168.95 272.00 169.00 Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#1A304A",
    strokeOpacity: 0.95,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 272.00 169.00  C 271.35 179.51 273.32 191.24 271.00 201.00 C 265.98 190.24 261.91 180.45 256.00 170.00 C 253.77 169.84 248.75 168.22 245.00 169.00 C 245.00 186.67 245.00 204.33 245.00 222.00 C 247.98 222.20 251.02 221.73 254.00 222.00 C 254.00 211.67 254.00 201.33 254.00 191.00 C 254.83 191.41 255.87 191.97 256.00 193.00 C 261.49 200.20 262.38 211.64 268.00 220.00 C 271.23 223.43 276.75 221.62 281.00 222.00 C 281.00 216.30 281.33 208.49 281.00 203.00 C 280.67 197.51 281.94 189.75 281.00 185.00 C 280.06 180.25 283.65 170.55 280.00 168.00 C 278.40 169.53 274.39 169.34 272.00 169.00 Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B8B9C7",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 290.00 177.00  C 292.71 174.23 294.57 170.19 298.00 168.00 C 294.32 169.86 290.91 172.84 290.00 177.00 Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#1C2337",
    strokeOpacity: 0.69,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 334.00 222.00  C 334.25 221.75 335.00 222.00 335.00 222.00 C 336.59 204.48 333.81 186.56 335.00 169.00 C 342.16 168.34 350.66 170.33 357.00 168.00 C 357.00 168.00 356.50 168.00 356.00 168.00 C 348.67 168.00 341.33 168.00 334.00 168.00 C 334.00 186.00 334.00 204.00 334.00 222.00 Z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#193049",
    strokeOpacity: 0.96,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 335.00 222.00  C 337.96 222.00 341.06 221.73 344.00 222.00 C 344.00 215.67 344.00 209.33 344.00 203.00 C 348.25 202.03 351.46 203.73 352.00 208.00 C 353.29 212.08 353.48 216.25 356.00 220.00 C 358.69 222.80 366.61 223.46 368.00 220.00 C 365.99 213.77 363.56 207.94 361.00 202.00 C 363.01 199.98 366.86 197.69 368.00 195.00 C 368.08 194.51 368.18 193.08 368.00 193.00 C 367.85 192.94 368.00 190.25 368.00 190.00 C 368.00 187.33 368.00 184.67 368.00 182.00 C 368.00 181.00 368.02 180.00 368.00 179.00 C 367.97 177.10 367.72 176.37 367.00 175.00 C 367.01 175.01 361.18 170.95 360.00 170.00 C 359.19 169.35 358.67 168.64 358.00 168.00 C 358.00 168.00 357.50 168.00 357.00 168.00 C 350.66 170.33 342.16 168.34 335.00 169.00 C 333.81 186.56 336.59 204.48 335.00 222.00 M 358.00 184.00  C 358.11 185.24 358.14 186.76 358.00 188.00 C 357.75 190.17 356.83 191.83 355.00 193.00 C 352.66 194.90 346.64 196.75 344.00 194.00 C 343.73 191.04 342.62 179.52 345.00 178.00 C 346.00 177.36 350.77 177.81 352.00 178.00 C 355.70 178.58 357.66 180.07 358.00 184.00 Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A5A8B0",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 360.00 170.00  C 361.19 170.71 363.96 171.13 365.00 172.00 C 363.33 170.18 360.53 168.58 358.00 168.00 C 358.67 168.64 359.19 169.35 360.00 170.00 Z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#494E5B",
    strokeOpacity: 0.29,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 376.00 223.00  C 375.96 223.00 376.00 222.00 376.00 222.00 C 376.00 204.33 375.98 186.67 376.00 169.00 C 376.00 168.50 376.00 168.00 376.00 168.00 C 376.00 168.00 375.00 167.96 375.00 168.00 C 374.47 173.83 374.92 181.26 375.00 187.00 C 375.08 192.74 374.27 200.76 375.00 206.00 C 375.73 211.24 372.51 219.64 376.00 223.00 Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#10182B",
    strokeOpacity: 0.71,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 376.00 169.00  C 382.31 169.57 389.52 168.16 395.00 168.00 C 388.67 168.00 382.33 168.00 376.00 168.00 C 376.00 168.00 376.00 168.50 376.00 169.00 Z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#1A2F48",
    strokeOpacity: 0.96,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 376.00 169.00  C 375.98 186.67 376.00 204.33 376.00 222.00 C 382.00 221.46 388.82 222.78 394.00 223.00 C 402.33 222.55 409.66 219.06 410.00 210.00 C 410.05 208.67 410.00 207.33 410.00 206.00 C 410.00 199.42 410.83 191.78 411.00 186.00 C 408.98 174.71 406.76 170.11 395.00 168.00 C 389.52 168.16 382.31 169.57 376.00 169.00 M 393.00 178.00  C 396.28 179.14 397.52 180.04 399.00 183.00 C 399.55 184.10 399.86 184.42 400.00 186.00 C 401.29 191.20 402.08 199.91 400.00 205.00 C 399.86 206.17 399.19 206.32 399.00 207.00 C 399.00 207.50 399.15 208.55 399.00 209.00 C 397.41 213.84 389.97 213.36 386.00 213.00 C 383.27 210.37 384.90 200.05 385.00 196.00 C 385.10 191.95 383.21 180.79 386.00 178.00 C 387.99 175.93 391.05 177.32 393.00 178.00 Z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 429.00 223.00  C 432.36 220.65 429.47 209.44 430.00 205.00 C 430.53 200.56 430.46 190.59 430.00 186.00 C 429.54 181.41 432.24 170.97 429.00 168.00 C 431.92 172.14 427.56 181.86 429.00 187.00 C 430.44 192.14 428.25 199.45 429.00 205.00 C 429.75 210.55 428.44 217.34 429.00 223.00 Z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C2CCD6",
    strokeOpacity: 0.04,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 471.00 176.00  C 469.71 172.56 466.51 169.27 463.00 168.00 C 465.26 170.36 469.54 172.98 471.00 176.00 Z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BDBFD0",
    strokeOpacity: 0.05,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 176.00  C 324.42 173.03 321.48 170.72 319.00 169.00 C 320.89 170.54 323.73 174.02 325.00 176.00 Z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0E162C",
    strokeOpacity: 0.89,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 418.00 222.00  C 418.12 221.74 418.95 221.35 419.00 221.00 C 421.27 205.25 420.43 184.87 419.00 169.00 C 419.00 169.00 418.00 168.96 418.00 169.00 C 416.43 186.34 418.00 204.58 418.00 222.00 Z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#152E49",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 419.00 221.00  C 422.42 221.40 424.63 221.40 428.00 221.00 C 427.57 210.49 428.58 200.58 428.00 190.00 C 427.42 179.42 432.30 169.00 419.00 169.00 C 420.43 184.87 421.27 205.25 419.00 221.00 Z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C8CCDC",
    strokeOpacity: 0.07,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 437.00 178.00  C 438.52 174.86 441.11 170.96 444.00 169.00 C 440.38 170.87 437.33 173.52 437.00 178.00 Z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#3D4352",
    strokeOpacity: 0.48,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 367.00 175.00  C 366.49 174.04 365.76 172.82 365.00 172.00 C 363.96 171.13 361.19 170.71 360.00 170.00 C 361.18 170.95 367.01 175.01 367.00 175.00 Z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#627D6D",
    strokeOpacity: 0.35,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 184.00 183.00  C 182.79 180.36 182.70 178.76 180.00 177.00 C 178.12 179.71 182.92 180.87 184.00 183.00 Z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C4C3CB",
    strokeOpacity: 0.08,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 304.00 178.00  C 306.16 177.46 308.78 178.26 311.00 178.00 C 308.57 177.87 306.79 176.82 304.00 178.00 Z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 311.00 178.00  C 308.78 178.26 306.16 177.46 304.00 178.00 C 302.89 178.47 300.53 180.05 300.00 181.00 C 298.89 183.41 300.49 189.91 300.00 194.00 C 299.51 198.09 299.61 205.09 301.00 209.00 C 301.00 209.00 300.80 209.60 301.00 210.00 C 303.52 212.68 306.32 213.40 310.00 213.00 C 310.00 213.00 310.50 213.03 311.00 213.00 C 315.55 209.00 315.59 201.89 315.00 196.00 C 314.41 190.11 316.44 181.14 313.00 178.00 C 311.62 177.07 312.70 177.80 311.00 178.00 Z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B3B4BA",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 179.00  C 325.69 180.63 326.78 184.38 327.00 186.00 C 327.02 182.89 327.63 179.01 325.00 177.00 C 325.00 177.50 325.00 178.50 325.00 179.00 Z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#323644",
    strokeOpacity: 0.5,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 386.00 178.00  C 386.00 177.96 387.00 178.00 387.00 178.00 C 388.91 178.00 391.13 177.68 393.00 178.00 C 391.05 177.32 387.99 175.93 386.00 178.00 Z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#979CA5",
    strokeOpacity: 0.17,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 453.00 178.00  C 455.77 177.89 460.21 178.97 461.00 182.00 C 460.38 177.79 456.07 176.60 453.00 178.00 Z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#889E8F",
    strokeOpacity: 0.14,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 125.00 180.00  C 129.15 178.51 126.04 187.27 127.00 190.00 C 123.77 188.61 121.27 191.26 119.00 192.00 C 128.27 193.03 129.16 185.74 128.00 178.00 C 126.33 176.92 125.76 179.78 125.00 180.00 Z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#1F4B38",
    strokeOpacity: 0.8,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 151.00 190.00  C 150.70 186.69 152.03 182.14 151.00 179.00 C 148.85 179.05 150.07 190.62 151.00 190.00 Z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#32344A",
    strokeOpacity: 0.6,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 289.00 181.00  C 288.23 190.00 287.90 201.04 289.00 210.00 C 289.16 211.32 289.42 211.13 290.00 212.00 C 289.99 200.67 290.00 189.33 290.00 178.00 C 288.93 179.15 289.15 179.30 289.00 181.00 Z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#7B7C87",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 311.00 213.00  C 317.93 212.56 316.15 200.89 316.00 196.00 C 315.85 191.11 317.96 181.35 313.00 178.00 C 316.44 181.14 314.41 190.11 315.00 196.00 C 315.59 201.89 315.55 209.00 311.00 213.00 Z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#7B8190",
    strokeOpacity: 0.29,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 344.00 194.00  C 344.00 194.05 345.00 194.00 345.00 194.00 C 345.48 188.71 344.64 183.30 345.00 178.00 C 342.62 179.52 343.73 191.04 344.00 194.00 Z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 345.00 194.00  C 347.48 194.00 350.58 194.51 353.00 194.00 C 352.92 193.90 357.83 188.76 358.00 188.00 C 358.14 186.76 358.11 185.24 358.00 184.00 C 357.48 181.75 354.05 178.50 352.00 178.00 C 350.77 177.81 346.00 177.36 345.00 178.00 C 344.64 183.30 345.48 188.71 345.00 194.00 Z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A4B1BA",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 358.00 184.00  C 357.66 180.07 355.70 178.58 352.00 178.00 C 354.05 178.50 357.48 181.75 358.00 184.00 Z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#1E263B",
    strokeOpacity: 0.68,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 386.00 213.00  C 385.96 213.00 386.00 212.00 386.00 212.00 C 386.00 200.82 385.00 189.13 386.00 178.00 C 383.21 180.79 385.10 191.95 385.00 196.00 C 384.90 200.05 383.27 210.37 386.00 213.00 Z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#D7D8EA",
    strokeOpacity: 0.05,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 386.00 212.00  C 386.25 211.75 387.00 212.00 387.00 212.00 C 387.97 201.28 387.97 188.72 387.00 178.00 C 387.00 178.00 386.00 177.96 386.00 178.00 C 385.00 189.13 386.00 200.82 386.00 212.00 Z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 387.00 212.00  C 391.44 212.00 396.18 212.14 399.00 209.00 C 399.15 208.55 399.00 207.50 399.00 207.00 C 399.00 199.84 400.84 189.88 399.00 183.00 C 397.52 180.04 396.28 179.14 393.00 178.00 C 391.13 177.68 388.91 178.00 387.00 178.00 C 387.97 188.72 387.97 201.28 387.00 212.00 Z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A3A8B2",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 447.00 186.00  C 447.30 184.33 449.11 179.29 451.00 178.00 C 447.56 179.13 447.27 183.09 447.00 186.00 Z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BCD6CB",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 151.00 190.00  C 151.00 190.00 151.50 190.03 152.00 190.00 C 152.31 186.52 150.53 181.24 154.00 180.00 C 152.85 179.53 152.76 178.96 151.00 179.00 C 152.03 182.14 150.70 186.69 151.00 190.00 Z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#172035",
    strokeOpacity: 0.75,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 212.00  C 327.40 206.36 326.19 195.96 327.00 190.00 C 327.00 188.67 326.99 187.33 327.00 186.00 C 326.78 184.38 325.69 180.63 325.00 179.00 C 325.00 190.00 325.00 201.00 325.00 212.00 Z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B3B3B7",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 368.00 182.00  C 368.66 185.01 368.65 187.05 368.00 190.00 C 368.00 190.25 367.85 192.94 368.00 193.00 C 370.63 187.51 369.35 184.41 368.00 179.00 C 368.02 180.00 368.00 181.00 368.00 182.00 Z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BEBFCA",
    strokeOpacity: 0.08,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 437.00 212.00  C 436.97 211.00 437.00 210.00 437.00 209.00 C 435.28 201.15 435.29 189.78 437.00 182.00 C 437.00 181.00 437.00 180.00 437.00 179.00 C 431.81 185.38 434.46 205.04 437.00 212.00 Z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BDCFC5",
    strokeOpacity: 0.05,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 95.00 189.00  C 92.46 187.31 94.91 182.73 96.00 181.00 C 93.47 182.58 91.22 187.31 95.00 189.00 Z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C4C1D2",
    strokeOpacity: 0.07,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 289.00 210.00  C 287.90 201.04 288.23 190.00 289.00 181.00 C 287.24 188.09 286.15 203.00 289.00 210.00 Z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#616773",
    strokeOpacity: 0.42,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 301.00 209.00  C 299.61 205.09 299.51 198.09 300.00 194.00 C 300.49 189.91 298.89 183.41 300.00 181.00 C 298.06 184.47 298.97 192.20 299.00 196.00 C 299.03 199.80 297.27 207.30 301.00 209.00 Z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#1E202E",
    strokeOpacity: 0.44,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 368.00 190.00  C 368.65 187.05 368.66 185.01 368.00 182.00 C 368.00 184.67 368.00 187.33 368.00 190.00 Z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#232A3D",
    strokeOpacity: 0.58,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 437.00 209.00  C 437.00 200.00 437.00 191.00 437.00 182.00 C 435.29 189.78 435.28 201.15 437.00 209.00 Z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#91A59A",
    strokeOpacity: 0.15,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 178.00 188.00  C 184.07 189.71 186.67 188.84 184.00 183.00 C 184.93 184.53 185.23 186.17 185.00 188.00 C 182.70 187.77 180.29 188.31 178.00 188.00 Z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#AEACB7",
    strokeOpacity: 0.15,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 399.00 207.00  C 399.19 206.32 399.86 206.17 400.00 205.00 C 400.72 199.13 400.51 191.90 400.00 186.00 C 399.86 184.42 399.55 184.10 399.00 183.00 C 400.84 189.88 399.00 199.84 399.00 207.00 Z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ACB9AF",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 174.00 187.00  C 171.67 185.99 169.71 184.77 167.00 184.00 C 169.10 184.82 171.57 186.25 174.00 187.00 Z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B0B0B9",
    strokeOpacity: 0.03,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 461.00 186.00  C 462.66 189.49 471.64 186.44 472.00 185.00 C 470.05 187.78 463.95 185.00 461.00 186.00 Z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0C0F25",
    strokeOpacity: 0.77,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 400.00 205.00  C 402.08 199.91 401.29 191.20 400.00 186.00 C 400.51 191.90 400.72 199.13 400.00 205.00 Z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#101220",
    strokeOpacity: 0.57,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 410.00 206.00  C 410.52 202.19 411.00 197.47 411.00 193.00 C 411.00 190.67 411.00 188.33 411.00 186.00 C 410.83 191.78 410.00 199.42 410.00 206.00 Z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C1C1C1",
    strokeOpacity: 0.01,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 411.00 193.00  C 411.01 193.07 412.00 193.00 412.00 193.00 C 411.95 190.43 411.35 187.96 411.00 186.00 C 411.00 188.33 411.00 190.67 411.00 193.00 Z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#9FA9B7",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 353.00 194.00  C 353.45 193.91 354.63 193.23 355.00 193.00 C 356.83 191.83 357.75 190.17 358.00 188.00 C 357.83 188.76 352.92 193.90 353.00 194.00 Z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B3B6C4",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 212.00  C 325.00 212.50 325.22 213.64 325.00 214.00 C 329.54 210.52 327.00 195.54 327.00 190.00 C 326.19 195.96 327.40 206.36 325.00 212.00 Z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#6C6D7E",
    strokeOpacity: 0.29,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 254.00 222.00  C 254.00 222.00 254.04 223.00 254.00 223.00 C 256.41 220.68 255.37 211.77 255.00 208.00 C 254.63 204.23 256.51 195.94 256.00 193.00 C 255.87 191.97 254.83 191.41 254.00 191.00 C 254.00 201.33 254.00 211.67 254.00 222.00 Z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#2B3445",
    strokeOpacity: 0.6,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 353.00 194.00  C 350.58 194.51 347.48 194.00 345.00 194.00 C 345.00 194.00 344.00 194.05 344.00 194.00 C 346.64 196.75 352.66 194.90 355.00 193.00 C 354.63 193.23 353.45 193.91 353.00 194.00 Z"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#9A9BB6",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 410.00 206.00  C 410.00 207.33 410.05 208.67 410.00 210.00 C 411.55 204.62 412.13 199.31 412.00 193.00 C 412.00 193.00 411.01 193.07 411.00 193.00 C 411.00 197.47 410.52 202.19 410.00 206.00 Z"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BFC2CF",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 361.00 202.00  C 363.88 201.34 367.51 198.04 368.00 195.00 C 366.86 197.69 363.01 199.98 361.00 202.00 Z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#AAC1AE",
    strokeOpacity: 0.06,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 178.00 200.00  C 176.37 197.40 173.60 197.07 171.00 196.00 C 173.16 197.21 175.44 198.99 178.00 200.00 Z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A6B0AF",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 185.00 205.00  C 187.36 206.75 189.03 209.03 191.00 211.00 C 196.31 216.31 199.85 221.04 204.00 227.00 C 199.90 217.79 190.41 204.12 179.00 200.00 C 180.57 202.40 182.74 203.32 185.00 205.00 Z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A8B8AF",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 80.00 217.00  C 80.00 217.00 80.60 217.20 81.00 217.00 C 84.15 212.49 88.90 208.50 93.00 205.00 C 94.33 203.86 95.68 202.11 97.00 201.00 C 90.30 205.41 84.99 210.68 80.00 217.00 Z"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#747886",
    strokeOpacity: 0.3,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 344.00 222.00  C 344.00 222.50 344.00 223.00 344.00 223.00 C 346.32 217.66 344.34 210.16 345.00 204.00 C 348.41 203.06 350.85 205.44 352.00 208.00 C 351.46 203.73 348.25 202.03 344.00 203.00 C 344.00 209.33 344.00 215.67 344.00 222.00 Z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#274C37",
    strokeOpacity: 0.64,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 81.00 217.00  C 85.70 214.70 89.36 208.64 93.00 205.00 C 88.90 208.50 84.15 212.49 81.00 217.00 Z"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#274E49",
    strokeOpacity: 0.82,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 182.00 213.00  C 183.08 213.14 183.99 213.96 185.00 214.00 C 186.07 213.60 190.61 212.57 191.00 211.00 C 189.03 209.03 187.36 206.75 185.00 205.00 C 186.18 207.52 190.08 208.91 188.00 212.00 C 185.96 211.09 183.36 212.82 182.00 213.00 Z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B6B8CA",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 451.00 213.00  C 449.28 212.30 447.20 206.25 447.00 205.00 C 447.26 207.83 447.53 211.98 451.00 213.00 Z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#999FAD",
    strokeOpacity: 0.25,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 387.00 212.00  C 387.00 212.00 386.25 211.75 386.00 212.00 C 386.00 212.00 385.96 213.00 386.00 213.00 C 389.97 213.36 397.41 213.84 399.00 209.00 C 396.18 212.14 391.44 212.00 387.00 212.00 Z"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C7C8CB",
    strokeOpacity: 0.06,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 310.00 213.00  C 306.32 213.40 303.52 212.68 301.00 210.00 C 302.69 213.45 306.86 215.45 310.00 213.00 Z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#18334C",
    strokeOpacity: 0.96,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 185.00 214.00  C 182.81 214.82 174.94 214.73 170.00 215.00 C 160.77 215.50 150.93 217.58 143.00 222.00 C 138.85 224.31 134.42 226.79 130.00 229.00 C 124.92 231.54 118.00 234.97 115.00 240.00 C 114.81 240.32 114.32 240.80 114.00 241.00 C 110.79 245.12 106.59 248.41 103.00 252.00 C 98.62 257.13 95.68 263.51 91.00 268.00 C 91.00 268.00 91.17 268.57 91.00 269.00 C 89.47 272.91 86.76 276.52 85.00 280.00 C 83.19 284.91 81.72 289.77 81.00 294.00 C 80.70 295.74 80.61 297.33 80.00 299.00 C 78.58 302.86 77.67 302.58 80.00 307.00 C 84.51 313.44 92.54 317.61 97.00 324.00 C 97.00 324.00 97.56 323.84 98.00 324.00 C 101.46 325.25 104.06 328.36 107.00 330.00 C 111.46 331.99 115.13 333.02 120.00 334.00 C 121.62 334.33 123.81 335.78 125.00 336.00 C 126.95 336.21 129.04 336.00 131.00 336.00 C 136.00 336.00 141.00 336.00 146.00 336.00 C 148.28 336.00 150.74 336.26 153.00 336.00 C 154.29 335.75 156.29 334.34 158.00 334.00 C 164.29 332.74 169.93 330.86 175.00 328.00 C 175.90 327.32 176.21 325.29 178.00 326.00 C 178.05 323.60 176.03 321.96 175.00 320.00 C 171.26 315.75 167.96 307.94 164.92 303.08 C 161.88 298.22 160.20 286.46 157.00 288.00 C 156.11 286.59 158.06 285.09 158.00 284.00 C 156.47 276.21 155.72 268.06 157.00 260.00 C 157.08 258.07 157.72 255.38 158.00 254.00 C 158.60 251.08 159.20 249.25 161.00 247.00 C 161.00 247.00 160.89 246.47 161.00 246.00 C 161.61 243.40 162.64 240.47 165.00 239.00 C 165.00 239.00 164.84 238.44 165.00 238.00 C 165.68 236.10 167.46 233.28 169.00 232.00 C 171.37 227.95 174.76 224.56 180.00 223.00 C 181.98 222.41 184.13 221.79 186.00 221.00 C 187.04 219.57 187.90 218.50 190.00 219.00 C 189.02 221.01 186.64 221.64 185.00 223.00 C 185.00 223.00 184.40 222.80 184.00 223.00 C 182.05 225.79 179.22 227.66 177.00 230.00 C 175.67 231.64 174.27 233.22 173.00 235.00 C 171.30 238.14 169.61 241.95 168.00 245.00 C 166.51 249.15 166.00 252.35 166.00 257.00 C 166.00 261.67 166.00 266.33 166.00 271.00 C 166.00 272.96 165.80 275.05 166.00 277.00 C 166.72 280.49 168.97 285.03 170.00 289.00 C 170.58 291.22 171.07 292.96 172.00 295.00 C 173.76 297.91 176.06 300.88 178.00 304.00 C 178.00 304.00 177.84 304.56 178.00 305.00 C 181.36 307.19 184.86 312.54 187.00 316.00 C 187.20 316.32 187.69 316.80 188.00 317.00 C 190.94 316.38 196.98 309.18 199.00 307.00 C 201.86 303.07 203.90 299.20 206.00 295.00 C 207.18 291.80 208.58 288.88 210.00 286.00 C 211.38 282.18 212.02 279.29 212.00 275.00 C 211.99 273.67 212.00 272.33 212.00 271.00 C 212.00 264.67 212.00 258.33 212.00 252.00 C 212.00 250.67 212.00 249.33 212.00 248.00 C 212.00 247.01 212.05 245.99 212.00 245.00 C 211.32 242.00 208.93 238.33 208.00 235.00 C 206.82 230.77 205.67 229.40 204.00 227.00 C 199.85 221.04 196.31 216.31 191.00 211.00 C 190.61 212.57 186.07 213.60 185.00 214.00 M 161.00 226.00  C 159.75 227.83 150.91 236.41 149.00 232.00 C 146.81 230.80 153.00 227.52 154.00 227.00 C 155.23 226.36 156.68 225.73 158.00 225.00 C 160.74 223.48 163.51 222.34 161.00 226.00 M 144.00 241.00  C 142.92 244.08 139.95 245.76 138.00 248.00 C 136.35 250.56 135.50 253.61 134.00 256.00 C 131.71 259.66 128.82 259.36 124.00 259.00 C 124.95 258.13 124.54 256.32 126.00 256.00 C 126.79 254.89 127.26 254.15 128.00 253.00 C 130.16 249.65 132.09 246.61 135.00 244.00 C 136.81 242.37 141.18 237.81 144.00 241.00 M 126.00 280.00  C 125.93 282.33 126.00 284.67 126.00 287.00 C 126.00 292.17 128.21 303.44 126.00 308.00 C 124.84 310.40 117.19 311.27 114.00 310.00 C 113.01 309.60 113.12 308.97 113.00 308.00 C 111.56 304.47 111.59 299.47 113.00 296.00 C 113.12 294.99 113.89 294.52 114.00 294.00 C 114.14 286.95 115.91 280.51 118.00 274.00 C 121.03 274.26 124.37 273.26 127.00 275.00 C 125.79 276.40 126.02 278.26 126.00 280.00 Z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ACAFBA",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 462.00 223.00  C 467.37 222.50 471.76 215.96 472.00 211.00 C 471.29 216.39 465.84 219.92 462.00 223.00 Z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#9EABB4",
    strokeOpacity: 0.16,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 170.00 215.00  C 174.94 214.73 182.81 214.82 185.00 214.00 C 183.99 213.96 183.08 213.14 182.00 213.00 C 180.71 212.83 179.30 213.03 178.00 213.00 C 176.08 213.26 171.98 214.68 170.00 215.00 Z"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ABADB5",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 299.00 223.00  C 295.91 219.77 291.98 217.09 290.00 213.00 C 289.85 217.35 295.10 222.14 299.00 223.00 Z"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#313947",
    strokeOpacity: 0.53,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 319.00 221.00  C 321.24 219.29 323.60 217.19 325.00 215.00 C 325.00 215.00 324.76 214.18 325.00 214.00 C 322.52 215.57 321.18 218.84 319.00 221.00 Z"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B1B9C2",
    strokeOpacity: 0.08,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 319.00 221.00  C 318.17 221.64 317.75 222.28 317.00 223.00 C 320.16 221.86 324.34 218.40 325.00 215.00 C 323.60 217.19 321.24 219.29 319.00 221.00 Z"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#AAC3AF",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 128.00 223.00  C 131.13 222.27 133.35 220.23 136.00 219.00 C 132.92 219.99 130.54 220.96 128.00 223.00 Z"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#9DA1B9",
    strokeOpacity: 0.19,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 186.00 221.00  C 185.73 221.38 185.49 222.76 185.00 223.00 C 186.64 221.64 189.02 221.01 190.00 219.00 C 187.90 218.50 187.04 219.57 186.00 221.00 Z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#666775",
    strokeOpacity: 0.21,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 281.00 223.00  C 281.00 223.00 281.00 222.50 281.00 222.00 C 276.75 221.62 271.23 223.43 268.00 220.00 C 270.76 224.10 275.82 223.47 281.00 223.00 Z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#60636F",
    strokeOpacity: 0.35,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 368.00 220.00  C 366.61 223.46 358.69 222.80 356.00 220.00 C 357.20 226.19 366.33 221.28 370.00 223.00 C 371.05 221.31 368.25 220.78 368.00 220.00 Z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A3A6B2",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 130.00 229.00  C 134.42 226.79 138.85 224.31 143.00 222.00 C 138.22 223.97 134.20 226.37 130.00 229.00 Z"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#504F61",
    strokeOpacity: 0.36,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 334.00 223.00  C 337.15 223.29 340.85 223.28 344.00 223.00 C 344.00 223.00 344.00 222.50 344.00 222.00 C 341.06 221.73 337.96 222.00 335.00 222.00 C 335.00 222.00 334.25 221.75 334.00 222.00 C 334.00 222.00 333.96 223.00 334.00 223.00 Z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#2F364A",
    strokeOpacity: 0.53,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 376.00 223.00  C 381.78 223.52 388.21 223.31 394.00 223.00 C 388.82 222.78 382.00 221.46 376.00 222.00 C 376.00 222.00 375.96 223.00 376.00 223.00 Z"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#8CAB98",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 121.00 227.00  C 123.21 225.73 125.59 225.25 127.00 223.00 C 124.23 223.61 123.05 225.42 121.00 227.00 Z"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#8B97A3",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 158.00 225.00  C 160.06 223.10 157.14 228.13 156.00 229.00 C 157.36 228.17 160.01 227.08 161.00 226.00 C 163.51 222.34 160.74 223.48 158.00 225.00 Z"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#485064",
    strokeOpacity: 0.46,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 169.00 232.00  C 169.55 231.54 170.48 231.40 171.00 231.00 C 173.82 228.81 176.71 224.95 180.00 223.00 C 174.76 224.56 171.37 227.95 169.00 232.00 Z"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B4B9C9",
    strokeOpacity: 0.04,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 177.00 230.00  C 179.22 227.66 182.05 225.79 184.00 223.00 C 181.21 224.36 178.93 227.63 177.00 230.00 Z"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B1B4BE",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 316.00 223.00  C 310.33 223.13 305.70 223.94 300.00 223.00 C 304.11 226.34 311.73 225.33 316.00 223.00 Z"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#9A9CA7",
    strokeOpacity: 0.18,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 461.00 223.00  C 456.25 222.68 452.77 224.02 448.00 223.00 C 452.68 224.56 456.28 225.06 461.00 223.00 Z"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 154.00 227.00  C 151.41 228.70 151.21 229.73 151.00 232.00 C 152.62 231.23 154.61 229.84 156.00 229.00 C 157.14 228.13 160.06 223.10 158.00 225.00 C 156.68 225.73 155.23 226.36 154.00 227.00 Z"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#364051",
    strokeOpacity: 0.48,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 156.00 229.00  C 154.61 229.84 152.62 231.23 151.00 232.00 C 150.59 232.19 149.08 232.18 149.00 232.00 C 150.91 236.41 159.75 227.83 161.00 226.00 C 160.01 227.08 157.36 228.17 156.00 229.00 Z"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#AEB1C2",
    strokeOpacity: 0.07,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 149.00 232.00  C 149.08 232.18 150.59 232.19 151.00 232.00 C 151.21 229.73 151.41 228.70 154.00 227.00 C 153.00 227.52 146.81 230.80 149.00 232.00 Z"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A5A7B5",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 169.00 232.00  C 167.46 233.28 165.68 236.10 165.00 238.00 C 167.70 236.24 168.89 233.42 171.00 231.00 C 170.48 231.40 169.55 231.54 169.00 232.00 Z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#6A707C",
    strokeOpacity: 0.24,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 303.00 235.00  C 308.56 233.03 316.39 233.55 322.00 235.00 C 317.94 233.37 306.68 230.20 303.00 235.00 Z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#193048",
    strokeOpacity: 0.95,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 303.00 235.00  C 303.00 235.00 302.48 234.90 302.00 235.00 C 299.71 236.46 295.73 239.80 294.00 242.00 C 292.92 243.97 292.13 244.60 292.00 247.00 C 291.94 247.99 292.00 249.01 292.00 250.00 C 292.00 260.00 292.00 270.00 292.00 280.00 C 292.00 281.00 292.00 282.00 292.00 283.00 C 292.00 283.00 291.90 283.52 292.00 284.00 C 295.18 287.25 297.75 292.83 302.00 295.00 C 303.87 295.74 304.93 295.85 307.00 296.00 C 310.53 296.26 314.47 296.26 318.00 296.00 C 320.05 295.85 321.16 295.71 323.00 295.00 C 324.40 294.29 326.54 292.07 328.00 291.00 C 331.70 288.30 332.88 285.82 334.00 281.00 C 335.04 271.68 335.67 258.21 334.00 249.00 C 332.32 244.26 330.24 237.14 322.00 235.00 C 316.39 233.55 308.56 233.03 303.00 235.00 M 318.00 247.00  C 321.33 248.56 321.64 250.78 322.00 254.00 C 322.76 260.83 322.62 269.15 322.00 276.00 C 321.75 278.72 321.44 283.12 318.00 284.00 C 317.13 284.22 315.90 283.98 315.00 284.00 C 309.97 285.10 306.15 284.97 304.00 279.00 C 303.84 278.56 304.00 278.00 304.00 278.00 C 300.85 273.75 302.27 256.57 304.00 252.00 C 306.34 245.82 312.58 244.46 318.00 247.00 Z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#AEB8C1",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 168.00 245.00  C 169.61 241.95 171.30 238.14 173.00 235.00 C 170.86 237.99 169.29 241.43 168.00 245.00 Z"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A09EA8",
    strokeOpacity: 0.14,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 212.00 245.00  C 211.79 241.00 209.25 238.08 208.00 235.00 C 208.93 238.33 211.32 242.00 212.00 245.00 Z"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#CBCCCD",
    strokeOpacity: 0.04,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 244.00 294.00  C 242.66 284.68 244.19 274.44 244.00 265.00 C 243.81 255.56 243.15 245.41 244.00 236.00 C 244.06 236.04 242.08 249.28 243.00 254.00 C 243.92 258.72 242.03 269.69 243.00 275.00 C 243.97 280.31 240.83 289.69 244.00 294.00 Z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#383D4B",
    strokeOpacity: 0.51,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 245.00 236.00  C 252.25 236.80 260.54 235.38 267.00 235.00 C 261.64 234.80 249.07 232.99 245.00 236.00 Z"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#193049",
    strokeOpacity: 0.95,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 245.00 236.00  C 245.96 246.59 244.13 259.62 245.00 270.00 C 245.87 280.38 239.90 298.00 256.00 294.00 C 255.40 287.39 256.45 280.63 256.00 274.00 C 259.84 273.64 263.55 273.48 264.00 278.00 C 264.91 280.18 265.02 282.77 266.00 285.00 C 267.16 286.76 267.74 286.78 268.00 288.00 C 268.34 289.56 267.99 290.62 269.00 292.00 C 269.18 292.25 270.81 293.85 271.00 294.00 C 273.47 295.13 283.09 295.05 282.00 291.00 C 283.39 291.26 282.78 293.05 283.00 294.00 C 284.84 291.63 281.48 286.65 280.00 284.00 C 278.57 281.43 277.19 278.90 276.00 276.00 C 276.00 276.00 275.98 275.50 276.00 275.00 C 273.34 271.58 280.27 268.70 282.00 266.00 C 282.00 266.00 281.84 265.44 282.00 265.00 C 282.67 263.11 283.78 259.56 284.00 258.00 C 284.28 252.78 284.09 248.57 282.00 244.00 C 281.78 243.75 281.00 244.00 281.00 244.00 C 279.36 242.18 276.00 239.39 275.00 237.00 C 272.71 234.67 270.07 235.12 267.00 235.00 C 260.54 235.38 252.25 236.80 245.00 236.00 M 265.00 263.00  C 262.48 263.85 259.17 264.43 256.00 264.00 C 256.66 258.17 254.68 251.01 257.00 246.00 C 266.56 239.31 278.54 258.43 265.00 263.00 Z"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A4A6AD",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 294.00 242.00  C 295.73 239.80 299.71 236.46 302.00 235.00 C 297.98 235.88 295.79 238.71 294.00 242.00 Z"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#737D85",
    strokeOpacity: 0.36,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 343.00 281.00  C 343.00 266.00 343.00 251.00 343.00 236.00 C 343.00 235.50 343.00 235.00 343.00 235.00 C 339.10 238.75 342.65 252.21 342.00 258.00 C 341.35 263.79 340.83 275.88 343.00 281.00 Z"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#3E4554",
    strokeOpacity: 0.57,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 343.00 236.00  C 346.64 236.33 350.36 235.75 354.00 236.00 C 354.42 244.18 353.44 253.99 354.00 262.00 C 354.56 270.01 351.04 279.46 359.00 284.00 C 350.59 269.93 357.01 251.10 355.00 235.00 C 351.02 235.27 346.97 234.64 343.00 235.00 C 343.00 235.00 343.00 235.50 343.00 236.00 Z"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C7CAD2",
    strokeOpacity: 0.15,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 371.00 278.00  C 371.02 277.90 372.00 278.00 372.00 278.00 C 373.26 264.11 370.74 249.89 372.00 236.00 C 372.11 236.07 370.22 251.15 371.00 256.00 C 371.78 260.85 370.50 272.52 371.00 278.00 Z"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#28323F",
    strokeOpacity: 0.67,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 373.00 236.00  C 376.33 236.00 379.67 236.00 383.00 236.00 C 383.50 236.00 384.00 236.00 384.00 236.00 C 384.00 235.50 384.00 235.00 384.00 235.00 C 380.84 234.71 375.35 234.26 373.00 236.00 Z"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B3B5BA",
    strokeOpacity: 0.07,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 384.00 236.00  C 384.00 250.31 385.72 265.81 384.00 280.00 C 383.82 281.47 383.45 283.56 383.00 285.00 C 385.70 279.29 386.16 266.59 385.00 260.00 C 383.84 253.41 388.51 239.34 384.00 235.00 C 384.00 235.00 384.00 235.50 384.00 236.00 Z"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#303644",
    strokeOpacity: 0.62,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 391.00 246.00  C 390.76 245.82 391.00 245.00 391.00 245.00 C 391.00 242.00 391.00 239.00 391.00 236.00 C 403.33 236.00 415.67 236.00 428.00 236.00 C 428.00 239.00 428.00 242.00 428.00 245.00 C 428.00 245.50 428.00 246.00 428.00 246.00 C 428.00 246.00 428.74 246.25 429.00 246.00 C 429.16 244.19 429.99 237.41 429.00 236.00 C 416.99 233.67 402.83 235.67 390.00 235.00 C 390.81 238.24 388.50 243.60 391.00 246.00 Z"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#414758",
    strokeOpacity: 0.47,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 439.00 295.00  C 437.55 294.78 436.84 295.39 436.00 294.00 C 433.12 289.26 437.26 280.77 436.00 275.00 C 434.74 269.23 436.66 261.20 436.00 255.00 C 435.34 248.80 436.49 241.32 436.00 235.00 C 431.71 238.00 436.26 251.41 435.00 257.00 C 433.74 262.59 435.38 272.60 435.00 279.00 C 434.62 285.40 433.07 294.52 439.00 295.00 Z"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#172D46",
    strokeOpacity: 0.97,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 436.00 294.00  C 446.70 295.12 459.17 292.06 469.00 295.00 C 469.35 294.96 469.95 294.35 470.00 294.00 C 469.16 291.19 468.56 287.47 469.00 284.00 C 461.83 283.34 453.34 285.33 447.00 283.00 C 445.81 281.31 446.78 272.11 448.00 271.00 C 452.10 267.28 462.67 273.30 466.00 270.00 C 467.10 268.38 466.00 262.05 466.00 260.00 C 462.04 260.36 449.55 261.66 447.00 259.00 C 446.75 256.28 445.84 247.52 448.00 246.00 C 455.33 246.00 462.67 246.00 470.00 246.00 C 470.00 242.33 470.00 238.67 470.00 235.00 C 465.06 236.04 457.69 233.61 453.00 235.00 C 448.31 236.39 439.80 232.34 436.00 235.00 C 436.49 241.32 435.34 248.80 436.00 255.00 C 436.66 261.20 434.74 269.23 436.00 275.00 C 437.26 280.77 433.12 289.26 436.00 294.00 Z"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A7C7AE",
    strokeOpacity: 0.06,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 96.00 247.00  C 95.58 247.45 95.11 248.40 95.00 249.00 C 99.97 245.52 103.37 239.80 108.00 236.00 C 103.70 239.01 100.04 243.55 96.00 247.00 Z"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#171F31",
    strokeOpacity: 0.54,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 244.00 294.00  C 244.22 294.30 244.70 294.78 245.00 295.00 C 248.09 295.44 253.76 295.66 256.00 294.00 C 239.90 298.00 245.87 280.38 245.00 270.00 C 244.13 259.62 245.96 246.59 245.00 236.00 C 245.00 236.00 244.35 236.23 244.00 236.00 C 243.15 245.41 243.81 255.56 244.00 265.00 C 244.19 274.44 242.66 284.68 244.00 294.00 Z"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#183049",
    strokeOpacity: 0.96,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 343.00 281.00  C 343.00 281.50 342.96 282.50 343.00 283.00 C 343.89 285.69 346.80 289.80 349.00 292.00 C 360.18 300.83 377.34 296.96 383.00 285.00 C 383.45 283.56 383.82 281.47 384.00 280.00 C 384.33 266.30 381.69 250.47 383.00 236.00 C 379.67 236.00 376.33 236.00 373.00 236.00 C 373.42 240.61 372.76 246.49 373.00 251.00 C 373.24 255.51 372.77 262.98 373.00 267.00 C 373.23 271.02 373.04 280.78 372.00 278.00 C 372.00 278.00 371.02 277.90 371.00 278.00 C 370.49 280.53 369.48 282.75 367.00 284.00 C 364.79 285.12 362.18 285.61 360.00 284.00 C 360.00 284.00 359.40 284.20 359.00 284.00 C 351.04 279.46 354.56 270.01 354.00 262.00 C 353.44 253.99 354.42 244.18 354.00 236.00 C 350.36 235.75 346.64 236.33 343.00 236.00 C 343.00 251.00 343.00 266.00 343.00 281.00 Z"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#081320",
    strokeOpacity: 0.93,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 372.00 278.00  C 373.04 280.78 373.23 271.02 373.00 267.00 C 372.77 262.98 373.24 255.51 373.00 251.00 C 372.76 246.49 373.42 240.61 373.00 236.00 C 373.00 236.00 372.35 236.23 372.00 236.00 C 370.74 249.89 373.26 264.11 372.00 278.00 Z"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#091421",
    strokeOpacity: 0.93,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 384.00 280.00  C 385.72 265.81 384.00 250.31 384.00 236.00 C 384.00 236.00 383.50 236.00 383.00 236.00 C 381.69 250.47 384.33 266.30 384.00 280.00 Z"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#152E49",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 391.00 245.00  C 394.02 244.73 400.99 243.99 403.00 246.00 C 407.31 250.31 403.00 262.44 404.00 269.00 C 405.00 275.56 404.00 286.99 404.00 294.00 C 412.39 293.24 415.48 293.38 415.00 285.00 C 414.52 276.62 414.23 271.58 415.00 265.00 C 415.77 258.42 411.97 250.03 416.00 246.00 C 417.93 243.98 425.09 244.74 428.00 245.00 C 428.00 242.00 428.00 239.00 428.00 236.00 C 415.67 236.00 403.33 236.00 391.00 236.00 C 391.00 239.00 391.00 242.00 391.00 245.00 Z"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeOpacity: 0.01,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 429.00 246.00  C 430.72 244.34 430.71 237.71 429.00 236.00 C 429.99 237.41 429.16 244.19 429.00 246.00 Z"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#27313F",
    strokeOpacity: 0.54,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 281.00 244.00  C 280.07 241.17 277.71 239.45 276.00 237.00 C 276.00 237.00 275.25 237.25 275.00 237.00 C 276.00 239.39 279.36 242.18 281.00 244.00 Z"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B8BCC9",
    strokeOpacity: 0.06,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 281.00 244.00  C 281.00 244.00 281.78 243.75 282.00 244.00 C 280.66 241.07 279.36 238.30 276.00 237.00 C 277.71 239.45 280.07 241.17 281.00 244.00 Z"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A7A9BE",
    strokeOpacity: 0.08,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 161.00 246.00  C 162.55 244.06 164.02 241.51 165.00 239.00 C 162.64 240.47 161.61 243.40 161.00 246.00 Z"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C1C6D2",
    strokeOpacity: 0.07,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 91.00 268.00  C 95.68 263.51 98.62 257.13 103.00 252.00 C 106.18 248.28 109.83 243.57 114.00 241.00 C 114.32 240.80 114.81 240.32 115.00 240.00 C 106.12 246.81 94.94 257.07 91.00 268.00 Z"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 135.00 244.00  C 132.94 246.36 130.28 250.21 128.00 253.00 C 127.26 254.15 126.79 254.89 126.00 256.00 C 125.88 260.13 132.63 257.57 134.00 256.00 C 135.50 253.61 136.35 250.56 138.00 248.00 C 139.64 245.45 141.19 242.46 144.00 241.00 C 141.18 237.81 136.81 242.37 135.00 244.00 Z"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#394050",
    strokeOpacity: 0.4,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 103.00 252.00  C 106.59 248.41 110.79 245.12 114.00 241.00 C 109.83 243.57 106.18 248.28 103.00 252.00 Z"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B1ACBD",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 138.00 248.00  C 139.95 245.76 142.92 244.08 144.00 241.00 C 141.19 242.46 139.64 245.45 138.00 248.00 Z"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B8BCC5",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 128.00 253.00  C 130.28 250.21 132.94 246.36 135.00 244.00 C 132.09 246.61 130.16 249.65 128.00 253.00 Z"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#161F31",
    strokeOpacity: 0.78,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 391.00 246.00  C 393.66 247.97 399.54 244.57 403.00 246.00 C 400.99 243.99 394.02 244.73 391.00 245.00 C 391.00 245.00 390.76 245.82 391.00 246.00 Z"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#061022",
    strokeOpacity: 0.85,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 416.00 246.00  C 416.00 245.96 417.00 246.00 417.00 246.00 C 420.67 246.00 424.33 246.00 428.00 246.00 C 428.00 246.00 428.00 245.50 428.00 245.00 C 425.09 244.74 417.93 243.98 416.00 246.00 Z"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#666A79",
    strokeOpacity: 0.18,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 265.00 263.00  C 262.43 263.50 259.59 262.62 257.00 263.00 C 257.00 257.33 257.00 251.67 257.00 246.00 C 254.68 251.01 256.66 258.17 256.00 264.00 C 259.17 264.43 262.48 263.85 265.00 263.00 Z"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 265.00 263.00  C 278.54 258.43 266.56 239.31 257.00 246.00 C 257.00 251.67 257.00 257.33 257.00 263.00 C 259.59 262.62 262.43 263.50 265.00 263.00 Z"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 304.00 252.00  C 302.23 259.74 304.00 270.03 304.00 278.00 C 304.00 278.00 303.84 278.56 304.00 279.00 C 307.98 282.82 308.75 284.17 315.00 284.00 C 315.90 283.98 317.13 284.22 318.00 284.00 C 319.28 283.34 321.76 277.46 322.00 276.00 C 322.62 269.15 322.76 260.83 322.00 254.00 C 321.70 252.42 319.79 248.09 318.00 247.00 C 312.58 244.46 306.34 245.82 304.00 252.00 Z"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#474A59",
    strokeOpacity: 0.35,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 404.00 295.00  C 403.96 295.00 404.00 294.00 404.00 294.00 C 404.00 286.99 405.00 275.56 404.00 269.00 C 403.00 262.44 407.31 250.31 403.00 246.00 C 404.27 253.08 401.31 264.34 403.00 271.00 C 404.69 277.66 399.30 290.48 404.00 295.00 Z"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#21253C",
    strokeOpacity: 0.53,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 404.00 294.00  C 404.00 294.00 403.96 295.00 404.00 295.00 C 407.60 295.33 411.38 295.00 415.00 295.00 C 415.00 295.00 415.74 295.25 416.00 295.00 C 417.47 278.80 414.54 262.20 416.00 246.00 C 411.97 250.03 415.77 258.42 415.00 265.00 C 414.23 271.58 414.52 276.62 415.00 285.00 C 415.48 293.38 412.39 293.24 404.00 294.00 Z"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#CECED5",
    strokeOpacity: 0.02,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 416.00 295.00  C 420.23 290.91 416.20 277.42 417.00 271.00 C 417.80 264.58 417.61 252.79 417.00 246.00 C 417.00 246.00 416.00 245.96 416.00 246.00 C 414.54 262.20 417.47 278.80 416.00 295.00 Z"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#858F9C",
    strokeOpacity: 0.35,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 447.00 259.00  C 447.00 259.04 448.00 259.00 448.00 259.00 C 448.25 258.75 448.00 258.00 448.00 258.00 C 448.00 254.00 448.00 250.00 448.00 246.00 C 445.84 247.52 446.75 256.28 447.00 259.00 Z"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#355948",
    strokeOpacity: 0.54,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 91.00 253.00  C 92.28 251.49 93.38 250.79 95.00 250.00 C 95.00 250.00 94.91 249.48 95.00 249.00 C 95.11 248.40 95.58 247.45 96.00 247.00 C 93.72 248.95 92.58 250.44 91.00 253.00 Z"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#9A9CA7",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 158.00 254.00  C 158.67 251.90 160.42 249.48 161.00 247.00 C 159.20 249.25 158.60 251.08 158.00 254.00 Z"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BBBAC7",
    strokeOpacity: 0.07,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 292.00 283.00  C 292.00 282.00 292.00 281.00 292.00 280.00 C 290.11 271.40 290.13 258.53 292.00 250.00 C 292.00 249.01 291.94 247.99 292.00 247.00 C 289.24 254.11 286.63 276.39 292.00 283.00 Z"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A0A5AF",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 322.00 254.00  C 321.64 250.78 321.33 248.56 318.00 247.00 C 319.79 248.09 321.70 252.42 322.00 254.00 Z"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B4B7BE",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 212.00 252.00  C 212.82 258.05 212.81 265.02 212.00 271.00 C 212.00 272.33 211.99 273.67 212.00 275.00 C 213.75 265.78 213.98 257.31 212.00 248.00 C 212.00 249.33 212.00 250.67 212.00 252.00 Z"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A1A4AF",
    strokeOpacity: 0.21,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 334.00 281.00  C 335.89 272.89 336.86 257.05 334.00 249.00 C 335.67 258.21 335.04 271.68 334.00 281.00 Z"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#AEC3B6",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 91.00 253.00  C 88.71 256.70 85.86 260.03 84.00 264.00 C 86.94 259.05 91.44 254.66 95.00 250.00 C 93.38 250.79 92.28 251.49 91.00 253.00 Z"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#1D2438",
    strokeOpacity: 0.58,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 292.00 280.00  C 292.00 270.00 292.00 260.00 292.00 250.00 C 290.13 258.53 290.11 271.40 292.00 280.00 Z"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0F1925",
    strokeOpacity: 0.75,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 212.00 271.00  C 212.81 265.02 212.82 258.05 212.00 252.00 C 212.00 258.33 212.00 264.67 212.00 271.00 Z"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#676778",
    strokeOpacity: 0.21,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 304.00 278.00  C 304.00 270.03 302.23 259.74 304.00 252.00 C 302.27 256.57 300.85 273.75 304.00 278.00 Z"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#244C38",
    strokeOpacity: 0.79,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 66.00 257.00  C 66.00 259.67 66.00 262.33 66.00 265.00 C 68.35 261.83 66.30 257.15 66.00 254.00 C 66.00 255.00 66.00 256.00 66.00 257.00 Z"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#969CAA",
    strokeOpacity: 0.08,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 134.00 256.00  C 132.63 257.57 125.88 260.13 126.00 256.00 C 124.54 256.32 124.95 258.13 124.00 259.00 C 128.82 259.36 131.71 259.66 134.00 256.00 Z"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#819F95",
    strokeOpacity: 0.05,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 66.00 266.00  C 66.00 266.00 66.00 265.50 66.00 265.00 C 66.00 262.33 66.00 259.67 66.00 257.00 C 65.31 260.14 65.70 262.93 66.00 266.00 Z"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#838A95",
    strokeOpacity: 0.24,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 166.00 271.00  C 166.00 266.33 166.00 261.67 166.00 257.00 C 165.58 261.34 165.57 266.60 166.00 271.00 Z"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A2ABC1",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 282.00 265.00  C 284.27 263.26 283.85 260.72 284.00 258.00 C 283.78 259.56 282.67 263.11 282.00 265.00 Z"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#D8D8FF",
    strokeOpacity: 0.02,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 448.00 259.00  C 454.00 259.00 460.00 259.00 466.00 259.00 C 466.50 259.00 467.00 259.00 467.00 259.00 C 464.45 256.34 451.96 257.64 448.00 258.00 C 448.00 258.00 448.25 258.75 448.00 259.00 Z"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#1E2336",
    strokeOpacity: 0.66,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 466.00 260.00  C 466.00 259.50 466.00 259.00 466.00 259.00 C 460.00 259.00 454.00 259.00 448.00 259.00 C 448.00 259.00 447.00 259.04 447.00 259.00 C 449.55 261.66 462.04 260.36 466.00 260.00 Z"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#798087",
    strokeOpacity: 0.39,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 466.00 260.00  C 466.00 262.05 467.10 268.38 466.00 270.00 C 467.92 268.10 467.26 261.86 467.00 259.00 C 467.00 259.00 466.50 259.00 466.00 259.00 C 466.00 259.00 466.00 259.50 466.00 260.00 Z"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#767986",
    strokeOpacity: 0.16,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 158.00 284.00  C 157.55 276.21 156.68 268.14 157.00 260.00 C 155.72 268.06 156.47 276.21 158.00 284.00 Z"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B8BCC6",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 276.00 275.00  C 276.18 270.89 281.18 270.22 282.00 266.00 C 280.27 268.70 273.34 271.58 276.00 275.00 Z"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C9C7D7",
    strokeOpacity: 0.05,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 85.00 280.00  C 86.76 276.52 89.47 272.91 91.00 269.00 C 87.69 271.06 86.27 276.55 85.00 280.00 Z"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A99AB5",
    strokeOpacity: 0.24,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 447.00 283.00  C 449.33 283.00 451.67 283.00 454.00 283.00 C 454.07 282.99 454.00 282.00 454.00 282.00 C 452.00 282.00 450.00 282.00 448.00 282.00 C 448.00 278.33 448.00 274.67 448.00 271.00 C 446.78 272.11 445.81 281.31 447.00 283.00 Z"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A4C3B8",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 68.00 281.00  C 67.57 278.70 66.30 275.86 66.00 274.00 C 66.20 276.96 67.28 278.64 68.00 281.00 Z"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 114.00 294.00  C 113.94 296.77 115.72 308.11 114.00 310.00 C 117.19 311.27 124.84 310.40 126.00 308.00 C 126.59 306.54 124.23 300.84 125.00 298.00 C 125.77 295.16 124.94 290.05 125.00 287.00 C 125.05 284.48 125.74 281.83 126.00 280.00 C 126.02 278.26 125.79 276.40 127.00 275.00 C 124.37 273.26 121.03 274.26 118.00 274.00 C 115.91 280.51 114.14 286.95 114.00 294.00 Z"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#646778",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 256.00 294.00  C 256.32 293.76 257.00 294.00 257.00 294.00 C 257.00 287.67 257.00 281.33 257.00 275.00 C 259.98 274.42 262.56 275.63 264.00 278.00 C 263.55 273.48 259.84 273.64 256.00 274.00 C 256.45 280.63 255.40 287.39 256.00 294.00 Z"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A8ABB6",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 280.00 284.00  C 278.82 281.13 278.53 277.94 276.00 276.00 C 277.19 278.90 278.57 281.43 280.00 284.00 Z"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#7E8791",
    strokeOpacity: 0.19,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 318.00 284.00  C 321.44 283.12 321.75 278.72 322.00 276.00 C 321.76 277.46 319.28 283.34 318.00 284.00 Z"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#8D929B",
    strokeOpacity: 0.21,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 170.00 289.00  C 168.97 285.03 166.72 280.49 166.00 277.00 C 166.45 281.28 168.54 285.36 170.00 289.00 Z"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ADB4BC",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 315.00 284.00  C 308.75 284.17 307.98 282.82 304.00 279.00 C 306.15 284.97 309.97 285.10 315.00 284.00 Z"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A4A6AB",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 125.00 287.00  C 125.00 286.96 126.00 287.00 126.00 287.00 C 126.00 284.67 125.93 282.33 126.00 280.00 C 125.74 281.83 125.05 284.48 125.00 287.00 Z"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BBBBBB",
    strokeOpacity: 0.02,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 454.00 283.00  C 457.02 283.00 466.64 281.35 469.00 283.00 C 466.71 280.71 457.45 281.69 454.00 282.00 C 454.00 282.00 454.07 282.99 454.00 283.00 Z"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BFC3D6",
    strokeOpacity: 0.03,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 349.00 292.00  C 346.80 289.80 343.89 285.69 343.00 283.00 C 343.28 286.98 345.95 289.59 349.00 292.00 Z"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#191E2C",
    strokeOpacity: 0.53,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 470.00 294.00  C 470.39 291.30 470.82 284.82 469.00 283.00 C 466.64 281.35 457.02 283.00 454.00 283.00 C 451.67 283.00 449.33 283.00 447.00 283.00 C 453.34 285.33 461.83 283.34 469.00 284.00 C 468.56 287.47 469.16 291.19 470.00 294.00 Z"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A6A9B4",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 302.00 295.00  C 297.75 292.83 295.18 287.25 292.00 284.00 C 292.97 288.40 297.74 293.31 302.00 295.00 Z"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#404654",
    strokeOpacity: 0.25,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 367.00 284.00  C 365.08 284.59 362.02 284.00 360.00 284.00 C 362.18 285.61 364.79 285.12 367.00 284.00 Z"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#9CA0AF",
    strokeOpacity: 0.18,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 268.00 288.00  C 267.74 286.78 267.16 286.76 266.00 285.00 C 266.53 286.21 267.53 287.04 268.00 288.00 Z"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ADB0C5",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 206.00 295.00  C 207.40 292.20 208.86 289.16 210.00 286.00 C 208.58 288.88 207.18 291.80 206.00 295.00 Z"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#6A707B",
    strokeOpacity: 0.34,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 126.00 308.00  C 128.21 303.44 126.00 292.17 126.00 287.00 C 126.00 287.00 125.00 286.96 125.00 287.00 C 124.94 290.05 125.77 295.16 125.00 298.00 C 124.23 300.84 126.59 306.54 126.00 308.00 Z"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#202738",
    strokeOpacity: 0.54,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 271.00 294.00  C 273.44 295.87 279.70 295.30 283.00 295.00 C 283.00 295.00 282.76 294.31 283.00 294.00 C 282.78 293.05 283.39 291.26 282.00 291.00 C 283.09 295.05 273.47 295.13 271.00 294.00 Z"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A6ABB3",
    strokeOpacity: 0.14,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 323.00 295.00  C 325.60 294.01 326.03 292.93 328.00 291.00 C 326.54 292.07 324.40 294.29 323.00 295.00 Z"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#EBEBED",
    strokeOpacity: 0.04,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 283.00 295.00  C 279.70 295.30 273.44 295.87 271.00 294.00 C 270.81 293.85 269.18 292.25 269.00 292.00 C 271.74 298.25 282.80 294.71 283.00 295.00 Z"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#727885",
    strokeOpacity: 0.27,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 80.00 299.00  C 80.61 297.33 80.70 295.74 81.00 294.00 C 81.23 293.33 80.14 298.34 80.00 299.00 Z"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#DADBEA",
    strokeOpacity: 0.02,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 113.00 296.00  C 112.55 299.62 112.55 304.38 113.00 308.00 C 113.12 308.97 113.01 309.60 114.00 310.00 C 115.72 308.11 113.94 296.77 114.00 294.00 C 113.89 294.52 113.12 294.99 113.00 296.00 Z"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#F7F7F7",
    strokeOpacity: 0.01,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 245.00 295.00  C 246.75 296.29 256.23 297.60 257.00 294.00 C 257.00 294.00 256.32 293.76 256.00 294.00 C 253.76 295.66 248.09 295.44 245.00 295.00 Z"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#2C2F3E",
    strokeOpacity: 0.33,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 439.00 295.00  C 443.24 295.64 446.98 295.16 451.00 295.00 C 456.65 294.78 462.35 295.00 468.00 295.00 C 468.00 295.00 468.50 295.05 469.00 295.00 C 459.17 292.06 446.70 295.12 436.00 294.00 C 436.84 295.39 437.55 294.78 439.00 295.00 Z"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ACADB5",
    strokeOpacity: 0.15,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 178.00 304.00  C 176.06 300.88 173.76 297.91 172.00 295.00 C 173.51 298.31 174.82 301.93 178.00 304.00 Z"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeOpacity: 0.01,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 415.00 295.00  C 411.38 295.00 407.60 295.33 404.00 295.00 C 405.94 296.94 412.93 296.53 415.00 295.00 Z"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 468.00 295.00  C 462.35 295.00 456.65 294.78 451.00 295.00 C 455.15 295.29 463.94 298.01 468.00 295.00 Z"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#0A1322",
    strokeOpacity: 0.69,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 113.00 308.00  C 112.55 304.38 112.55 299.62 113.00 296.00 C 111.59 299.47 111.56 304.47 113.00 308.00 Z"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#8D8F9E",
    strokeOpacity: 0.21,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 318.00 296.00  C 314.47 296.26 310.53 296.26 307.00 296.00 C 310.72 296.69 314.22 296.70 318.00 296.00 Z"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ABAEBB",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 187.00 316.00  C 184.86 312.54 181.36 307.19 178.00 305.00 C 179.52 309.21 183.46 313.25 187.00 316.00 Z"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#999FA6",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 97.00 324.00  C 92.54 317.61 84.51 313.44 80.00 307.00 C 83.65 313.92 90.89 319.33 97.00 324.00 Z"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A5B0BB",
    strokeOpacity: 0.14,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 188.00 317.00  C 190.97 318.92 197.15 309.53 199.00 307.00 C 196.98 309.18 190.94 316.38 188.00 317.00 Z"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A2B9A8",
    strokeOpacity: 0.18,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 247.00 314.00  C 247.50 313.99 248.00 314.00 248.00 314.00 C 248.00 313.50 248.00 313.00 248.00 313.00 C 247.84 312.77 246.34 313.23 246.00 313.00 C 242.91 310.91 252.35 310.78 254.00 312.00 C 254.41 311.81 255.00 312.00 255.00 312.00 C 253.02 308.14 247.50 310.77 244.00 310.00 C 243.71 312.87 244.06 314.07 247.00 314.00 Z"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B6D1B7",
    strokeOpacity: 0.08,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 257.00 315.00  C 256.72 313.73 257.21 312.29 257.00 311.00 C 259.67 311.00 262.33 311.00 265.00 311.00 C 262.15 308.92 252.83 309.79 257.00 315.00 Z"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ADBCAF",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 272.00 313.00  C 274.88 309.51 276.44 312.04 278.00 315.00 C 276.42 310.65 275.11 307.81 272.00 313.00 Z"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A3B8A9",
    strokeOpacity: 0.14,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 283.00 311.00  C 287.70 310.36 287.56 316.35 290.00 319.00 C 292.59 317.36 289.34 312.57 292.00 311.00 C 294.24 315.09 292.40 321.16 293.00 326.00 C 295.31 321.66 293.35 315.16 294.00 310.00 C 289.54 308.70 289.65 312.85 290.00 316.00 C 288.84 314.89 285.46 307.14 283.00 311.00 Z"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C1CDC3",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 302.00 321.00  C 300.88 317.83 297.12 319.10 297.03 314.97 C 296.94 310.84 300.27 310.60 304.00 311.00 C 300.95 308.62 297.08 309.80 296.01 313.99 C 294.94 318.18 300.77 318.71 302.00 321.00 Z"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BDCAC0",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 309.00 311.00  C 309.00 310.96 310.00 311.00 310.00 311.00 C 312.00 311.00 314.00 311.00 316.00 311.00 C 314.30 309.74 310.69 309.24 309.00 311.00 Z"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#AEBCB1",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 321.00 313.00  C 322.99 310.17 327.07 311.20 330.00 311.00 C 329.73 312.28 330.77 313.72 332.00 314.00 C 330.50 309.94 322.51 307.21 321.00 313.00 Z"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B6C7B9",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 335.00 311.00  C 337.21 311.45 339.83 310.40 342.00 311.00 C 340.40 310.21 336.52 308.83 335.00 311.00 Z"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B0BFB2",
    strokeOpacity: 0.16,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 350.00 314.00  C 350.00 313.50 350.00 313.00 350.00 313.00 C 349.84 312.77 348.34 313.23 348.00 313.00 C 344.51 310.63 354.66 311.00 356.00 311.00 C 356.50 311.00 357.00 311.00 357.00 311.00 C 354.32 308.73 349.50 310.62 346.00 310.00 C 345.27 312.97 346.96 314.91 350.00 314.00 Z"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A9B7AB",
    strokeOpacity: 0.18,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 365.00 313.00  C 368.68 306.74 375.15 315.02 370.00 319.00 C 371.68 320.87 373.30 318.48 375.00 320.00 C 374.72 318.77 373.28 317.73 372.00 318.00 C 376.20 312.09 367.79 306.15 365.00 313.00 Z"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BBC7BC",
    strokeOpacity: 0.08,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 383.00 326.00  C 384.31 322.55 380.37 311.68 385.00 311.00 C 385.25 310.75 386.00 311.00 386.00 311.00 C 385.50 309.24 383.28 310.28 382.00 310.00 C 383.61 313.74 379.41 323.49 383.00 326.00 Z"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ADC0B6",
    strokeOpacity: 0.05,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 391.00 323.00  C 390.82 323.97 391.15 325.03 391.00 326.00 C 393.74 325.09 390.63 323.18 394.00 324.00 C 395.18 319.80 389.76 311.02 398.00 310.00 C 391.01 310.41 391.96 317.87 391.00 323.00 Z"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#4B6456",
    strokeOpacity: 0.65,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 394.00 324.00  C 395.48 324.36 398.44 329.86 401.92 325.92 C 405.39 321.97 406.42 309.51 398.00 310.00 C 389.76 311.02 395.18 319.80 394.00 324.00 M 400.00 314.00  C 402.95 315.66 400.92 324.67 397.32 322.66 C 393.72 320.65 396.72 312.15 400.00 314.00 Z"
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A7B5AD",
    strokeOpacity: 0.17,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 407.00 313.00  C 409.11 309.84 418.19 309.56 417.00 315.00 C 416.00 315.00 415.00 315.00 414.00 315.00 C 414.50 316.76 416.72 315.72 418.00 316.00 C 419.60 309.22 409.53 307.72 407.00 313.00 Z"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BCC2BB",
    strokeOpacity: 0.06,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 421.00 311.00  C 421.96 310.80 423.03 311.16 424.00 311.00 C 424.00 316.00 424.00 321.00 424.00 326.00 C 426.31 321.66 424.35 315.16 425.00 310.00 C 423.34 309.87 422.06 309.92 421.00 311.00 Z"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A4B6A9",
    strokeOpacity: 0.18,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 433.00 323.00  C 436.13 320.96 427.81 318.55 428.03 314.97 C 428.24 311.39 434.94 308.14 436.00 314.00 C 434.51 315.23 432.48 313.75 432.00 317.00 C 434.37 317.62 435.60 319.43 437.00 321.00 C 437.39 318.67 434.66 317.93 434.00 316.00 C 440.29 315.04 434.22 306.18 428.26 311.26 C 422.30 316.34 434.08 319.86 433.00 323.00 Z"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B7CABE",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 439.00 311.00  C 440.40 310.38 447.60 310.38 449.00 311.00 C 447.88 309.28 440.15 309.24 439.00 311.00 Z"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#485F4F",
    strokeOpacity: 0.66,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 452.00 326.00  C 456.89 325.77 456.80 310.21 452.00 310.00 C 452.00 315.33 452.00 320.67 452.00 326.00 Z"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C5D9CB",
    strokeOpacity: 0.04,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 458.00 311.00  C 458.00 310.96 459.00 311.00 459.00 311.00 C 463.12 311.61 458.90 317.51 463.00 316.00 C 461.79 314.64 461.67 307.23 458.00 311.00 Z"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A0B5A4",
    strokeOpacity: 0.19,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 463.00 316.00  C 466.04 314.88 464.44 309.98 469.00 311.00 C 465.77 307.70 463.36 313.16 463.00 316.00 Z"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#2C4839",
    strokeOpacity: 0.79,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 246.00 313.00  C 246.76 310.39 251.99 312.70 253.00 313.00 C 253.35 312.93 253.74 312.12 254.00 312.00 C 252.35 310.78 242.91 310.91 246.00 313.00 Z"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#385142",
    strokeOpacity: 0.76,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 257.00 315.00  C 257.00 315.00 257.00 315.50 257.00 316.00 C 258.53 318.07 258.50 321.97 257.00 324.00 C 257.00 324.00 256.94 324.99 257.00 325.00 C 260.86 325.46 259.00 322.76 261.00 321.00 C 261.20 322.71 264.48 329.04 267.00 325.00 C 265.37 324.29 265.71 321.62 264.00 321.00 C 265.16 319.72 265.61 317.86 267.00 317.00 C 267.07 314.21 267.13 312.55 265.00 311.00 C 262.33 311.00 259.67 311.00 257.00 311.00 C 257.21 312.29 256.72 313.73 257.00 315.00 M 263.00 313.00  C 265.57 314.02 263.60 319.57 260.99 317.99 C 258.38 316.41 260.11 311.85 263.00 313.00 Z"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#456050",
    strokeOpacity: 0.65,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 272.00 313.00  C 270.31 317.24 269.70 321.77 268.00 326.00 C 269.31 325.86 270.69 326.18 272.00 326.00 C 272.00 325.00 272.00 324.00 272.00 323.00 C 273.57 323.39 276.22 322.06 277.00 324.00 C 276.57 326.59 279.39 325.99 281.00 326.00 C 280.33 322.18 279.32 318.63 278.00 315.00 C 276.44 312.04 274.88 309.51 272.00 313.00 M 276.00 317.00  C 277.67 319.86 273.17 323.09 273.00 319.00 C 276.49 321.51 272.64 316.11 276.00 317.00 Z"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#375545",
    strokeOpacity: 0.76,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 286.00 326.00  C 286.00 323.33 286.00 320.67 286.00 318.00 C 287.39 318.26 286.78 320.05 287.00 321.00 C 287.95 322.34 290.24 327.62 293.00 326.00 C 292.40 321.16 294.24 315.09 292.00 311.00 C 289.34 312.57 292.59 317.36 290.00 319.00 C 287.56 316.35 287.70 310.36 283.00 311.00 C 283.00 316.00 283.00 321.00 283.00 326.00 C 283.79 325.65 285.26 326.44 286.00 326.00 Z"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#3D5245",
    strokeOpacity: 0.67,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 302.00 321.00  C 302.87 323.48 302.45 322.07 300.00 323.00 C 299.37 323.24 297.93 321.18 297.00 322.00 C 296.59 323.56 297.46 324.69 298.00 326.00 C 303.49 329.76 307.71 323.89 306.00 319.00 C 305.56 318.35 301.86 317.34 301.00 317.00 C 303.22 314.16 300.25 313.50 299.00 316.00 C 298.35 310.90 303.07 313.92 305.00 315.00 C 305.00 313.67 305.00 312.33 305.00 311.00 C 305.00 311.00 304.49 311.05 304.00 311.00 C 300.27 310.60 296.94 310.84 297.03 314.97 C 297.12 319.10 300.88 317.83 302.00 321.00 Z"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#849A8F",
    strokeOpacity: 0.24,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 306.00 319.00  C 305.55 317.46 303.24 317.88 303.00 316.00 C 306.59 317.01 306.71 312.67 305.00 311.00 C 305.00 312.33 305.00 313.67 305.00 315.00 C 303.07 313.92 298.35 310.90 299.00 316.00 C 300.25 313.50 303.22 314.16 301.00 317.00 C 301.86 317.34 305.56 318.35 306.00 319.00 Z"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#4F6558",
    strokeOpacity: 0.28,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 310.00 326.00  C 309.94 325.99 310.00 325.00 310.00 325.00 C 310.00 320.40 310.41 315.58 310.00 311.00 C 310.00 311.00 309.00 310.96 309.00 311.00 C 308.70 314.35 307.70 323.78 310.00 326.00 Z"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#335040",
    strokeOpacity: 0.82,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 310.00 325.00  C 311.55 324.02 311.99 321.72 314.00 321.00 C 314.88 320.68 316.09 321.24 317.00 321.00 C 319.17 319.82 318.22 312.52 317.00 311.00 C 317.00 311.00 316.50 311.00 316.00 311.00 C 314.00 311.00 312.00 311.00 310.00 311.00 C 310.41 315.58 310.00 320.40 310.00 325.00 M 315.00 317.00  C 314.89 317.45 313.42 318.58 313.00 318.00 C 311.23 317.21 312.35 314.53 312.00 313.00 C 314.36 311.87 317.73 315.51 315.00 317.00 Z"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A0ACA0",
    strokeOpacity: 0.2,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 317.00 321.00  C 320.18 320.16 320.07 311.92 317.00 311.00 C 318.22 312.52 319.17 319.82 317.00 321.00 Z"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#3E5849",
    strokeOpacity: 0.68,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 321.00 313.00  C 321.00 313.00 321.00 313.50 321.00 314.00 C 321.00 316.45 320.45 319.63 321.00 322.00 C 325.20 332.96 335.22 322.72 332.00 314.00 C 330.77 313.72 329.73 312.28 330.00 311.00 C 327.07 311.20 322.99 310.17 321.00 313.00 M 328.00 314.00  C 328.10 314.02 328.00 315.00 328.00 315.00 C 329.32 316.78 329.70 320.28 328.00 322.00 C 327.34 322.67 326.22 323.50 325.00 323.00 C 322.39 321.94 323.60 309.50 328.00 314.00 Z"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#375342",
    strokeOpacity: 0.75,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 338.00 325.00  C 338.55 324.71 337.58 321.54 338.00 321.00 C 339.92 320.49 340.23 322.84 341.00 324.00 C 340.91 323.98 342.98 327.86 344.66 325.68 C 346.35 323.49 343.78 323.68 344.00 322.00 C 343.87 320.51 344.76 315.86 344.00 313.00 C 343.01 311.03 343.91 311.95 342.00 311.00 C 339.83 310.40 337.21 311.45 335.00 311.00 C 335.00 316.00 335.00 321.00 335.00 326.00 C 336.18 326.80 337.45 325.12 338.00 325.00 M 341.00 313.00  C 343.57 314.02 341.60 319.57 338.99 317.99 C 336.38 316.41 338.11 311.85 341.00 313.00 Z"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#33493B",
    strokeOpacity: 0.76,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 348.00 313.00  C 348.50 311.27 354.57 312.06 356.00 311.00 C 354.66 311.00 344.51 310.63 348.00 313.00 Z"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#3E594A",
    strokeOpacity: 0.91,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 348.00 313.00  C 348.34 313.23 349.84 312.77 350.00 313.00 C 352.68 315.58 350.06 321.54 351.00 325.00 C 353.89 321.64 348.82 311.31 357.00 313.00 C 357.24 312.82 357.23 311.16 357.00 311.00 C 357.00 311.00 356.50 311.00 356.00 311.00 C 354.57 312.06 348.50 311.27 348.00 313.00 Z"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#435D4F",
    strokeOpacity: 0.67,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 365.00 313.00  C 363.43 316.87 364.10 322.30 366.00 325.00 C 367.40 325.98 372.33 326.22 373.00 326.00 C 374.00 326.00 375.00 326.00 376.00 326.00 C 374.49 323.73 375.75 321.85 375.00 320.00 C 373.30 318.48 371.68 320.87 370.00 319.00 C 375.15 315.02 368.68 306.74 365.00 313.00 Z"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#3C5043",
    strokeOpacity: 0.63,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 383.00 326.00  C 383.85 326.59 389.96 326.35 391.00 326.00 C 391.15 325.03 390.82 323.97 391.00 323.00 C 390.39 322.20 386.87 323.61 386.00 323.00 C 388.19 326.60 391.12 323.66 384.00 325.00 C 384.64 320.83 382.71 315.34 385.00 312.00 C 385.00 311.50 385.00 311.00 385.00 311.00 C 380.37 311.68 384.31 322.55 383.00 326.00 Z"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#89A193",
    strokeOpacity: 0.35,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 385.00 312.00  C 385.00 315.60 384.29 320.19 386.00 323.00 C 385.73 319.02 386.36 314.97 386.00 311.00 C 386.00 311.00 385.25 310.75 385.00 311.00 C 385.00 311.00 385.00 311.50 385.00 312.00 Z"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#4A6152",
    strokeOpacity: 0.65,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 407.00 313.00  C 405.31 317.72 407.94 322.66 408.00 326.00 C 412.28 327.29 414.70 327.25 417.00 324.00 C 417.66 322.65 418.45 318.84 417.00 318.00 C 411.80 316.82 411.45 320.18 414.00 323.00 C 407.44 321.60 409.38 315.40 414.00 315.00 C 415.00 315.00 416.00 315.00 417.00 315.00 C 418.19 309.56 409.11 309.84 407.00 313.00 Z"
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#2C4A3B",
    strokeOpacity: 0.63,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 421.00 312.00  C 421.00 315.26 419.86 320.98 421.00 324.00 C 421.75 325.27 421.60 326.89 424.00 326.00 C 424.00 321.00 424.00 316.00 424.00 311.00 C 423.03 311.16 421.96 310.80 421.00 311.00 C 421.00 311.00 421.00 311.50 421.00 312.00 Z"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#3D5648",
    strokeOpacity: 0.69,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 433.00 323.00  C 432.95 323.15 431.44 323.16 431.00 323.00 C 429.69 322.52 428.59 321.55 427.00 322.00 C 427.73 323.34 428.34 324.64 429.00 326.00 C 433.23 328.26 437.43 325.92 437.00 321.00 C 435.60 319.43 434.37 317.62 432.00 317.00 C 432.48 313.75 434.51 315.23 436.00 314.00 C 434.94 308.14 428.24 311.39 428.03 314.97 C 427.81 318.55 436.13 320.96 433.00 323.00 Z"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#335242",
    strokeOpacity: 0.85,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 439.00 313.00  C 446.45 315.25 440.46 320.28 443.00 326.00 C 443.35 326.23 444.65 326.23 445.00 326.00 C 447.54 320.27 441.51 315.26 449.00 313.00 C 449.24 312.80 449.23 311.35 449.00 311.00 C 447.60 310.38 440.40 310.38 439.00 311.00 C 438.77 311.35 438.76 312.80 439.00 313.00 Z"
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#667F6D",
    strokeOpacity: 0.17,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 459.00 325.00  C 457.45 321.51 459.35 314.86 459.00 311.00 C 459.00 311.00 458.00 310.96 458.00 311.00 C 457.74 313.92 457.56 325.41 459.00 325.00 Z"
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#31513E",
    strokeOpacity: 0.82,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 459.00 325.00  C 459.46 324.87 460.52 324.91 461.00 325.00 C 461.89 321.98 460.77 319.09 464.00 322.00 C 465.24 323.12 464.46 327.53 468.00 326.00 C 466.49 320.66 463.64 316.11 469.00 312.00 C 469.00 312.00 469.11 311.02 469.00 311.00 C 464.44 309.98 466.04 314.88 463.00 316.00 C 458.90 317.51 463.12 311.61 459.00 311.00 C 459.35 314.86 457.45 321.51 459.00 325.00 Z"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#3E5D4D",
    strokeOpacity: 0.96,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 246.00 313.00  C 246.34 313.23 247.84 312.77 248.00 313.00 C 250.02 314.94 249.26 322.09 249.00 325.00 C 252.29 321.81 246.91 314.14 253.00 313.00 C 251.99 312.70 246.76 310.39 246.00 313.00 Z"
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#6D8375",
    strokeOpacity: 0.38,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 253.00 313.00  C 246.91 314.14 252.29 321.81 249.00 325.00 C 248.74 325.25 248.00 325.00 248.00 325.00 C 248.00 325.50 248.00 326.00 248.00 326.00 C 249.00 326.00 250.00 326.00 251.00 326.00 C 251.00 322.00 251.00 318.00 251.00 314.00 C 253.67 314.48 254.13 313.81 255.00 312.00 C 255.00 312.00 254.41 311.81 254.00 312.00 C 253.74 312.12 253.35 312.93 253.00 313.00 Z"
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#3B5949",
    strokeOpacity: 0.96,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 386.00 323.00  C 384.29 320.19 385.00 315.60 385.00 312.00 C 382.71 315.34 384.64 320.83 384.00 325.00 C 391.12 323.66 388.19 326.60 386.00 323.00 Z"
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 421.00 324.00  C 419.86 320.98 421.00 315.26 421.00 312.00 C 419.12 314.53 419.45 321.37 421.00 324.00 Z"
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#96B4A2",
    strokeOpacity: 0.17,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 468.00 326.00  C 471.05 324.68 466.49 320.59 466.36 318.70 C 466.23 316.81 468.51 314.13 469.00 312.00 C 463.64 316.11 466.49 320.66 468.00 326.00 Z"
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#395143",
    strokeOpacity: 0.73,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 248.00 314.00  C 248.00 317.67 248.00 321.33 248.00 325.00 C 248.00 325.00 248.74 325.25 249.00 325.00 C 249.26 322.09 250.02 314.94 248.00 313.00 C 248.00 313.00 248.00 313.50 248.00 314.00 Z"
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#596F65",
    strokeOpacity: 0.16,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 263.00 313.00  C 260.11 311.85 258.38 316.41 260.99 317.99 C 263.60 319.57 265.57 314.02 263.00 313.00 Z"
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#829D92",
    strokeOpacity: 0.15,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 313.00 318.00  C 312.37 317.13 313.49 314.98 313.00 314.00 C 315.03 313.36 315.06 315.69 315.00 317.00 C 317.73 315.51 314.36 311.87 312.00 313.00 C 312.35 314.53 311.23 317.21 313.00 318.00 Z"
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#AEC7B4",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 323.00  C 325.00 320.00 325.00 317.00 325.00 314.00 C 326.00 314.00 327.00 314.00 328.00 314.00 C 323.60 309.50 322.39 321.94 325.00 323.00 Z"
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#5A6C61",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 341.00 313.00  C 338.11 311.85 336.38 316.41 338.99 317.99 C 341.60 319.57 343.57 314.02 341.00 313.00 Z"
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#8DA093",
    strokeOpacity: 0.22,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 344.00 322.00  C 344.45 318.56 345.53 316.05 344.00 313.00 C 344.76 315.86 343.87 320.51 344.00 322.00 Z"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#4B6253",
    strokeOpacity: 0.52,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 350.00 314.00  C 350.00 318.00 350.00 322.00 350.00 326.00 C 355.79 326.16 351.85 317.71 353.00 314.00 C 354.70 314.34 355.89 313.82 357.00 313.00 C 348.82 311.31 353.89 321.64 351.00 325.00 C 350.06 321.54 352.68 315.58 350.00 313.00 C 350.00 313.00 350.00 313.50 350.00 314.00 Z"
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#819C8C",
    strokeOpacity: 0.3,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 443.00 326.00  C 440.46 320.28 446.45 315.25 439.00 313.00 C 439.27 314.47 441.00 313.89 442.00 314.00 C 443.14 316.96 440.05 324.08 443.00 326.00 Z"
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#99AD9F",
    strokeOpacity: 0.29,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 445.00 326.00  C 447.28 322.99 445.37 317.83 446.00 314.00 C 447.41 314.35 448.16 313.68 449.00 313.00 C 441.51 315.26 447.54 320.27 445.00 326.00 Z"
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#D1E1D6",
    strokeOpacity: 0.06,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 248.00 326.00  C 248.00 326.00 248.00 325.50 248.00 325.00 C 248.00 321.33 248.00 317.67 248.00 314.00 C 248.00 314.00 247.50 313.99 247.00 314.00 C 246.74 316.92 245.98 324.06 248.00 326.00 Z"
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 313.00 318.00  C 313.42 318.58 314.89 317.45 315.00 317.00 C 315.06 315.69 315.03 313.36 313.00 314.00 C 313.49 314.98 312.37 317.13 313.00 318.00 Z"
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C7D2CA",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 321.00 322.00  C 320.45 319.63 321.00 316.45 321.00 314.00 C 319.21 316.42 320.06 319.54 321.00 322.00 Z"
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 323.00  C 326.22 323.50 327.34 322.67 328.00 322.00 C 328.77 320.77 328.00 316.51 328.00 315.00 C 328.00 315.00 328.10 314.02 328.00 314.00 C 327.00 314.00 326.00 314.00 325.00 314.00 C 325.00 317.00 325.00 320.00 325.00 323.00 Z"
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 400.00 314.00  C 396.72 312.15 393.72 320.65 397.32 322.66 C 400.92 324.67 402.95 315.66 400.00 314.00 Z"
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BDDBCA",
    strokeOpacity: 0.06,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 328.00 322.00  C 329.70 320.28 329.32 316.78 328.00 315.00 C 328.00 316.51 328.77 320.77 328.00 322.00 Z"
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#456051",
    strokeOpacity: 0.47,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 257.00 324.00  C 258.50 321.97 258.53 318.07 257.00 316.00 C 257.00 318.67 257.00 321.33 257.00 324.00 Z"
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#94A398",
    strokeOpacity: 0.18,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 267.00 325.00  C 266.74 325.41 266.99 317.29 267.00 317.00 C 265.61 317.86 265.16 319.72 264.00 321.00 C 265.71 321.62 265.37 324.29 267.00 325.00 Z"
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A8C7B3",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 276.00 317.00  C 272.64 316.11 276.49 321.51 273.00 319.00 C 273.17 323.09 277.67 319.86 276.00 317.00 Z"
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C7D0CA",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 417.00 318.00  C 418.45 318.84 417.66 322.65 417.00 324.00 C 418.71 321.58 419.90 318.20 417.00 318.00 Z"
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ECF1EE",
    strokeOpacity: 0.03,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 286.00 326.00  C 287.56 325.07 287.08 322.68 287.00 321.00 C 286.78 320.05 287.39 318.26 286.00 318.00 C 286.00 320.67 286.00 323.33 286.00 326.00 Z"
  }))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#CDCBCE",
    strokeOpacity: 0.07,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 175.00 328.00  C 176.36 327.34 177.66 326.73 179.00 326.00 C 179.43 323.00 176.45 321.82 175.00 320.00 C 176.03 321.96 178.05 323.60 178.00 326.00 C 176.21 325.29 175.90 327.32 175.00 328.00 Z"
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C2E7CF",
    strokeOpacity: 0.06,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 461.00 325.00  C 463.55 325.48 460.22 320.40 464.00 322.00 C 460.77 319.09 461.89 321.98 461.00 325.00 Z"
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#8EA698",
    strokeOpacity: 0.21,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 257.00 325.00  C 257.50 326.76 259.72 325.72 261.00 326.00 C 261.00 324.33 261.00 322.67 261.00 321.00 C 259.00 322.76 260.86 325.46 257.00 325.00 Z"
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#99AA9D",
    strokeOpacity: 0.13,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 298.00 326.00  C 297.46 324.69 296.59 323.56 297.00 322.00 C 297.93 321.18 299.37 323.24 300.00 323.00 C 300.99 322.95 296.35 318.97 296.01 321.99 C 295.67 325.01 296.14 324.73 298.00 326.00 Z"
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#797C78",
    strokeOpacity: 0.15,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 310.00 325.00  C 310.00 325.00 309.94 325.99 310.00 326.00 C 314.71 326.56 311.48 322.73 314.00 321.00 C 311.99 321.72 311.55 324.02 310.00 325.00 Z"
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A3BAA7",
    strokeOpacity: 0.03,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 338.00 325.00  C 340.39 324.46 338.30 323.52 341.00 324.00 C 340.23 322.84 339.92 320.49 338.00 321.00 C 337.58 321.54 338.55 324.71 338.00 325.00 Z"
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A5B8AB",
    strokeOpacity: 0.16,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 429.00 326.00  C 428.34 324.64 427.73 323.34 427.00 322.00 C 428.59 321.55 429.69 322.52 431.00 323.00 C 427.59 318.88 424.41 323.55 429.00 326.00 Z"
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#7B9082",
    strokeOpacity: 0.4,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 272.00 326.00  C 273.88 325.74 274.12 323.99 277.00 324.00 C 276.22 322.06 273.57 323.39 272.00 323.00 C 272.00 324.00 272.00 325.00 272.00 326.00 Z"
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B8B9C0",
    strokeOpacity: 0.07,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 107.00 330.00  C 104.06 328.36 101.46 325.25 98.00 324.00 C 100.56 326.67 103.65 328.50 107.00 330.00 Z"
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#9AA9A1",
    strokeOpacity: 0.16,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 373.00 326.00  C 372.33 326.22 367.40 325.98 366.00 325.00 C 367.04 326.48 369.36 327.52 373.00 326.00 Z"
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#A2B4BD",
    strokeOpacity: 0.11,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 125.00 336.00  C 123.81 335.78 121.62 334.33 120.00 334.00 C 121.67 334.51 122.72 335.76 125.00 336.00 Z"
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B5B6C7",
    strokeOpacity: 0.09,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 153.00 336.00  C 155.31 335.73 156.27 334.52 158.00 334.00 C 156.29 334.34 154.29 335.75 153.00 336.00 Z"
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#696C73",
    strokeOpacity: 0.26,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 146.00 336.00  C 141.00 336.00 136.00 336.00 131.00 336.00 C 135.65 336.45 141.28 336.45 146.00 336.00 Z"
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 0.00 477.00  L 523.00 477.00 L 523.00 0.00 L 0.00 0.00 L 0.00 477.00 M 143.00 122.00  C 149.65 127.20 154.77 138.87 159.00 146.00 C 160.93 148.59 163.16 151.15 165.00 154.00 C 167.81 158.35 170.55 162.65 173.00 167.00 C 175.18 170.05 178.63 172.20 180.00 176.00 C 180.16 176.44 180.00 177.00 180.00 177.00 C 182.70 178.76 182.79 180.36 184.00 183.00 C 186.67 188.84 184.07 189.71 178.00 188.00 C 176.68 187.63 175.34 187.41 174.00 187.00 C 171.57 186.25 169.10 184.82 167.00 184.00 C 162.67 182.77 158.22 181.71 154.00 180.00 C 150.53 181.24 152.31 186.52 152.00 190.00 C 158.79 189.54 165.16 193.59 171.00 196.00 C 173.60 197.07 176.37 197.40 178.00 200.00 C 178.43 200.17 179.00 200.00 179.00 200.00 C 190.41 204.12 199.90 217.79 204.00 227.00 C 205.67 229.40 206.82 230.77 208.00 235.00 C 209.25 238.08 211.79 241.00 212.00 245.00 C 212.05 245.99 212.00 247.01 212.00 248.00 C 213.98 257.31 213.75 265.78 212.00 275.00 C 212.02 279.29 211.38 282.18 210.00 286.00 C 208.86 289.16 207.40 292.20 206.00 295.00 C 203.90 299.20 201.86 303.07 199.00 307.00 C 197.15 309.53 190.97 318.92 188.00 317.00 C 187.69 316.80 187.20 316.32 187.00 316.00 C 183.46 313.25 179.52 309.21 178.00 305.00 C 177.84 304.56 178.00 304.00 178.00 304.00 C 174.82 301.93 173.51 298.31 172.00 295.00 C 171.07 292.96 170.58 291.22 170.00 289.00 C 168.54 285.36 166.45 281.28 166.00 277.00 C 165.80 275.05 166.00 272.96 166.00 271.00 C 165.57 266.60 165.58 261.34 166.00 257.00 C 166.00 252.35 166.51 249.15 168.00 245.00 C 169.29 241.43 170.86 237.99 173.00 235.00 C 174.27 233.22 175.67 231.64 177.00 230.00 C 178.93 227.63 181.21 224.36 184.00 223.00 C 184.40 222.80 185.00 223.00 185.00 223.00 C 185.49 222.76 185.73 221.38 186.00 221.00 C 184.13 221.79 181.98 222.41 180.00 223.00 C 176.71 224.95 173.82 228.81 171.00 231.00 C 168.89 233.42 167.70 236.24 165.00 238.00 C 164.84 238.44 165.00 239.00 165.00 239.00 C 164.02 241.51 162.55 244.06 161.00 246.00 C 160.89 246.47 161.00 247.00 161.00 247.00 C 160.42 249.48 158.67 251.90 158.00 254.00 C 157.72 255.38 157.08 258.07 157.00 260.00 C 156.68 268.14 157.55 276.21 158.00 284.00 C 158.06 285.09 156.11 286.59 157.00 288.00 C 160.20 286.46 161.88 298.22 164.92 303.08 C 167.96 307.94 171.26 315.75 175.00 320.00 C 176.45 321.82 179.43 323.00 179.00 326.00 C 177.66 326.73 176.36 327.34 175.00 328.00 C 169.93 330.86 164.29 332.74 158.00 334.00 C 156.27 334.52 155.31 335.73 153.00 336.00 C 150.74 336.26 148.28 336.00 146.00 336.00 C 141.28 336.45 135.65 336.45 131.00 336.00 C 129.04 336.00 126.95 336.21 125.00 336.00 C 122.72 335.76 121.67 334.51 120.00 334.00 C 115.13 333.02 111.46 331.99 107.00 330.00 C 103.65 328.50 100.56 326.67 98.00 324.00 C 97.56 323.84 97.00 324.00 97.00 324.00 C 90.89 319.33 83.65 313.92 80.00 307.00 C 77.67 302.58 78.58 302.86 80.00 299.00 C 80.14 298.34 81.23 293.33 81.00 294.00 C 81.72 289.77 83.19 284.91 85.00 280.00 C 86.27 276.55 87.69 271.06 91.00 269.00 C 91.17 268.57 91.00 268.00 91.00 268.00 C 94.94 257.07 106.12 246.81 115.00 240.00 C 118.00 234.97 124.92 231.54 130.00 229.00 C 134.20 226.37 138.22 223.97 143.00 222.00 C 150.93 217.58 160.77 215.50 170.00 215.00 C 171.98 214.68 176.08 213.26 178.00 213.00 C 163.10 212.71 150.20 214.45 136.00 219.00 C 133.35 220.23 131.13 222.27 128.00 223.00 C 127.53 223.11 127.00 223.00 127.00 223.00 C 125.59 225.25 123.21 225.73 121.00 227.00 C 116.51 229.58 112.06 233.16 108.00 236.00 C 103.37 239.80 99.97 245.52 95.00 249.00 C 94.91 249.48 95.00 250.00 95.00 250.00 C 91.44 254.66 86.94 259.05 84.00 264.00 C 81.90 268.49 80.31 273.24 77.25 277.25 C 74.19 281.25 75.34 290.12 70.00 291.00 C 72.04 287.41 66.64 285.14 68.00 281.00 C 67.28 278.64 66.20 276.96 66.00 274.00 C 65.82 271.36 66.00 268.65 66.00 266.00 C 65.70 262.93 65.31 260.14 66.00 257.00 C 66.00 256.00 66.00 255.00 66.00 254.00 C 66.00 240.71 71.87 227.29 80.00 217.00 C 84.99 210.68 90.30 205.41 97.00 201.00 C 103.78 196.54 111.10 193.55 119.00 192.00 C 121.27 191.26 123.77 188.61 127.00 190.00 C 126.04 187.27 129.15 178.51 125.00 180.00 C 120.53 181.32 115.17 183.72 110.78 184.78 C 106.38 185.84 99.76 191.13 95.00 189.00 C 91.22 187.31 93.47 182.58 96.00 181.00 C 96.23 180.64 96.00 180.00 96.00 180.00 C 98.92 175.31 105.72 161.10 111.00 160.00 C 111.74 156.23 114.42 152.84 117.00 150.00 C 118.56 147.58 118.37 146.09 121.00 145.00 C 121.16 144.56 121.00 144.00 121.00 144.00 C 122.11 140.94 124.81 138.10 127.00 136.00 C 127.16 135.56 127.00 135.00 127.00 135.00 C 128.14 131.85 131.25 127.79 134.00 126.00 C 134.22 125.64 134.00 125.00 134.00 125.00 C 135.82 119.95 139.17 119.01 143.00 122.00 M 319.00 169.00  C 321.48 170.72 324.42 173.03 325.00 176.00 C 325.09 176.48 325.00 177.00 325.00 177.00 C 327.63 179.01 327.02 182.89 327.00 186.00 C 326.99 187.33 327.00 188.67 327.00 190.00 C 327.00 195.54 329.54 210.52 325.00 214.00 C 324.76 214.18 325.00 215.00 325.00 215.00 C 324.34 218.40 320.16 221.86 317.00 223.00 C 316.56 223.16 316.00 223.00 316.00 223.00 C 311.73 225.33 304.11 226.34 300.00 223.00 C 299.51 222.92 299.00 223.00 299.00 223.00 C 295.10 222.14 289.85 217.35 290.00 213.00 C 290.02 212.50 290.00 212.00 290.00 212.00 C 289.42 211.13 289.16 211.32 289.00 210.00 C 286.15 203.00 287.24 188.09 289.00 181.00 C 289.15 179.30 288.93 179.15 290.00 178.00 C 290.00 177.50 290.00 177.00 290.00 177.00 C 290.91 172.84 294.32 169.86 298.00 168.00 C 304.39 164.77 313.11 164.92 319.00 169.00 M 462.00 168.00  C 462.50 168.01 463.00 168.00 463.00 168.00 C 466.51 169.27 469.71 172.56 471.00 176.00 C 471.95 178.54 472.71 182.15 472.00 185.00 C 471.64 186.44 462.66 189.49 461.00 186.00 C 460.53 185.01 461.16 183.10 461.00 182.00 C 460.21 178.97 455.77 177.89 453.00 178.00 C 452.50 178.02 451.45 177.85 451.00 178.00 C 449.11 179.29 447.30 184.33 447.00 186.00 C 446.51 191.20 446.46 199.11 447.00 205.00 C 447.20 206.25 449.28 212.30 451.00 213.00 C 456.98 214.76 462.55 209.29 461.00 204.00 C 465.63 204.65 473.74 203.33 472.00 211.00 C 471.76 215.96 467.37 222.50 462.00 223.00 C 461.50 223.05 461.00 223.00 461.00 223.00 C 456.28 225.06 452.68 224.56 448.00 223.00 C 442.76 221.25 437.18 218.08 437.00 212.00 C 434.46 205.04 431.81 185.38 437.00 179.00 C 437.00 178.50 437.00 178.00 437.00 178.00 C 437.33 173.52 440.38 170.87 444.00 169.00 C 446.43 167.75 447.31 167.63 450.00 167.00 C 454.18 166.03 458.05 165.84 462.00 168.00 M 255.00 168.00  C 255.52 168.50 255.67 169.41 256.00 170.00 C 261.91 180.45 265.98 190.24 271.00 201.00 C 273.32 191.24 271.35 179.51 272.00 169.00 C 271.65 168.95 270.90 168.19 271.00 168.00 C 272.58 165.18 279.38 168.05 282.00 167.00 C 281.33 185.50 283.33 205.32 281.00 223.00 C 275.82 223.47 270.76 224.10 268.00 220.00 C 262.38 211.64 261.49 200.20 256.00 193.00 C 256.51 195.94 254.63 204.23 255.00 208.00 C 255.37 211.77 256.41 220.68 254.00 223.00 C 252.19 223.16 245.41 223.99 244.00 223.00 C 238.99 219.49 245.36 207.01 243.00 201.00 C 240.64 194.99 245.74 184.78 243.00 178.00 C 240.26 171.22 247.95 161.11 255.00 168.00 M 356.00 168.00  C 356.50 168.00 357.00 168.00 357.00 168.00 C 357.50 168.00 358.00 168.00 358.00 168.00 C 360.53 168.58 363.33 170.18 365.00 172.00 C 365.76 172.82 366.49 174.04 367.00 175.00 C 367.72 176.37 367.97 177.10 368.00 179.00 C 369.35 184.41 370.63 187.51 368.00 193.00 C 368.18 193.08 368.08 194.51 368.00 195.00 C 367.51 198.04 363.88 201.34 361.00 202.00 C 363.56 207.94 365.99 213.77 368.00 220.00 C 368.25 220.78 371.05 221.31 370.00 223.00 C 366.33 221.28 357.20 226.19 356.00 220.00 C 353.48 216.25 353.29 212.08 352.00 208.00 C 350.85 205.44 348.41 203.06 345.00 204.00 C 344.34 210.16 346.32 217.66 344.00 223.00 C 340.85 223.28 337.15 223.29 334.00 223.00 C 329.58 218.74 334.06 203.34 333.00 197.00 C 331.94 190.66 332.88 176.04 333.00 170.00 C 333.12 163.96 353.56 166.19 356.00 168.00 M 395.00 168.00  C 406.76 170.11 408.98 174.71 411.00 186.00 C 411.35 187.96 411.95 190.43 412.00 193.00 C 412.13 199.31 411.55 204.62 410.00 210.00 C 409.66 219.06 402.33 222.55 394.00 223.00 C 388.21 223.31 381.78 223.52 376.00 223.00 C 372.51 219.64 375.73 211.24 375.00 206.00 C 374.27 200.76 375.08 192.74 375.00 187.00 C 374.92 181.26 374.47 173.83 375.00 168.00 C 378.23 164.64 391.29 167.34 395.00 168.00 M 425.00 168.00  C 426.51 167.90 427.64 166.75 429.00 168.00 C 432.24 170.97 429.54 181.41 430.00 186.00 C 430.46 190.59 430.53 200.56 430.00 205.00 C 429.47 209.44 432.36 220.65 429.00 223.00 C 427.45 224.09 419.99 223.18 418.00 223.00 C 414.52 219.65 418.00 213.17 417.00 208.00 C 416.00 202.83 417.76 196.96 417.00 191.00 C 416.24 185.04 418.03 182.22 417.00 175.00 C 415.97 167.78 419.06 167.60 425.00 168.00 M 322.00 235.00  C 330.24 237.14 332.32 244.26 334.00 249.00 C 336.86 257.05 335.89 272.89 334.00 281.00 C 332.88 285.82 331.70 288.30 328.00 291.00 C 326.03 292.93 325.60 294.01 323.00 295.00 C 321.16 295.71 320.05 295.85 318.00 296.00 C 314.22 296.70 310.72 296.69 307.00 296.00 C 304.93 295.85 303.87 295.74 302.00 295.00 C 297.74 293.31 292.97 288.40 292.00 284.00 C 291.90 283.52 292.00 283.00 292.00 283.00 C 286.63 276.39 289.24 254.11 292.00 247.00 C 292.13 244.60 292.92 243.97 294.00 242.00 C 295.79 238.71 297.98 235.88 302.00 235.00 C 302.48 234.90 303.00 235.00 303.00 235.00 C 306.68 230.20 317.94 233.37 322.00 235.00 M 244.00 236.00  C 244.35 236.23 245.00 236.00 245.00 236.00 C 249.07 232.99 261.64 234.80 267.00 235.00 C 270.07 235.12 272.71 234.67 275.00 237.00 C 275.25 237.25 276.00 237.00 276.00 237.00 C 279.36 238.30 280.66 241.07 282.00 244.00 C 284.09 248.57 284.28 252.78 284.00 258.00 C 283.85 260.72 284.27 263.26 282.00 265.00 C 281.84 265.44 282.00 266.00 282.00 266.00 C 281.18 270.22 276.18 270.89 276.00 275.00 C 275.98 275.50 276.00 276.00 276.00 276.00 C 278.53 277.94 278.82 281.13 280.00 284.00 C 281.48 286.65 284.84 291.63 283.00 294.00 C 282.76 294.31 283.00 295.00 283.00 295.00 C 282.80 294.71 271.74 298.25 269.00 292.00 C 267.99 290.62 268.34 289.56 268.00 288.00 C 267.53 287.04 266.53 286.21 266.00 285.00 C 265.02 282.77 264.91 280.18 264.00 278.00 C 262.56 275.63 259.98 274.42 257.00 275.00 C 257.00 281.33 257.00 287.67 257.00 294.00 C 256.23 297.60 246.75 296.29 245.00 295.00 C 244.70 294.78 244.22 294.30 244.00 294.00 C 240.83 289.69 243.97 280.31 243.00 275.00 C 242.03 269.69 243.92 258.72 243.00 254.00 C 242.08 249.28 244.06 236.04 244.00 236.00 M 359.00 284.00  C 359.40 284.20 360.00 284.00 360.00 284.00 C 362.02 284.00 365.08 284.59 367.00 284.00 C 369.48 282.75 370.49 280.53 371.00 278.00 C 370.50 272.52 371.78 260.85 371.00 256.00 C 370.22 251.15 372.11 236.07 372.00 236.00 C 372.35 236.23 373.00 236.00 373.00 236.00 C 375.35 234.26 380.84 234.71 384.00 235.00 C 388.51 239.34 383.84 253.41 385.00 260.00 C 386.16 266.59 385.70 279.29 383.00 285.00 C 377.34 296.96 360.18 300.83 349.00 292.00 C 345.95 289.59 343.28 286.98 343.00 283.00 C 342.96 282.50 343.00 281.50 343.00 281.00 C 340.83 275.88 341.35 263.79 342.00 258.00 C 342.65 252.21 339.10 238.75 343.00 235.00 C 346.97 234.64 351.02 235.27 355.00 235.00 C 357.01 251.10 350.59 269.93 359.00 284.00 M 429.00 236.00  C 430.71 237.71 430.72 244.34 429.00 246.00 C 428.74 246.25 428.00 246.00 428.00 246.00 C 424.33 246.00 420.67 246.00 417.00 246.00 C 417.61 252.79 417.80 264.58 417.00 271.00 C 416.20 277.42 420.23 290.91 416.00 295.00 C 415.74 295.25 415.00 295.00 415.00 295.00 C 412.93 296.53 405.94 296.94 404.00 295.00 C 399.30 290.48 404.69 277.66 403.00 271.00 C 401.31 264.34 404.27 253.08 403.00 246.00 C 399.54 244.57 393.66 247.97 391.00 246.00 C 388.50 243.60 390.81 238.24 390.00 235.00 C 402.83 235.67 416.99 233.67 429.00 236.00 M 448.00 246.00  C 448.00 250.00 448.00 254.00 448.00 258.00 C 451.96 257.64 464.45 256.34 467.00 259.00 C 467.26 261.86 467.92 268.10 466.00 270.00 C 462.67 273.30 452.10 267.28 448.00 271.00 C 448.00 274.67 448.00 278.33 448.00 282.00 C 450.00 282.00 452.00 282.00 454.00 282.00 C 457.45 281.69 466.71 280.71 469.00 283.00 C 470.82 284.82 470.39 291.30 470.00 294.00 C 469.95 294.35 469.35 294.96 469.00 295.00 C 468.50 295.05 468.00 295.00 468.00 295.00 C 463.94 298.01 455.15 295.29 451.00 295.00 C 446.98 295.16 443.24 295.64 439.00 295.00 C 433.07 294.52 434.62 285.40 435.00 279.00 C 435.38 272.60 433.74 262.59 435.00 257.00 C 436.26 251.41 431.71 238.00 436.00 235.00 C 439.80 232.34 448.31 236.39 453.00 235.00 C 457.69 233.61 465.06 236.04 470.00 235.00 C 470.00 238.67 470.00 242.33 470.00 246.00 C 462.67 246.00 455.33 246.00 448.00 246.00 M 255.00 312.00  C 254.13 313.81 253.67 314.48 251.00 314.00 C 251.00 318.00 251.00 322.00 251.00 326.00 C 250.00 326.00 249.00 326.00 248.00 326.00 C 245.98 324.06 246.74 316.92 247.00 314.00 C 244.06 314.07 243.71 312.87 244.00 310.00 C 247.50 310.77 253.02 308.14 255.00 312.00 M 265.00 311.00  C 267.13 312.55 267.07 314.21 267.00 317.00 C 266.99 317.29 266.74 325.41 267.00 325.00 C 264.48 329.04 261.20 322.71 261.00 321.00 C 261.00 322.67 261.00 324.33 261.00 326.00 C 259.72 325.72 257.50 326.76 257.00 325.00 C 256.94 324.99 257.00 324.00 257.00 324.00 C 257.00 321.33 257.00 318.67 257.00 316.00 C 257.00 315.50 257.00 315.00 257.00 315.00 C 252.83 309.79 262.15 308.92 265.00 311.00 M 278.00 315.00  C 279.32 318.63 280.33 322.18 281.00 326.00 C 279.39 325.99 276.57 326.59 277.00 324.00 C 274.12 323.99 273.88 325.74 272.00 326.00 C 270.69 326.18 269.31 325.86 268.00 326.00 C 269.70 321.77 270.31 317.24 272.00 313.00 C 275.11 307.81 276.42 310.65 278.00 315.00 M 293.00 326.00  C 290.24 327.62 287.95 322.34 287.00 321.00 C 287.08 322.68 287.56 325.07 286.00 326.00 C 285.26 326.44 283.79 325.65 283.00 326.00 C 283.00 321.00 283.00 316.00 283.00 311.00 C 285.46 307.14 288.84 314.89 290.00 316.00 C 289.65 312.85 289.54 308.70 294.00 310.00 C 293.35 315.16 295.31 321.66 293.00 326.00 M 304.00 311.00  C 304.49 311.05 305.00 311.00 305.00 311.00 C 306.71 312.67 306.59 317.01 303.00 316.00 C 303.24 317.88 305.55 317.46 306.00 319.00 C 307.71 323.89 303.49 329.76 298.00 326.00 C 296.14 324.73 295.67 325.01 296.01 321.99 C 296.35 318.97 300.99 322.95 300.00 323.00 C 302.45 322.07 302.87 323.48 302.00 321.00 C 300.77 318.71 294.94 318.18 296.01 313.99 C 297.08 309.80 300.95 308.62 304.00 311.00 M 316.00 311.00  C 316.50 311.00 317.00 311.00 317.00 311.00 C 320.07 311.92 320.18 320.16 317.00 321.00 C 316.09 321.24 314.88 320.68 314.00 321.00 C 311.48 322.73 314.71 326.56 310.00 326.00 C 307.70 323.78 308.70 314.35 309.00 311.00 C 310.69 309.24 314.30 309.74 316.00 311.00 M 332.00 314.00  C 335.22 322.72 325.20 332.96 321.00 322.00 C 320.06 319.54 319.21 316.42 321.00 314.00 C 321.00 313.50 321.00 313.00 321.00 313.00 C 322.51 307.21 330.50 309.94 332.00 314.00 M 342.00 311.00  C 343.91 311.95 343.01 311.03 344.00 313.00 C 345.53 316.05 344.45 318.56 344.00 322.00 C 343.78 323.68 346.35 323.49 344.66 325.68 C 342.98 327.86 340.91 323.98 341.00 324.00 C 338.30 323.52 340.39 324.46 338.00 325.00 C 337.45 325.12 336.18 326.80 335.00 326.00 C 335.00 321.00 335.00 316.00 335.00 311.00 C 336.52 308.83 340.40 310.21 342.00 311.00 M 357.00 311.00  C 357.23 311.16 357.24 312.82 357.00 313.00 C 355.89 313.82 354.70 314.34 353.00 314.00 C 351.85 317.71 355.79 326.16 350.00 326.00 C 350.00 322.00 350.00 318.00 350.00 314.00 C 346.96 314.91 345.27 312.97 346.00 310.00 C 349.50 310.62 354.32 308.73 357.00 311.00 M 375.00 320.00  C 375.75 321.85 374.49 323.73 376.00 326.00 C 375.00 326.00 374.00 326.00 373.00 326.00 C 369.36 327.52 367.04 326.48 366.00 325.00 C 364.10 322.30 363.43 316.87 365.00 313.00 C 367.79 306.15 376.20 312.09 372.00 318.00 C 373.28 317.73 374.72 318.77 375.00 320.00 M 386.00 311.00  C 386.36 314.97 385.73 319.02 386.00 323.00 C 386.87 323.61 390.39 322.20 391.00 323.00 C 391.96 317.87 391.01 310.41 398.00 310.00 C 406.42 309.51 405.39 321.97 401.92 325.92 C 398.44 329.86 395.48 324.36 394.00 324.00 C 390.63 323.18 393.74 325.09 391.00 326.00 C 389.96 326.35 383.85 326.59 383.00 326.00 C 379.41 323.49 383.61 313.74 382.00 310.00 C 383.28 310.28 385.50 309.24 386.00 311.00 M 414.00 315.00  C 409.38 315.40 407.44 321.60 414.00 323.00 C 411.45 320.18 411.80 316.82 417.00 318.00 C 419.90 318.20 418.71 321.58 417.00 324.00 C 414.70 327.25 412.28 327.29 408.00 326.00 C 407.94 322.66 405.31 317.72 407.00 313.00 C 409.53 307.72 419.60 309.22 418.00 316.00 C 416.72 315.72 414.50 316.76 414.00 315.00 M 424.00 326.00  C 421.60 326.89 421.75 325.27 421.00 324.00 C 419.45 321.37 419.12 314.53 421.00 312.00 C 421.00 311.50 421.00 311.00 421.00 311.00 C 422.06 309.92 423.34 309.87 425.00 310.00 C 424.35 315.16 426.31 321.66 424.00 326.00 M 437.00 321.00  C 437.43 325.92 433.23 328.26 429.00 326.00 C 424.41 323.55 427.59 318.88 431.00 323.00 C 431.44 323.16 432.95 323.15 433.00 323.00 C 434.08 319.86 422.30 316.34 428.26 311.26 C 434.22 306.18 440.29 315.04 434.00 316.00 C 434.66 317.93 437.39 318.67 437.00 321.00 M 449.00 311.00  C 449.23 311.35 449.24 312.80 449.00 313.00 C 448.16 313.68 447.41 314.35 446.00 314.00 C 445.37 317.83 447.28 322.99 445.00 326.00 C 444.65 326.23 443.35 326.23 443.00 326.00 C 440.05 324.08 443.14 316.96 442.00 314.00 C 441.00 313.89 439.27 314.47 439.00 313.00 C 438.76 312.80 438.77 311.35 439.00 311.00 C 440.15 309.24 447.88 309.28 449.00 311.00 M 452.00 326.00  C 452.00 320.67 452.00 315.33 452.00 310.00 C 456.80 310.21 456.89 325.77 452.00 326.00 M 463.00 316.00  C 463.36 313.16 465.77 307.70 469.00 311.00 C 469.11 311.02 469.00 312.00 469.00 312.00 C 468.51 314.13 466.23 316.81 466.36 318.70 C 466.49 320.59 471.05 324.68 468.00 326.00 C 464.46 327.53 465.24 323.12 464.00 322.00 C 460.22 320.40 463.55 325.48 461.00 325.00 C 460.52 324.91 459.46 324.87 459.00 325.00 C 457.56 325.41 457.74 313.92 458.00 311.00 C 461.67 307.23 461.79 314.64 463.00 316.00 Z"
  }))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    fill: "#B1BEB7",
    fillOpacity: 0.08,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 134.00 125.00  C 136.91 122.22 138.44 119.55 143.00 122.00 C 139.17 119.01 135.82 119.95 134.00 125.00 Z"
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    fill: "#296B4E",
    fillOpacity: 0.95,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 134.00 125.00  C 134.00 125.00 134.22 125.64 134.00 126.00 C 132.05 129.14 130.12 132.97 127.00 135.00 C 127.00 135.00 127.16 135.56 127.00 136.00 C 125.89 139.07 123.19 141.90 121.00 144.00 C 121.00 144.00 121.16 144.56 121.00 145.00 C 120.12 147.45 118.56 148.27 117.00 150.00 C 114.42 152.84 111.74 156.23 111.00 160.00 C 110.91 160.48 111.00 161.00 111.00 161.00 C 109.50 163.41 107.75 165.00 106.00 167.00 C 103.38 170.93 100.07 177.35 96.00 180.00 C 96.00 180.00 96.23 180.64 96.00 181.00 C 94.91 182.73 92.46 187.31 95.00 189.00 C 99.76 191.13 106.38 185.84 110.78 184.78 C 115.17 183.72 120.53 181.32 125.00 180.00 C 125.76 179.78 126.33 176.92 128.00 178.00 C 129.16 185.74 128.27 193.03 119.00 192.00 C 111.10 193.55 103.78 196.54 97.00 201.00 C 95.68 202.11 94.33 203.86 93.00 205.00 C 89.36 208.64 85.70 214.70 81.00 217.00 C 80.60 217.20 80.00 217.00 80.00 217.00 C 71.87 227.29 66.00 240.71 66.00 254.00 C 66.30 257.15 68.35 261.83 66.00 265.00 C 66.00 265.50 66.00 266.00 66.00 266.00 C 66.00 268.65 65.82 271.36 66.00 274.00 C 66.30 275.86 67.57 278.70 68.00 281.00 C 66.64 285.14 72.04 287.41 70.00 291.00 C 75.34 290.12 74.19 281.25 77.25 277.25 C 80.31 273.24 81.90 268.49 84.00 264.00 C 85.86 260.03 88.71 256.70 91.00 253.00 C 92.58 250.44 93.72 248.95 96.00 247.00 C 100.04 243.55 103.70 239.01 108.00 236.00 C 112.06 233.16 116.51 229.58 121.00 227.00 C 123.05 225.42 124.23 223.61 127.00 223.00 C 127.00 223.00 127.53 223.11 128.00 223.00 C 130.54 220.96 132.92 219.99 136.00 219.00 C 150.20 214.45 163.10 212.71 178.00 213.00 C 179.30 213.03 180.71 212.83 182.00 213.00 C 183.36 212.82 185.96 211.09 188.00 212.00 C 190.08 208.91 186.18 207.52 185.00 205.00 C 182.74 203.32 180.57 202.40 179.00 200.00 C 179.00 200.00 178.43 200.17 178.00 200.00 C 175.44 198.99 173.16 197.21 171.00 196.00 C 165.16 193.59 158.79 189.54 152.00 190.00 C 151.50 190.03 151.00 190.00 151.00 190.00 C 150.07 190.62 148.85 179.05 151.00 179.00 C 152.76 178.96 152.85 179.53 154.00 180.00 C 158.22 181.71 162.67 182.77 167.00 184.00 C 169.71 184.77 171.67 185.99 174.00 187.00 C 175.34 187.41 176.68 187.63 178.00 188.00 C 180.29 188.31 182.70 187.77 185.00 188.00 C 185.23 186.17 184.93 184.53 184.00 183.00 C 182.92 180.87 178.12 179.71 180.00 177.00 C 180.00 177.00 180.16 176.44 180.00 176.00 C 176.95 174.02 174.75 170.11 173.00 167.00 C 170.55 162.65 167.81 158.35 165.00 154.00 C 162.79 151.28 160.84 149.11 159.00 146.00 C 154.77 138.87 149.65 127.20 143.00 122.00 C 138.44 119.55 136.91 122.22 134.00 125.00 Z"
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    fill: "#ABBCAE",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 127.00 135.00  C 130.12 132.97 132.05 129.14 134.00 126.00 C 131.25 127.79 128.14 131.85 127.00 135.00 Z"
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    fill: "#AEC1B6",
    fillOpacity: 0.12,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 121.00 144.00  C 123.19 141.90 125.89 139.07 127.00 136.00 C 124.81 138.10 122.11 140.94 121.00 144.00 Z"
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    fill: "#8BAA91",
    fillOpacity: 0.17,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 117.00 150.00  C 118.56 148.27 120.12 147.45 121.00 145.00 C 118.37 146.09 118.56 147.58 117.00 150.00 Z"
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    fill: "#A6B8AE",
    fillOpacity: 0.08,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 165.00 154.00  C 163.16 151.15 160.93 148.59 159.00 146.00 C 160.84 149.11 162.79 151.28 165.00 154.00 Z"
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    fill: "#BECFC5",
    fillOpacity: 0.06,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 96.00 180.00  C 100.07 177.35 103.38 170.93 106.00 167.00 C 107.63 164.55 108.49 162.75 111.00 161.00 C 111.00 161.00 110.91 160.48 111.00 160.00 C 105.72 161.10 98.92 175.31 96.00 180.00 Z"
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    fill: "#2F4E3D",
    fillOpacity: 0.56,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 106.00 167.00  C 107.75 165.00 109.50 163.41 111.00 161.00 C 108.49 162.75 107.63 164.55 106.00 167.00 Z"
  }))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    fill: "#182E47",
    fillOpacity: 0.96,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 298.00 168.00  C 294.57 170.19 292.71 174.23 290.00 177.00 C 290.00 177.00 290.00 177.50 290.00 178.00 C 290.00 189.33 289.99 200.67 290.00 212.00 C 290.00 212.00 290.02 212.50 290.00 213.00 C 291.98 217.09 295.91 219.77 299.00 223.00 C 299.00 223.00 299.51 222.92 300.00 223.00 C 305.70 223.94 310.33 223.13 316.00 223.00 C 316.00 223.00 316.56 223.16 317.00 223.00 C 317.75 222.28 318.17 221.64 319.00 221.00 C 321.18 218.84 322.52 215.57 325.00 214.00 C 325.22 213.64 325.00 212.50 325.00 212.00 C 325.00 201.00 325.00 190.00 325.00 179.00 C 325.00 178.50 325.00 177.50 325.00 177.00 C 325.00 177.00 325.09 176.48 325.00 176.00 C 323.73 174.02 320.89 170.54 319.00 169.00 C 313.11 164.92 304.39 164.77 298.00 168.00 M 311.00 178.00  C 312.70 177.80 311.62 177.07 313.00 178.00 C 317.96 181.35 315.85 191.11 316.00 196.00 C 316.15 200.89 317.93 212.56 311.00 213.00 C 310.50 213.03 310.00 213.00 310.00 213.00 C 306.86 215.45 302.69 213.45 301.00 210.00 C 300.80 209.60 301.00 209.00 301.00 209.00 C 297.27 207.30 299.03 199.80 299.00 196.00 C 298.97 192.20 298.06 184.47 300.00 181.00 C 300.53 180.05 302.89 178.47 304.00 178.00 C 306.79 176.82 308.57 177.87 311.00 178.00 Z"
  }))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    fill: "#CECFD8",
    fillOpacity: 0.07,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 450.00 167.00  C 454.31 166.52 457.88 167.90 462.00 168.00 C 458.05 165.84 454.18 166.03 450.00 167.00 Z"
  }))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    fill: "#A8BFAE",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 180.00 176.00  C 178.63 172.20 175.18 170.05 173.00 167.00 C 174.75 170.11 176.95 174.02 180.00 176.00 Z"
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    fill: "#C4C6CD",
    fillOpacity: 0.05,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 244.00 223.00  C 244.00 204.67 244.00 186.33 244.00 168.00 C 247.67 168.00 251.33 168.00 255.00 168.00 C 247.95 161.11 240.26 171.22 243.00 178.00 C 245.74 184.78 240.64 194.99 243.00 201.00 C 245.36 207.01 238.99 219.49 244.00 223.00 Z"
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    fill: "#B5B9C4",
    fillOpacity: 0.15,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 271.00 168.00  C 272.19 167.62 279.03 167.32 280.00 168.00 C 283.65 170.55 280.06 180.25 281.00 185.00 C 281.94 189.75 280.67 197.51 281.00 203.00 C 281.33 208.49 281.00 216.30 281.00 222.00 C 281.00 222.50 281.00 223.00 281.00 223.00 C 283.33 205.32 281.33 185.50 282.00 167.00 C 279.38 168.05 272.58 165.18 271.00 168.00 Z"
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    fill: "#B2B4BE",
    fillOpacity: 0.07,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 334.00 223.00  C 333.96 223.00 334.00 222.00 334.00 222.00 C 334.00 204.00 334.00 186.00 334.00 168.00 C 341.33 168.00 348.67 168.00 356.00 168.00 C 353.56 166.19 333.12 163.96 333.00 170.00 C 332.88 176.04 331.94 190.66 333.00 197.00 C 334.06 203.34 329.58 218.74 334.00 223.00 Z"
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    fill: "#9FA4AD",
    fillOpacity: 0.08,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 375.00 168.00  C 375.00 167.96 376.00 168.00 376.00 168.00 C 382.33 168.00 388.67 168.00 395.00 168.00 C 391.29 167.34 378.23 164.64 375.00 168.00 Z"
  }))), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    fill: "#888C99",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 418.00 223.00  C 417.96 223.00 418.00 222.00 418.00 222.00 C 418.00 204.58 416.43 186.34 418.00 169.00 C 419.62 167.31 422.67 168.15 425.00 168.00 C 419.06 167.60 415.97 167.78 417.00 175.00 C 418.03 182.22 416.24 185.04 417.00 191.00 C 417.76 196.96 416.00 202.83 417.00 208.00 C 418.00 213.17 414.52 219.65 418.00 223.00 Z"
  }))), _g296 || (_g296 = /*#__PURE__*/React.createElement("g", {
    fill: "#202538",
    fillOpacity: 0.6,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 425.00 168.00  C 422.67 168.15 419.62 167.31 418.00 169.00 C 418.00 168.96 419.00 169.00 419.00 169.00 C 432.30 169.00 427.42 179.42 428.00 190.00 C 428.58 200.58 427.57 210.49 428.00 221.00 C 424.63 221.40 422.42 221.40 419.00 221.00 C 418.95 221.35 418.12 221.74 418.00 222.00 C 418.00 222.00 417.96 223.00 418.00 223.00 C 419.99 223.18 427.45 224.09 429.00 223.00 C 428.44 217.34 429.75 210.55 429.00 205.00 C 428.25 199.45 430.44 192.14 429.00 187.00 C 427.56 181.86 431.92 172.14 429.00 168.00 C 427.64 166.75 426.51 167.90 425.00 168.00 Z"
  }))), _g297 || (_g297 = /*#__PURE__*/React.createElement("g", {
    fill: "#1B2F47",
    fillOpacity: 0.92,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 444.00 169.00  C 441.11 170.96 438.52 174.86 437.00 178.00 C 437.00 178.00 437.00 178.50 437.00 179.00 C 437.00 180.00 437.00 181.00 437.00 182.00 C 437.00 191.00 437.00 200.00 437.00 209.00 C 437.00 210.00 436.97 211.00 437.00 212.00 C 437.18 218.08 442.76 221.25 448.00 223.00 C 452.77 224.02 456.25 222.68 461.00 223.00 C 461.00 223.00 461.50 223.05 462.00 223.00 C 465.84 219.92 471.29 216.39 472.00 211.00 C 473.74 203.33 465.63 204.65 461.00 204.00 C 462.55 209.29 456.98 214.76 451.00 213.00 C 447.53 211.98 447.26 207.83 447.00 205.00 C 446.46 199.11 446.51 191.20 447.00 186.00 C 447.27 183.09 447.56 179.13 451.00 178.00 C 451.45 177.85 452.50 178.02 453.00 178.00 C 456.07 176.60 460.38 177.79 461.00 182.00 C 461.16 183.10 460.53 185.01 461.00 186.00 C 463.95 185.00 470.05 187.78 472.00 185.00 C 472.71 182.15 471.95 178.54 471.00 176.00 C 469.54 172.98 465.26 170.36 463.00 168.00 C 463.00 168.00 462.50 168.01 462.00 168.00 C 457.88 167.90 454.31 166.52 450.00 167.00 C 447.31 167.63 446.43 167.75 444.00 169.00 Z"
  }))), _g298 || (_g298 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2233",
    fillOpacity: 0.6,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 244.00 223.00  C 245.41 223.99 252.19 223.16 254.00 223.00 C 254.04 223.00 254.00 222.00 254.00 222.00 C 251.02 221.73 247.98 222.20 245.00 222.00 C 245.00 204.33 245.00 186.67 245.00 169.00 C 248.75 168.22 253.77 169.84 256.00 170.00 C 255.67 169.41 255.52 168.50 255.00 168.00 C 251.33 168.00 247.67 168.00 244.00 168.00 C 244.00 186.33 244.00 204.67 244.00 223.00 Z"
  }))), _g299 || (_g299 = /*#__PURE__*/React.createElement("g", {
    fill: "#14192A",
    fillOpacity: 0.66,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 272.00 169.00  C 274.39 169.34 278.40 169.53 280.00 168.00 C 279.03 167.32 272.19 167.62 271.00 168.00 C 270.90 168.19 271.65 168.95 272.00 169.00 Z"
  }))), _g300 || (_g300 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A304A",
    fillOpacity: 0.95,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 272.00 169.00  C 271.35 179.51 273.32 191.24 271.00 201.00 C 265.98 190.24 261.91 180.45 256.00 170.00 C 253.77 169.84 248.75 168.22 245.00 169.00 C 245.00 186.67 245.00 204.33 245.00 222.00 C 247.98 222.20 251.02 221.73 254.00 222.00 C 254.00 211.67 254.00 201.33 254.00 191.00 C 254.83 191.41 255.87 191.97 256.00 193.00 C 261.49 200.20 262.38 211.64 268.00 220.00 C 271.23 223.43 276.75 221.62 281.00 222.00 C 281.00 216.30 281.33 208.49 281.00 203.00 C 280.67 197.51 281.94 189.75 281.00 185.00 C 280.06 180.25 283.65 170.55 280.00 168.00 C 278.40 169.53 274.39 169.34 272.00 169.00 Z"
  }))), _g301 || (_g301 = /*#__PURE__*/React.createElement("g", {
    fill: "#B8B9C7",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 290.00 177.00  C 292.71 174.23 294.57 170.19 298.00 168.00 C 294.32 169.86 290.91 172.84 290.00 177.00 Z"
  }))), _g302 || (_g302 = /*#__PURE__*/React.createElement("g", {
    fill: "#1C2337",
    fillOpacity: 0.69,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 334.00 222.00  C 334.25 221.75 335.00 222.00 335.00 222.00 C 336.59 204.48 333.81 186.56 335.00 169.00 C 342.16 168.34 350.66 170.33 357.00 168.00 C 357.00 168.00 356.50 168.00 356.00 168.00 C 348.67 168.00 341.33 168.00 334.00 168.00 C 334.00 186.00 334.00 204.00 334.00 222.00 Z"
  }))), _g303 || (_g303 = /*#__PURE__*/React.createElement("g", {
    fill: "#193049",
    fillOpacity: 0.96,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 335.00 222.00  C 337.96 222.00 341.06 221.73 344.00 222.00 C 344.00 215.67 344.00 209.33 344.00 203.00 C 348.25 202.03 351.46 203.73 352.00 208.00 C 353.29 212.08 353.48 216.25 356.00 220.00 C 358.69 222.80 366.61 223.46 368.00 220.00 C 365.99 213.77 363.56 207.94 361.00 202.00 C 363.01 199.98 366.86 197.69 368.00 195.00 C 368.08 194.51 368.18 193.08 368.00 193.00 C 367.85 192.94 368.00 190.25 368.00 190.00 C 368.00 187.33 368.00 184.67 368.00 182.00 C 368.00 181.00 368.02 180.00 368.00 179.00 C 367.97 177.10 367.72 176.37 367.00 175.00 C 367.01 175.01 361.18 170.95 360.00 170.00 C 359.19 169.35 358.67 168.64 358.00 168.00 C 358.00 168.00 357.50 168.00 357.00 168.00 C 350.66 170.33 342.16 168.34 335.00 169.00 C 333.81 186.56 336.59 204.48 335.00 222.00 M 358.00 184.00  C 358.11 185.24 358.14 186.76 358.00 188.00 C 357.75 190.17 356.83 191.83 355.00 193.00 C 352.66 194.90 346.64 196.75 344.00 194.00 C 343.73 191.04 342.62 179.52 345.00 178.00 C 346.00 177.36 350.77 177.81 352.00 178.00 C 355.70 178.58 357.66 180.07 358.00 184.00 Z"
  }))), _g304 || (_g304 = /*#__PURE__*/React.createElement("g", {
    fill: "#A5A8B0",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 360.00 170.00  C 361.19 170.71 363.96 171.13 365.00 172.00 C 363.33 170.18 360.53 168.58 358.00 168.00 C 358.67 168.64 359.19 169.35 360.00 170.00 Z"
  }))), _g305 || (_g305 = /*#__PURE__*/React.createElement("g", {
    fill: "#494E5B",
    fillOpacity: 0.29,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 376.00 223.00  C 375.96 223.00 376.00 222.00 376.00 222.00 C 376.00 204.33 375.98 186.67 376.00 169.00 C 376.00 168.50 376.00 168.00 376.00 168.00 C 376.00 168.00 375.00 167.96 375.00 168.00 C 374.47 173.83 374.92 181.26 375.00 187.00 C 375.08 192.74 374.27 200.76 375.00 206.00 C 375.73 211.24 372.51 219.64 376.00 223.00 Z"
  }))), _g306 || (_g306 = /*#__PURE__*/React.createElement("g", {
    fill: "#10182B",
    fillOpacity: 0.71,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 376.00 169.00  C 382.31 169.57 389.52 168.16 395.00 168.00 C 388.67 168.00 382.33 168.00 376.00 168.00 C 376.00 168.00 376.00 168.50 376.00 169.00 Z"
  }))), _g307 || (_g307 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2F48",
    fillOpacity: 0.96,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 376.00 169.00  C 375.98 186.67 376.00 204.33 376.00 222.00 C 382.00 221.46 388.82 222.78 394.00 223.00 C 402.33 222.55 409.66 219.06 410.00 210.00 C 410.05 208.67 410.00 207.33 410.00 206.00 C 410.00 199.42 410.83 191.78 411.00 186.00 C 408.98 174.71 406.76 170.11 395.00 168.00 C 389.52 168.16 382.31 169.57 376.00 169.00 M 393.00 178.00  C 396.28 179.14 397.52 180.04 399.00 183.00 C 399.55 184.10 399.86 184.42 400.00 186.00 C 401.29 191.20 402.08 199.91 400.00 205.00 C 399.86 206.17 399.19 206.32 399.00 207.00 C 399.00 207.50 399.15 208.55 399.00 209.00 C 397.41 213.84 389.97 213.36 386.00 213.00 C 383.27 210.37 384.90 200.05 385.00 196.00 C 385.10 191.95 383.21 180.79 386.00 178.00 C 387.99 175.93 391.05 177.32 393.00 178.00 Z"
  }))), _g308 || (_g308 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 429.00 223.00  C 432.36 220.65 429.47 209.44 430.00 205.00 C 430.53 200.56 430.46 190.59 430.00 186.00 C 429.54 181.41 432.24 170.97 429.00 168.00 C 431.92 172.14 427.56 181.86 429.00 187.00 C 430.44 192.14 428.25 199.45 429.00 205.00 C 429.75 210.55 428.44 217.34 429.00 223.00 Z"
  }))), _g309 || (_g309 = /*#__PURE__*/React.createElement("g", {
    fill: "#C2CCD6",
    fillOpacity: 0.04,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 471.00 176.00  C 469.71 172.56 466.51 169.27 463.00 168.00 C 465.26 170.36 469.54 172.98 471.00 176.00 Z"
  }))), _g310 || (_g310 = /*#__PURE__*/React.createElement("g", {
    fill: "#BDBFD0",
    fillOpacity: 0.05,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 176.00  C 324.42 173.03 321.48 170.72 319.00 169.00 C 320.89 170.54 323.73 174.02 325.00 176.00 Z"
  }))), _g311 || (_g311 = /*#__PURE__*/React.createElement("g", {
    fill: "#0E162C",
    fillOpacity: 0.89,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 418.00 222.00  C 418.12 221.74 418.95 221.35 419.00 221.00 C 421.27 205.25 420.43 184.87 419.00 169.00 C 419.00 169.00 418.00 168.96 418.00 169.00 C 416.43 186.34 418.00 204.58 418.00 222.00 Z"
  }))), _g312 || (_g312 = /*#__PURE__*/React.createElement("g", {
    fill: "#152E49",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 419.00 221.00  C 422.42 221.40 424.63 221.40 428.00 221.00 C 427.57 210.49 428.58 200.58 428.00 190.00 C 427.42 179.42 432.30 169.00 419.00 169.00 C 420.43 184.87 421.27 205.25 419.00 221.00 Z"
  }))), _g313 || (_g313 = /*#__PURE__*/React.createElement("g", {
    fill: "#C8CCDC",
    fillOpacity: 0.07,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 437.00 178.00  C 438.52 174.86 441.11 170.96 444.00 169.00 C 440.38 170.87 437.33 173.52 437.00 178.00 Z"
  }))), _g314 || (_g314 = /*#__PURE__*/React.createElement("g", {
    fill: "#3D4352",
    fillOpacity: 0.48,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 367.00 175.00  C 366.49 174.04 365.76 172.82 365.00 172.00 C 363.96 171.13 361.19 170.71 360.00 170.00 C 361.18 170.95 367.01 175.01 367.00 175.00 Z"
  }))), _g315 || (_g315 = /*#__PURE__*/React.createElement("g", {
    fill: "#627D6D",
    fillOpacity: 0.35,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 184.00 183.00  C 182.79 180.36 182.70 178.76 180.00 177.00 C 178.12 179.71 182.92 180.87 184.00 183.00 Z"
  }))), _g316 || (_g316 = /*#__PURE__*/React.createElement("g", {
    fill: "#C4C3CB",
    fillOpacity: 0.08,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 304.00 178.00  C 306.16 177.46 308.78 178.26 311.00 178.00 C 308.57 177.87 306.79 176.82 304.00 178.00 Z"
  }))), _g317 || (_g317 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 311.00 178.00  C 308.78 178.26 306.16 177.46 304.00 178.00 C 302.89 178.47 300.53 180.05 300.00 181.00 C 298.89 183.41 300.49 189.91 300.00 194.00 C 299.51 198.09 299.61 205.09 301.00 209.00 C 301.00 209.00 300.80 209.60 301.00 210.00 C 303.52 212.68 306.32 213.40 310.00 213.00 C 310.00 213.00 310.50 213.03 311.00 213.00 C 315.55 209.00 315.59 201.89 315.00 196.00 C 314.41 190.11 316.44 181.14 313.00 178.00 C 311.62 177.07 312.70 177.80 311.00 178.00 Z"
  }))), _g318 || (_g318 = /*#__PURE__*/React.createElement("g", {
    fill: "#B3B4BA",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 179.00  C 325.69 180.63 326.78 184.38 327.00 186.00 C 327.02 182.89 327.63 179.01 325.00 177.00 C 325.00 177.50 325.00 178.50 325.00 179.00 Z"
  }))), _g319 || (_g319 = /*#__PURE__*/React.createElement("g", {
    fill: "#323644",
    fillOpacity: 0.5,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 386.00 178.00  C 386.00 177.96 387.00 178.00 387.00 178.00 C 388.91 178.00 391.13 177.68 393.00 178.00 C 391.05 177.32 387.99 175.93 386.00 178.00 Z"
  }))), _g320 || (_g320 = /*#__PURE__*/React.createElement("g", {
    fill: "#979CA5",
    fillOpacity: 0.17,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 453.00 178.00  C 455.77 177.89 460.21 178.97 461.00 182.00 C 460.38 177.79 456.07 176.60 453.00 178.00 Z"
  }))), _g321 || (_g321 = /*#__PURE__*/React.createElement("g", {
    fill: "#889E8F",
    fillOpacity: 0.14,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 125.00 180.00  C 129.15 178.51 126.04 187.27 127.00 190.00 C 123.77 188.61 121.27 191.26 119.00 192.00 C 128.27 193.03 129.16 185.74 128.00 178.00 C 126.33 176.92 125.76 179.78 125.00 180.00 Z"
  }))), _g322 || (_g322 = /*#__PURE__*/React.createElement("g", {
    fill: "#1F4B38",
    fillOpacity: 0.8,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 151.00 190.00  C 150.70 186.69 152.03 182.14 151.00 179.00 C 148.85 179.05 150.07 190.62 151.00 190.00 Z"
  }))), _g323 || (_g323 = /*#__PURE__*/React.createElement("g", {
    fill: "#32344A",
    fillOpacity: 0.6,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 289.00 181.00  C 288.23 190.00 287.90 201.04 289.00 210.00 C 289.16 211.32 289.42 211.13 290.00 212.00 C 289.99 200.67 290.00 189.33 290.00 178.00 C 288.93 179.15 289.15 179.30 289.00 181.00 Z"
  }))), _g324 || (_g324 = /*#__PURE__*/React.createElement("g", {
    fill: "#7B7C87",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 311.00 213.00  C 317.93 212.56 316.15 200.89 316.00 196.00 C 315.85 191.11 317.96 181.35 313.00 178.00 C 316.44 181.14 314.41 190.11 315.00 196.00 C 315.59 201.89 315.55 209.00 311.00 213.00 Z"
  }))), _g325 || (_g325 = /*#__PURE__*/React.createElement("g", {
    fill: "#7B8190",
    fillOpacity: 0.29,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 344.00 194.00  C 344.00 194.05 345.00 194.00 345.00 194.00 C 345.48 188.71 344.64 183.30 345.00 178.00 C 342.62 179.52 343.73 191.04 344.00 194.00 Z"
  }))), _g326 || (_g326 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 345.00 194.00  C 347.48 194.00 350.58 194.51 353.00 194.00 C 352.92 193.90 357.83 188.76 358.00 188.00 C 358.14 186.76 358.11 185.24 358.00 184.00 C 357.48 181.75 354.05 178.50 352.00 178.00 C 350.77 177.81 346.00 177.36 345.00 178.00 C 344.64 183.30 345.48 188.71 345.00 194.00 Z"
  }))), _g327 || (_g327 = /*#__PURE__*/React.createElement("g", {
    fill: "#A4B1BA",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 358.00 184.00  C 357.66 180.07 355.70 178.58 352.00 178.00 C 354.05 178.50 357.48 181.75 358.00 184.00 Z"
  }))), _g328 || (_g328 = /*#__PURE__*/React.createElement("g", {
    fill: "#1E263B",
    fillOpacity: 0.68,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 386.00 213.00  C 385.96 213.00 386.00 212.00 386.00 212.00 C 386.00 200.82 385.00 189.13 386.00 178.00 C 383.21 180.79 385.10 191.95 385.00 196.00 C 384.90 200.05 383.27 210.37 386.00 213.00 Z"
  }))), _g329 || (_g329 = /*#__PURE__*/React.createElement("g", {
    fill: "#D7D8EA",
    fillOpacity: 0.05,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 386.00 212.00  C 386.25 211.75 387.00 212.00 387.00 212.00 C 387.97 201.28 387.97 188.72 387.00 178.00 C 387.00 178.00 386.00 177.96 386.00 178.00 C 385.00 189.13 386.00 200.82 386.00 212.00 Z"
  }))), _g330 || (_g330 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 387.00 212.00  C 391.44 212.00 396.18 212.14 399.00 209.00 C 399.15 208.55 399.00 207.50 399.00 207.00 C 399.00 199.84 400.84 189.88 399.00 183.00 C 397.52 180.04 396.28 179.14 393.00 178.00 C 391.13 177.68 388.91 178.00 387.00 178.00 C 387.97 188.72 387.97 201.28 387.00 212.00 Z"
  }))), _g331 || (_g331 = /*#__PURE__*/React.createElement("g", {
    fill: "#A3A8B2",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 447.00 186.00  C 447.30 184.33 449.11 179.29 451.00 178.00 C 447.56 179.13 447.27 183.09 447.00 186.00 Z"
  }))), _g332 || (_g332 = /*#__PURE__*/React.createElement("g", {
    fill: "#BCD6CB",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 151.00 190.00  C 151.00 190.00 151.50 190.03 152.00 190.00 C 152.31 186.52 150.53 181.24 154.00 180.00 C 152.85 179.53 152.76 178.96 151.00 179.00 C 152.03 182.14 150.70 186.69 151.00 190.00 Z"
  }))), _g333 || (_g333 = /*#__PURE__*/React.createElement("g", {
    fill: "#172035",
    fillOpacity: 0.75,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 212.00  C 327.40 206.36 326.19 195.96 327.00 190.00 C 327.00 188.67 326.99 187.33 327.00 186.00 C 326.78 184.38 325.69 180.63 325.00 179.00 C 325.00 190.00 325.00 201.00 325.00 212.00 Z"
  }))), _g334 || (_g334 = /*#__PURE__*/React.createElement("g", {
    fill: "#B3B3B7",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 368.00 182.00  C 368.66 185.01 368.65 187.05 368.00 190.00 C 368.00 190.25 367.85 192.94 368.00 193.00 C 370.63 187.51 369.35 184.41 368.00 179.00 C 368.02 180.00 368.00 181.00 368.00 182.00 Z"
  }))), _g335 || (_g335 = /*#__PURE__*/React.createElement("g", {
    fill: "#BEBFCA",
    fillOpacity: 0.08,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 437.00 212.00  C 436.97 211.00 437.00 210.00 437.00 209.00 C 435.28 201.15 435.29 189.78 437.00 182.00 C 437.00 181.00 437.00 180.00 437.00 179.00 C 431.81 185.38 434.46 205.04 437.00 212.00 Z"
  }))), _g336 || (_g336 = /*#__PURE__*/React.createElement("g", {
    fill: "#BDCFC5",
    fillOpacity: 0.05,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 95.00 189.00  C 92.46 187.31 94.91 182.73 96.00 181.00 C 93.47 182.58 91.22 187.31 95.00 189.00 Z"
  }))), _g337 || (_g337 = /*#__PURE__*/React.createElement("g", {
    fill: "#C4C1D2",
    fillOpacity: 0.07,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 289.00 210.00  C 287.90 201.04 288.23 190.00 289.00 181.00 C 287.24 188.09 286.15 203.00 289.00 210.00 Z"
  }))), _g338 || (_g338 = /*#__PURE__*/React.createElement("g", {
    fill: "#616773",
    fillOpacity: 0.42,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 301.00 209.00  C 299.61 205.09 299.51 198.09 300.00 194.00 C 300.49 189.91 298.89 183.41 300.00 181.00 C 298.06 184.47 298.97 192.20 299.00 196.00 C 299.03 199.80 297.27 207.30 301.00 209.00 Z"
  }))), _g339 || (_g339 = /*#__PURE__*/React.createElement("g", {
    fill: "#1E202E",
    fillOpacity: 0.44,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 368.00 190.00  C 368.65 187.05 368.66 185.01 368.00 182.00 C 368.00 184.67 368.00 187.33 368.00 190.00 Z"
  }))), _g340 || (_g340 = /*#__PURE__*/React.createElement("g", {
    fill: "#232A3D",
    fillOpacity: 0.58,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 437.00 209.00  C 437.00 200.00 437.00 191.00 437.00 182.00 C 435.29 189.78 435.28 201.15 437.00 209.00 Z"
  }))), _g341 || (_g341 = /*#__PURE__*/React.createElement("g", {
    fill: "#91A59A",
    fillOpacity: 0.15,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 178.00 188.00  C 184.07 189.71 186.67 188.84 184.00 183.00 C 184.93 184.53 185.23 186.17 185.00 188.00 C 182.70 187.77 180.29 188.31 178.00 188.00 Z"
  }))), _g342 || (_g342 = /*#__PURE__*/React.createElement("g", {
    fill: "#AEACB7",
    fillOpacity: 0.15,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 399.00 207.00  C 399.19 206.32 399.86 206.17 400.00 205.00 C 400.72 199.13 400.51 191.90 400.00 186.00 C 399.86 184.42 399.55 184.10 399.00 183.00 C 400.84 189.88 399.00 199.84 399.00 207.00 Z"
  }))), _g343 || (_g343 = /*#__PURE__*/React.createElement("g", {
    fill: "#ACB9AF",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 174.00 187.00  C 171.67 185.99 169.71 184.77 167.00 184.00 C 169.10 184.82 171.57 186.25 174.00 187.00 Z"
  }))), _g344 || (_g344 = /*#__PURE__*/React.createElement("g", {
    fill: "#B0B0B9",
    fillOpacity: 0.03,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 461.00 186.00  C 462.66 189.49 471.64 186.44 472.00 185.00 C 470.05 187.78 463.95 185.00 461.00 186.00 Z"
  }))), _g345 || (_g345 = /*#__PURE__*/React.createElement("g", {
    fill: "#0C0F25",
    fillOpacity: 0.77,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 400.00 205.00  C 402.08 199.91 401.29 191.20 400.00 186.00 C 400.51 191.90 400.72 199.13 400.00 205.00 Z"
  }))), _g346 || (_g346 = /*#__PURE__*/React.createElement("g", {
    fill: "#101220",
    fillOpacity: 0.57,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 410.00 206.00  C 410.52 202.19 411.00 197.47 411.00 193.00 C 411.00 190.67 411.00 188.33 411.00 186.00 C 410.83 191.78 410.00 199.42 410.00 206.00 Z"
  }))), _g347 || (_g347 = /*#__PURE__*/React.createElement("g", {
    fill: "#C1C1C1",
    fillOpacity: 0.01,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 411.00 193.00  C 411.01 193.07 412.00 193.00 412.00 193.00 C 411.95 190.43 411.35 187.96 411.00 186.00 C 411.00 188.33 411.00 190.67 411.00 193.00 Z"
  }))), _g348 || (_g348 = /*#__PURE__*/React.createElement("g", {
    fill: "#9FA9B7",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 353.00 194.00  C 353.45 193.91 354.63 193.23 355.00 193.00 C 356.83 191.83 357.75 190.17 358.00 188.00 C 357.83 188.76 352.92 193.90 353.00 194.00 Z"
  }))), _g349 || (_g349 = /*#__PURE__*/React.createElement("g", {
    fill: "#B3B6C4",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 212.00  C 325.00 212.50 325.22 213.64 325.00 214.00 C 329.54 210.52 327.00 195.54 327.00 190.00 C 326.19 195.96 327.40 206.36 325.00 212.00 Z"
  }))), _g350 || (_g350 = /*#__PURE__*/React.createElement("g", {
    fill: "#6C6D7E",
    fillOpacity: 0.29,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 254.00 222.00  C 254.00 222.00 254.04 223.00 254.00 223.00 C 256.41 220.68 255.37 211.77 255.00 208.00 C 254.63 204.23 256.51 195.94 256.00 193.00 C 255.87 191.97 254.83 191.41 254.00 191.00 C 254.00 201.33 254.00 211.67 254.00 222.00 Z"
  }))), _g351 || (_g351 = /*#__PURE__*/React.createElement("g", {
    fill: "#2B3445",
    fillOpacity: 0.6,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 353.00 194.00  C 350.58 194.51 347.48 194.00 345.00 194.00 C 345.00 194.00 344.00 194.05 344.00 194.00 C 346.64 196.75 352.66 194.90 355.00 193.00 C 354.63 193.23 353.45 193.91 353.00 194.00 Z"
  }))), _g352 || (_g352 = /*#__PURE__*/React.createElement("g", {
    fill: "#9A9BB6",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 410.00 206.00  C 410.00 207.33 410.05 208.67 410.00 210.00 C 411.55 204.62 412.13 199.31 412.00 193.00 C 412.00 193.00 411.01 193.07 411.00 193.00 C 411.00 197.47 410.52 202.19 410.00 206.00 Z"
  }))), _g353 || (_g353 = /*#__PURE__*/React.createElement("g", {
    fill: "#BFC2CF",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 361.00 202.00  C 363.88 201.34 367.51 198.04 368.00 195.00 C 366.86 197.69 363.01 199.98 361.00 202.00 Z"
  }))), _g354 || (_g354 = /*#__PURE__*/React.createElement("g", {
    fill: "#AAC1AE",
    fillOpacity: 0.06,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 178.00 200.00  C 176.37 197.40 173.60 197.07 171.00 196.00 C 173.16 197.21 175.44 198.99 178.00 200.00 Z"
  }))), _g355 || (_g355 = /*#__PURE__*/React.createElement("g", {
    fill: "#A6B0AF",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 185.00 205.00  C 187.36 206.75 189.03 209.03 191.00 211.00 C 196.31 216.31 199.85 221.04 204.00 227.00 C 199.90 217.79 190.41 204.12 179.00 200.00 C 180.57 202.40 182.74 203.32 185.00 205.00 Z"
  }))), _g356 || (_g356 = /*#__PURE__*/React.createElement("g", {
    fill: "#A8B8AF",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 80.00 217.00  C 80.00 217.00 80.60 217.20 81.00 217.00 C 84.15 212.49 88.90 208.50 93.00 205.00 C 94.33 203.86 95.68 202.11 97.00 201.00 C 90.30 205.41 84.99 210.68 80.00 217.00 Z"
  }))), _g357 || (_g357 = /*#__PURE__*/React.createElement("g", {
    fill: "#747886",
    fillOpacity: 0.3,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 344.00 222.00  C 344.00 222.50 344.00 223.00 344.00 223.00 C 346.32 217.66 344.34 210.16 345.00 204.00 C 348.41 203.06 350.85 205.44 352.00 208.00 C 351.46 203.73 348.25 202.03 344.00 203.00 C 344.00 209.33 344.00 215.67 344.00 222.00 Z"
  }))), _g358 || (_g358 = /*#__PURE__*/React.createElement("g", {
    fill: "#274C37",
    fillOpacity: 0.64,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 81.00 217.00  C 85.70 214.70 89.36 208.64 93.00 205.00 C 88.90 208.50 84.15 212.49 81.00 217.00 Z"
  }))), _g359 || (_g359 = /*#__PURE__*/React.createElement("g", {
    fill: "#274E49",
    fillOpacity: 0.82,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 182.00 213.00  C 183.08 213.14 183.99 213.96 185.00 214.00 C 186.07 213.60 190.61 212.57 191.00 211.00 C 189.03 209.03 187.36 206.75 185.00 205.00 C 186.18 207.52 190.08 208.91 188.00 212.00 C 185.96 211.09 183.36 212.82 182.00 213.00 Z"
  }))), _g360 || (_g360 = /*#__PURE__*/React.createElement("g", {
    fill: "#B6B8CA",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 451.00 213.00  C 449.28 212.30 447.20 206.25 447.00 205.00 C 447.26 207.83 447.53 211.98 451.00 213.00 Z"
  }))), _g361 || (_g361 = /*#__PURE__*/React.createElement("g", {
    fill: "#999FAD",
    fillOpacity: 0.25,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 387.00 212.00  C 387.00 212.00 386.25 211.75 386.00 212.00 C 386.00 212.00 385.96 213.00 386.00 213.00 C 389.97 213.36 397.41 213.84 399.00 209.00 C 396.18 212.14 391.44 212.00 387.00 212.00 Z"
  }))), _g362 || (_g362 = /*#__PURE__*/React.createElement("g", {
    fill: "#C7C8CB",
    fillOpacity: 0.06,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 310.00 213.00  C 306.32 213.40 303.52 212.68 301.00 210.00 C 302.69 213.45 306.86 215.45 310.00 213.00 Z"
  }))), _g363 || (_g363 = /*#__PURE__*/React.createElement("g", {
    fill: "#18334C",
    fillOpacity: 0.96,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 185.00 214.00  C 182.81 214.82 174.94 214.73 170.00 215.00 C 160.77 215.50 150.93 217.58 143.00 222.00 C 138.85 224.31 134.42 226.79 130.00 229.00 C 124.92 231.54 118.00 234.97 115.00 240.00 C 114.81 240.32 114.32 240.80 114.00 241.00 C 110.79 245.12 106.59 248.41 103.00 252.00 C 98.62 257.13 95.68 263.51 91.00 268.00 C 91.00 268.00 91.17 268.57 91.00 269.00 C 89.47 272.91 86.76 276.52 85.00 280.00 C 83.19 284.91 81.72 289.77 81.00 294.00 C 80.70 295.74 80.61 297.33 80.00 299.00 C 78.58 302.86 77.67 302.58 80.00 307.00 C 84.51 313.44 92.54 317.61 97.00 324.00 C 97.00 324.00 97.56 323.84 98.00 324.00 C 101.46 325.25 104.06 328.36 107.00 330.00 C 111.46 331.99 115.13 333.02 120.00 334.00 C 121.62 334.33 123.81 335.78 125.00 336.00 C 126.95 336.21 129.04 336.00 131.00 336.00 C 136.00 336.00 141.00 336.00 146.00 336.00 C 148.28 336.00 150.74 336.26 153.00 336.00 C 154.29 335.75 156.29 334.34 158.00 334.00 C 164.29 332.74 169.93 330.86 175.00 328.00 C 175.90 327.32 176.21 325.29 178.00 326.00 C 178.05 323.60 176.03 321.96 175.00 320.00 C 171.26 315.75 167.96 307.94 164.92 303.08 C 161.88 298.22 160.20 286.46 157.00 288.00 C 156.11 286.59 158.06 285.09 158.00 284.00 C 156.47 276.21 155.72 268.06 157.00 260.00 C 157.08 258.07 157.72 255.38 158.00 254.00 C 158.60 251.08 159.20 249.25 161.00 247.00 C 161.00 247.00 160.89 246.47 161.00 246.00 C 161.61 243.40 162.64 240.47 165.00 239.00 C 165.00 239.00 164.84 238.44 165.00 238.00 C 165.68 236.10 167.46 233.28 169.00 232.00 C 171.37 227.95 174.76 224.56 180.00 223.00 C 181.98 222.41 184.13 221.79 186.00 221.00 C 187.04 219.57 187.90 218.50 190.00 219.00 C 189.02 221.01 186.64 221.64 185.00 223.00 C 185.00 223.00 184.40 222.80 184.00 223.00 C 182.05 225.79 179.22 227.66 177.00 230.00 C 175.67 231.64 174.27 233.22 173.00 235.00 C 171.30 238.14 169.61 241.95 168.00 245.00 C 166.51 249.15 166.00 252.35 166.00 257.00 C 166.00 261.67 166.00 266.33 166.00 271.00 C 166.00 272.96 165.80 275.05 166.00 277.00 C 166.72 280.49 168.97 285.03 170.00 289.00 C 170.58 291.22 171.07 292.96 172.00 295.00 C 173.76 297.91 176.06 300.88 178.00 304.00 C 178.00 304.00 177.84 304.56 178.00 305.00 C 181.36 307.19 184.86 312.54 187.00 316.00 C 187.20 316.32 187.69 316.80 188.00 317.00 C 190.94 316.38 196.98 309.18 199.00 307.00 C 201.86 303.07 203.90 299.20 206.00 295.00 C 207.18 291.80 208.58 288.88 210.00 286.00 C 211.38 282.18 212.02 279.29 212.00 275.00 C 211.99 273.67 212.00 272.33 212.00 271.00 C 212.00 264.67 212.00 258.33 212.00 252.00 C 212.00 250.67 212.00 249.33 212.00 248.00 C 212.00 247.01 212.05 245.99 212.00 245.00 C 211.32 242.00 208.93 238.33 208.00 235.00 C 206.82 230.77 205.67 229.40 204.00 227.00 C 199.85 221.04 196.31 216.31 191.00 211.00 C 190.61 212.57 186.07 213.60 185.00 214.00 M 161.00 226.00  C 159.75 227.83 150.91 236.41 149.00 232.00 C 146.81 230.80 153.00 227.52 154.00 227.00 C 155.23 226.36 156.68 225.73 158.00 225.00 C 160.74 223.48 163.51 222.34 161.00 226.00 M 144.00 241.00  C 142.92 244.08 139.95 245.76 138.00 248.00 C 136.35 250.56 135.50 253.61 134.00 256.00 C 131.71 259.66 128.82 259.36 124.00 259.00 C 124.95 258.13 124.54 256.32 126.00 256.00 C 126.79 254.89 127.26 254.15 128.00 253.00 C 130.16 249.65 132.09 246.61 135.00 244.00 C 136.81 242.37 141.18 237.81 144.00 241.00 M 126.00 280.00  C 125.93 282.33 126.00 284.67 126.00 287.00 C 126.00 292.17 128.21 303.44 126.00 308.00 C 124.84 310.40 117.19 311.27 114.00 310.00 C 113.01 309.60 113.12 308.97 113.00 308.00 C 111.56 304.47 111.59 299.47 113.00 296.00 C 113.12 294.99 113.89 294.52 114.00 294.00 C 114.14 286.95 115.91 280.51 118.00 274.00 C 121.03 274.26 124.37 273.26 127.00 275.00 C 125.79 276.40 126.02 278.26 126.00 280.00 Z"
  }))), _g364 || (_g364 = /*#__PURE__*/React.createElement("g", {
    fill: "#ACAFBA",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 462.00 223.00  C 467.37 222.50 471.76 215.96 472.00 211.00 C 471.29 216.39 465.84 219.92 462.00 223.00 Z"
  }))), _g365 || (_g365 = /*#__PURE__*/React.createElement("g", {
    fill: "#9EABB4",
    fillOpacity: 0.16,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 170.00 215.00  C 174.94 214.73 182.81 214.82 185.00 214.00 C 183.99 213.96 183.08 213.14 182.00 213.00 C 180.71 212.83 179.30 213.03 178.00 213.00 C 176.08 213.26 171.98 214.68 170.00 215.00 Z"
  }))), _g366 || (_g366 = /*#__PURE__*/React.createElement("g", {
    fill: "#ABADB5",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 299.00 223.00  C 295.91 219.77 291.98 217.09 290.00 213.00 C 289.85 217.35 295.10 222.14 299.00 223.00 Z"
  }))), _g367 || (_g367 = /*#__PURE__*/React.createElement("g", {
    fill: "#313947",
    fillOpacity: 0.53,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 319.00 221.00  C 321.24 219.29 323.60 217.19 325.00 215.00 C 325.00 215.00 324.76 214.18 325.00 214.00 C 322.52 215.57 321.18 218.84 319.00 221.00 Z"
  }))), _g368 || (_g368 = /*#__PURE__*/React.createElement("g", {
    fill: "#B1B9C2",
    fillOpacity: 0.08,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 319.00 221.00  C 318.17 221.64 317.75 222.28 317.00 223.00 C 320.16 221.86 324.34 218.40 325.00 215.00 C 323.60 217.19 321.24 219.29 319.00 221.00 Z"
  }))), _g369 || (_g369 = /*#__PURE__*/React.createElement("g", {
    fill: "#AAC3AF",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 128.00 223.00  C 131.13 222.27 133.35 220.23 136.00 219.00 C 132.92 219.99 130.54 220.96 128.00 223.00 Z"
  }))), _g370 || (_g370 = /*#__PURE__*/React.createElement("g", {
    fill: "#9DA1B9",
    fillOpacity: 0.19,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 186.00 221.00  C 185.73 221.38 185.49 222.76 185.00 223.00 C 186.64 221.64 189.02 221.01 190.00 219.00 C 187.90 218.50 187.04 219.57 186.00 221.00 Z"
  }))), _g371 || (_g371 = /*#__PURE__*/React.createElement("g", {
    fill: "#666775",
    fillOpacity: 0.21,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 281.00 223.00  C 281.00 223.00 281.00 222.50 281.00 222.00 C 276.75 221.62 271.23 223.43 268.00 220.00 C 270.76 224.10 275.82 223.47 281.00 223.00 Z"
  }))), _g372 || (_g372 = /*#__PURE__*/React.createElement("g", {
    fill: "#60636F",
    fillOpacity: 0.35,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 368.00 220.00  C 366.61 223.46 358.69 222.80 356.00 220.00 C 357.20 226.19 366.33 221.28 370.00 223.00 C 371.05 221.31 368.25 220.78 368.00 220.00 Z"
  }))), _g373 || (_g373 = /*#__PURE__*/React.createElement("g", {
    fill: "#A3A6B2",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 130.00 229.00  C 134.42 226.79 138.85 224.31 143.00 222.00 C 138.22 223.97 134.20 226.37 130.00 229.00 Z"
  }))), _g374 || (_g374 = /*#__PURE__*/React.createElement("g", {
    fill: "#504F61",
    fillOpacity: 0.36,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 334.00 223.00  C 337.15 223.29 340.85 223.28 344.00 223.00 C 344.00 223.00 344.00 222.50 344.00 222.00 C 341.06 221.73 337.96 222.00 335.00 222.00 C 335.00 222.00 334.25 221.75 334.00 222.00 C 334.00 222.00 333.96 223.00 334.00 223.00 Z"
  }))), _g375 || (_g375 = /*#__PURE__*/React.createElement("g", {
    fill: "#2F364A",
    fillOpacity: 0.53,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 376.00 223.00  C 381.78 223.52 388.21 223.31 394.00 223.00 C 388.82 222.78 382.00 221.46 376.00 222.00 C 376.00 222.00 375.96 223.00 376.00 223.00 Z"
  }))), _g376 || (_g376 = /*#__PURE__*/React.createElement("g", {
    fill: "#8CAB98",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 121.00 227.00  C 123.21 225.73 125.59 225.25 127.00 223.00 C 124.23 223.61 123.05 225.42 121.00 227.00 Z"
  }))), _g377 || (_g377 = /*#__PURE__*/React.createElement("g", {
    fill: "#8B97A3",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 158.00 225.00  C 160.06 223.10 157.14 228.13 156.00 229.00 C 157.36 228.17 160.01 227.08 161.00 226.00 C 163.51 222.34 160.74 223.48 158.00 225.00 Z"
  }))), _g378 || (_g378 = /*#__PURE__*/React.createElement("g", {
    fill: "#485064",
    fillOpacity: 0.46,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 169.00 232.00  C 169.55 231.54 170.48 231.40 171.00 231.00 C 173.82 228.81 176.71 224.95 180.00 223.00 C 174.76 224.56 171.37 227.95 169.00 232.00 Z"
  }))), _g379 || (_g379 = /*#__PURE__*/React.createElement("g", {
    fill: "#B4B9C9",
    fillOpacity: 0.04,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 177.00 230.00  C 179.22 227.66 182.05 225.79 184.00 223.00 C 181.21 224.36 178.93 227.63 177.00 230.00 Z"
  }))), _g380 || (_g380 = /*#__PURE__*/React.createElement("g", {
    fill: "#B1B4BE",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 316.00 223.00  C 310.33 223.13 305.70 223.94 300.00 223.00 C 304.11 226.34 311.73 225.33 316.00 223.00 Z"
  }))), _g381 || (_g381 = /*#__PURE__*/React.createElement("g", {
    fill: "#9A9CA7",
    fillOpacity: 0.18,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 461.00 223.00  C 456.25 222.68 452.77 224.02 448.00 223.00 C 452.68 224.56 456.28 225.06 461.00 223.00 Z"
  }))), _g382 || (_g382 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 154.00 227.00  C 151.41 228.70 151.21 229.73 151.00 232.00 C 152.62 231.23 154.61 229.84 156.00 229.00 C 157.14 228.13 160.06 223.10 158.00 225.00 C 156.68 225.73 155.23 226.36 154.00 227.00 Z"
  }))), _g383 || (_g383 = /*#__PURE__*/React.createElement("g", {
    fill: "#364051",
    fillOpacity: 0.48,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 156.00 229.00  C 154.61 229.84 152.62 231.23 151.00 232.00 C 150.59 232.19 149.08 232.18 149.00 232.00 C 150.91 236.41 159.75 227.83 161.00 226.00 C 160.01 227.08 157.36 228.17 156.00 229.00 Z"
  }))), _g384 || (_g384 = /*#__PURE__*/React.createElement("g", {
    fill: "#AEB1C2",
    fillOpacity: 0.07,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 149.00 232.00  C 149.08 232.18 150.59 232.19 151.00 232.00 C 151.21 229.73 151.41 228.70 154.00 227.00 C 153.00 227.52 146.81 230.80 149.00 232.00 Z"
  }))), _g385 || (_g385 = /*#__PURE__*/React.createElement("g", {
    fill: "#A5A7B5",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 169.00 232.00  C 167.46 233.28 165.68 236.10 165.00 238.00 C 167.70 236.24 168.89 233.42 171.00 231.00 C 170.48 231.40 169.55 231.54 169.00 232.00 Z"
  }))), _g386 || (_g386 = /*#__PURE__*/React.createElement("g", {
    fill: "#6A707C",
    fillOpacity: 0.24,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 303.00 235.00  C 308.56 233.03 316.39 233.55 322.00 235.00 C 317.94 233.37 306.68 230.20 303.00 235.00 Z"
  }))), _g387 || (_g387 = /*#__PURE__*/React.createElement("g", {
    fill: "#193048",
    fillOpacity: 0.95,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 303.00 235.00  C 303.00 235.00 302.48 234.90 302.00 235.00 C 299.71 236.46 295.73 239.80 294.00 242.00 C 292.92 243.97 292.13 244.60 292.00 247.00 C 291.94 247.99 292.00 249.01 292.00 250.00 C 292.00 260.00 292.00 270.00 292.00 280.00 C 292.00 281.00 292.00 282.00 292.00 283.00 C 292.00 283.00 291.90 283.52 292.00 284.00 C 295.18 287.25 297.75 292.83 302.00 295.00 C 303.87 295.74 304.93 295.85 307.00 296.00 C 310.53 296.26 314.47 296.26 318.00 296.00 C 320.05 295.85 321.16 295.71 323.00 295.00 C 324.40 294.29 326.54 292.07 328.00 291.00 C 331.70 288.30 332.88 285.82 334.00 281.00 C 335.04 271.68 335.67 258.21 334.00 249.00 C 332.32 244.26 330.24 237.14 322.00 235.00 C 316.39 233.55 308.56 233.03 303.00 235.00 M 318.00 247.00  C 321.33 248.56 321.64 250.78 322.00 254.00 C 322.76 260.83 322.62 269.15 322.00 276.00 C 321.75 278.72 321.44 283.12 318.00 284.00 C 317.13 284.22 315.90 283.98 315.00 284.00 C 309.97 285.10 306.15 284.97 304.00 279.00 C 303.84 278.56 304.00 278.00 304.00 278.00 C 300.85 273.75 302.27 256.57 304.00 252.00 C 306.34 245.82 312.58 244.46 318.00 247.00 Z"
  }))), _g388 || (_g388 = /*#__PURE__*/React.createElement("g", {
    fill: "#AEB8C1",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 168.00 245.00  C 169.61 241.95 171.30 238.14 173.00 235.00 C 170.86 237.99 169.29 241.43 168.00 245.00 Z"
  }))), _g389 || (_g389 = /*#__PURE__*/React.createElement("g", {
    fill: "#A09EA8",
    fillOpacity: 0.14,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 212.00 245.00  C 211.79 241.00 209.25 238.08 208.00 235.00 C 208.93 238.33 211.32 242.00 212.00 245.00 Z"
  }))), _g390 || (_g390 = /*#__PURE__*/React.createElement("g", {
    fill: "#CBCCCD",
    fillOpacity: 0.04,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 244.00 294.00  C 242.66 284.68 244.19 274.44 244.00 265.00 C 243.81 255.56 243.15 245.41 244.00 236.00 C 244.06 236.04 242.08 249.28 243.00 254.00 C 243.92 258.72 242.03 269.69 243.00 275.00 C 243.97 280.31 240.83 289.69 244.00 294.00 Z"
  }))), _g391 || (_g391 = /*#__PURE__*/React.createElement("g", {
    fill: "#383D4B",
    fillOpacity: 0.51,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 245.00 236.00  C 252.25 236.80 260.54 235.38 267.00 235.00 C 261.64 234.80 249.07 232.99 245.00 236.00 Z"
  }))), _g392 || (_g392 = /*#__PURE__*/React.createElement("g", {
    fill: "#193049",
    fillOpacity: 0.95,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 245.00 236.00  C 245.96 246.59 244.13 259.62 245.00 270.00 C 245.87 280.38 239.90 298.00 256.00 294.00 C 255.40 287.39 256.45 280.63 256.00 274.00 C 259.84 273.64 263.55 273.48 264.00 278.00 C 264.91 280.18 265.02 282.77 266.00 285.00 C 267.16 286.76 267.74 286.78 268.00 288.00 C 268.34 289.56 267.99 290.62 269.00 292.00 C 269.18 292.25 270.81 293.85 271.00 294.00 C 273.47 295.13 283.09 295.05 282.00 291.00 C 283.39 291.26 282.78 293.05 283.00 294.00 C 284.84 291.63 281.48 286.65 280.00 284.00 C 278.57 281.43 277.19 278.90 276.00 276.00 C 276.00 276.00 275.98 275.50 276.00 275.00 C 273.34 271.58 280.27 268.70 282.00 266.00 C 282.00 266.00 281.84 265.44 282.00 265.00 C 282.67 263.11 283.78 259.56 284.00 258.00 C 284.28 252.78 284.09 248.57 282.00 244.00 C 281.78 243.75 281.00 244.00 281.00 244.00 C 279.36 242.18 276.00 239.39 275.00 237.00 C 272.71 234.67 270.07 235.12 267.00 235.00 C 260.54 235.38 252.25 236.80 245.00 236.00 M 265.00 263.00  C 262.48 263.85 259.17 264.43 256.00 264.00 C 256.66 258.17 254.68 251.01 257.00 246.00 C 266.56 239.31 278.54 258.43 265.00 263.00 Z"
  }))), _g393 || (_g393 = /*#__PURE__*/React.createElement("g", {
    fill: "#A4A6AD",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 294.00 242.00  C 295.73 239.80 299.71 236.46 302.00 235.00 C 297.98 235.88 295.79 238.71 294.00 242.00 Z"
  }))), _g394 || (_g394 = /*#__PURE__*/React.createElement("g", {
    fill: "#737D85",
    fillOpacity: 0.36,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 343.00 281.00  C 343.00 266.00 343.00 251.00 343.00 236.00 C 343.00 235.50 343.00 235.00 343.00 235.00 C 339.10 238.75 342.65 252.21 342.00 258.00 C 341.35 263.79 340.83 275.88 343.00 281.00 Z"
  }))), _g395 || (_g395 = /*#__PURE__*/React.createElement("g", {
    fill: "#3E4554",
    fillOpacity: 0.57,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 343.00 236.00  C 346.64 236.33 350.36 235.75 354.00 236.00 C 354.42 244.18 353.44 253.99 354.00 262.00 C 354.56 270.01 351.04 279.46 359.00 284.00 C 350.59 269.93 357.01 251.10 355.00 235.00 C 351.02 235.27 346.97 234.64 343.00 235.00 C 343.00 235.00 343.00 235.50 343.00 236.00 Z"
  }))), _g396 || (_g396 = /*#__PURE__*/React.createElement("g", {
    fill: "#C7CAD2",
    fillOpacity: 0.15,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 371.00 278.00  C 371.02 277.90 372.00 278.00 372.00 278.00 C 373.26 264.11 370.74 249.89 372.00 236.00 C 372.11 236.07 370.22 251.15 371.00 256.00 C 371.78 260.85 370.50 272.52 371.00 278.00 Z"
  }))), _g397 || (_g397 = /*#__PURE__*/React.createElement("g", {
    fill: "#28323F",
    fillOpacity: 0.67,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 373.00 236.00  C 376.33 236.00 379.67 236.00 383.00 236.00 C 383.50 236.00 384.00 236.00 384.00 236.00 C 384.00 235.50 384.00 235.00 384.00 235.00 C 380.84 234.71 375.35 234.26 373.00 236.00 Z"
  }))), _g398 || (_g398 = /*#__PURE__*/React.createElement("g", {
    fill: "#B3B5BA",
    fillOpacity: 0.07,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 384.00 236.00  C 384.00 250.31 385.72 265.81 384.00 280.00 C 383.82 281.47 383.45 283.56 383.00 285.00 C 385.70 279.29 386.16 266.59 385.00 260.00 C 383.84 253.41 388.51 239.34 384.00 235.00 C 384.00 235.00 384.00 235.50 384.00 236.00 Z"
  }))), _g399 || (_g399 = /*#__PURE__*/React.createElement("g", {
    fill: "#303644",
    fillOpacity: 0.62,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 391.00 246.00  C 390.76 245.82 391.00 245.00 391.00 245.00 C 391.00 242.00 391.00 239.00 391.00 236.00 C 403.33 236.00 415.67 236.00 428.00 236.00 C 428.00 239.00 428.00 242.00 428.00 245.00 C 428.00 245.50 428.00 246.00 428.00 246.00 C 428.00 246.00 428.74 246.25 429.00 246.00 C 429.16 244.19 429.99 237.41 429.00 236.00 C 416.99 233.67 402.83 235.67 390.00 235.00 C 390.81 238.24 388.50 243.60 391.00 246.00 Z"
  }))), _g400 || (_g400 = /*#__PURE__*/React.createElement("g", {
    fill: "#414758",
    fillOpacity: 0.47,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 439.00 295.00  C 437.55 294.78 436.84 295.39 436.00 294.00 C 433.12 289.26 437.26 280.77 436.00 275.00 C 434.74 269.23 436.66 261.20 436.00 255.00 C 435.34 248.80 436.49 241.32 436.00 235.00 C 431.71 238.00 436.26 251.41 435.00 257.00 C 433.74 262.59 435.38 272.60 435.00 279.00 C 434.62 285.40 433.07 294.52 439.00 295.00 Z"
  }))), _g401 || (_g401 = /*#__PURE__*/React.createElement("g", {
    fill: "#172D46",
    fillOpacity: 0.97,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 436.00 294.00  C 446.70 295.12 459.17 292.06 469.00 295.00 C 469.35 294.96 469.95 294.35 470.00 294.00 C 469.16 291.19 468.56 287.47 469.00 284.00 C 461.83 283.34 453.34 285.33 447.00 283.00 C 445.81 281.31 446.78 272.11 448.00 271.00 C 452.10 267.28 462.67 273.30 466.00 270.00 C 467.10 268.38 466.00 262.05 466.00 260.00 C 462.04 260.36 449.55 261.66 447.00 259.00 C 446.75 256.28 445.84 247.52 448.00 246.00 C 455.33 246.00 462.67 246.00 470.00 246.00 C 470.00 242.33 470.00 238.67 470.00 235.00 C 465.06 236.04 457.69 233.61 453.00 235.00 C 448.31 236.39 439.80 232.34 436.00 235.00 C 436.49 241.32 435.34 248.80 436.00 255.00 C 436.66 261.20 434.74 269.23 436.00 275.00 C 437.26 280.77 433.12 289.26 436.00 294.00 Z"
  }))), _g402 || (_g402 = /*#__PURE__*/React.createElement("g", {
    fill: "#A7C7AE",
    fillOpacity: 0.06,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 96.00 247.00  C 95.58 247.45 95.11 248.40 95.00 249.00 C 99.97 245.52 103.37 239.80 108.00 236.00 C 103.70 239.01 100.04 243.55 96.00 247.00 Z"
  }))), _g403 || (_g403 = /*#__PURE__*/React.createElement("g", {
    fill: "#171F31",
    fillOpacity: 0.54,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 244.00 294.00  C 244.22 294.30 244.70 294.78 245.00 295.00 C 248.09 295.44 253.76 295.66 256.00 294.00 C 239.90 298.00 245.87 280.38 245.00 270.00 C 244.13 259.62 245.96 246.59 245.00 236.00 C 245.00 236.00 244.35 236.23 244.00 236.00 C 243.15 245.41 243.81 255.56 244.00 265.00 C 244.19 274.44 242.66 284.68 244.00 294.00 Z"
  }))), _g404 || (_g404 = /*#__PURE__*/React.createElement("g", {
    fill: "#183049",
    fillOpacity: 0.96,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 343.00 281.00  C 343.00 281.50 342.96 282.50 343.00 283.00 C 343.89 285.69 346.80 289.80 349.00 292.00 C 360.18 300.83 377.34 296.96 383.00 285.00 C 383.45 283.56 383.82 281.47 384.00 280.00 C 384.33 266.30 381.69 250.47 383.00 236.00 C 379.67 236.00 376.33 236.00 373.00 236.00 C 373.42 240.61 372.76 246.49 373.00 251.00 C 373.24 255.51 372.77 262.98 373.00 267.00 C 373.23 271.02 373.04 280.78 372.00 278.00 C 372.00 278.00 371.02 277.90 371.00 278.00 C 370.49 280.53 369.48 282.75 367.00 284.00 C 364.79 285.12 362.18 285.61 360.00 284.00 C 360.00 284.00 359.40 284.20 359.00 284.00 C 351.04 279.46 354.56 270.01 354.00 262.00 C 353.44 253.99 354.42 244.18 354.00 236.00 C 350.36 235.75 346.64 236.33 343.00 236.00 C 343.00 251.00 343.00 266.00 343.00 281.00 Z"
  }))), _g405 || (_g405 = /*#__PURE__*/React.createElement("g", {
    fill: "#081320",
    fillOpacity: 0.93,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 372.00 278.00  C 373.04 280.78 373.23 271.02 373.00 267.00 C 372.77 262.98 373.24 255.51 373.00 251.00 C 372.76 246.49 373.42 240.61 373.00 236.00 C 373.00 236.00 372.35 236.23 372.00 236.00 C 370.74 249.89 373.26 264.11 372.00 278.00 Z"
  }))), _g406 || (_g406 = /*#__PURE__*/React.createElement("g", {
    fill: "#091421",
    fillOpacity: 0.93,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 384.00 280.00  C 385.72 265.81 384.00 250.31 384.00 236.00 C 384.00 236.00 383.50 236.00 383.00 236.00 C 381.69 250.47 384.33 266.30 384.00 280.00 Z"
  }))), _g407 || (_g407 = /*#__PURE__*/React.createElement("g", {
    fill: "#152E49",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 391.00 245.00  C 394.02 244.73 400.99 243.99 403.00 246.00 C 407.31 250.31 403.00 262.44 404.00 269.00 C 405.00 275.56 404.00 286.99 404.00 294.00 C 412.39 293.24 415.48 293.38 415.00 285.00 C 414.52 276.62 414.23 271.58 415.00 265.00 C 415.77 258.42 411.97 250.03 416.00 246.00 C 417.93 243.98 425.09 244.74 428.00 245.00 C 428.00 242.00 428.00 239.00 428.00 236.00 C 415.67 236.00 403.33 236.00 391.00 236.00 C 391.00 239.00 391.00 242.00 391.00 245.00 Z"
  }))), _g408 || (_g408 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillOpacity: 0.01,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 429.00 246.00  C 430.72 244.34 430.71 237.71 429.00 236.00 C 429.99 237.41 429.16 244.19 429.00 246.00 Z"
  }))), _g409 || (_g409 = /*#__PURE__*/React.createElement("g", {
    fill: "#27313F",
    fillOpacity: 0.54,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 281.00 244.00  C 280.07 241.17 277.71 239.45 276.00 237.00 C 276.00 237.00 275.25 237.25 275.00 237.00 C 276.00 239.39 279.36 242.18 281.00 244.00 Z"
  }))), _g410 || (_g410 = /*#__PURE__*/React.createElement("g", {
    fill: "#B8BCC9",
    fillOpacity: 0.06,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 281.00 244.00  C 281.00 244.00 281.78 243.75 282.00 244.00 C 280.66 241.07 279.36 238.30 276.00 237.00 C 277.71 239.45 280.07 241.17 281.00 244.00 Z"
  }))), _g411 || (_g411 = /*#__PURE__*/React.createElement("g", {
    fill: "#A7A9BE",
    fillOpacity: 0.08,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 161.00 246.00  C 162.55 244.06 164.02 241.51 165.00 239.00 C 162.64 240.47 161.61 243.40 161.00 246.00 Z"
  }))), _g412 || (_g412 = /*#__PURE__*/React.createElement("g", {
    fill: "#C1C6D2",
    fillOpacity: 0.07,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 91.00 268.00  C 95.68 263.51 98.62 257.13 103.00 252.00 C 106.18 248.28 109.83 243.57 114.00 241.00 C 114.32 240.80 114.81 240.32 115.00 240.00 C 106.12 246.81 94.94 257.07 91.00 268.00 Z"
  }))), _g413 || (_g413 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 135.00 244.00  C 132.94 246.36 130.28 250.21 128.00 253.00 C 127.26 254.15 126.79 254.89 126.00 256.00 C 125.88 260.13 132.63 257.57 134.00 256.00 C 135.50 253.61 136.35 250.56 138.00 248.00 C 139.64 245.45 141.19 242.46 144.00 241.00 C 141.18 237.81 136.81 242.37 135.00 244.00 Z"
  }))), _g414 || (_g414 = /*#__PURE__*/React.createElement("g", {
    fill: "#394050",
    fillOpacity: 0.4,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 103.00 252.00  C 106.59 248.41 110.79 245.12 114.00 241.00 C 109.83 243.57 106.18 248.28 103.00 252.00 Z"
  }))), _g415 || (_g415 = /*#__PURE__*/React.createElement("g", {
    fill: "#B1ACBD",
    fillOpacity: 0.12,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 138.00 248.00  C 139.95 245.76 142.92 244.08 144.00 241.00 C 141.19 242.46 139.64 245.45 138.00 248.00 Z"
  }))), _g416 || (_g416 = /*#__PURE__*/React.createElement("g", {
    fill: "#B8BCC5",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 128.00 253.00  C 130.28 250.21 132.94 246.36 135.00 244.00 C 132.09 246.61 130.16 249.65 128.00 253.00 Z"
  }))), _g417 || (_g417 = /*#__PURE__*/React.createElement("g", {
    fill: "#161F31",
    fillOpacity: 0.78,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 391.00 246.00  C 393.66 247.97 399.54 244.57 403.00 246.00 C 400.99 243.99 394.02 244.73 391.00 245.00 C 391.00 245.00 390.76 245.82 391.00 246.00 Z"
  }))), _g418 || (_g418 = /*#__PURE__*/React.createElement("g", {
    fill: "#061022",
    fillOpacity: 0.85,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 416.00 246.00  C 416.00 245.96 417.00 246.00 417.00 246.00 C 420.67 246.00 424.33 246.00 428.00 246.00 C 428.00 246.00 428.00 245.50 428.00 245.00 C 425.09 244.74 417.93 243.98 416.00 246.00 Z"
  }))), _g419 || (_g419 = /*#__PURE__*/React.createElement("g", {
    fill: "#666A79",
    fillOpacity: 0.18,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 265.00 263.00  C 262.43 263.50 259.59 262.62 257.00 263.00 C 257.00 257.33 257.00 251.67 257.00 246.00 C 254.68 251.01 256.66 258.17 256.00 264.00 C 259.17 264.43 262.48 263.85 265.00 263.00 Z"
  }))), _g420 || (_g420 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 265.00 263.00  C 278.54 258.43 266.56 239.31 257.00 246.00 C 257.00 251.67 257.00 257.33 257.00 263.00 C 259.59 262.62 262.43 263.50 265.00 263.00 Z"
  }))), _g421 || (_g421 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 304.00 252.00  C 302.23 259.74 304.00 270.03 304.00 278.00 C 304.00 278.00 303.84 278.56 304.00 279.00 C 307.98 282.82 308.75 284.17 315.00 284.00 C 315.90 283.98 317.13 284.22 318.00 284.00 C 319.28 283.34 321.76 277.46 322.00 276.00 C 322.62 269.15 322.76 260.83 322.00 254.00 C 321.70 252.42 319.79 248.09 318.00 247.00 C 312.58 244.46 306.34 245.82 304.00 252.00 Z"
  }))), _g422 || (_g422 = /*#__PURE__*/React.createElement("g", {
    fill: "#474A59",
    fillOpacity: 0.35,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 404.00 295.00  C 403.96 295.00 404.00 294.00 404.00 294.00 C 404.00 286.99 405.00 275.56 404.00 269.00 C 403.00 262.44 407.31 250.31 403.00 246.00 C 404.27 253.08 401.31 264.34 403.00 271.00 C 404.69 277.66 399.30 290.48 404.00 295.00 Z"
  }))), _g423 || (_g423 = /*#__PURE__*/React.createElement("g", {
    fill: "#21253C",
    fillOpacity: 0.53,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 404.00 294.00  C 404.00 294.00 403.96 295.00 404.00 295.00 C 407.60 295.33 411.38 295.00 415.00 295.00 C 415.00 295.00 415.74 295.25 416.00 295.00 C 417.47 278.80 414.54 262.20 416.00 246.00 C 411.97 250.03 415.77 258.42 415.00 265.00 C 414.23 271.58 414.52 276.62 415.00 285.00 C 415.48 293.38 412.39 293.24 404.00 294.00 Z"
  }))), _g424 || (_g424 = /*#__PURE__*/React.createElement("g", {
    fill: "#CECED5",
    fillOpacity: 0.02,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 416.00 295.00  C 420.23 290.91 416.20 277.42 417.00 271.00 C 417.80 264.58 417.61 252.79 417.00 246.00 C 417.00 246.00 416.00 245.96 416.00 246.00 C 414.54 262.20 417.47 278.80 416.00 295.00 Z"
  }))), _g425 || (_g425 = /*#__PURE__*/React.createElement("g", {
    fill: "#858F9C",
    fillOpacity: 0.35,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 447.00 259.00  C 447.00 259.04 448.00 259.00 448.00 259.00 C 448.25 258.75 448.00 258.00 448.00 258.00 C 448.00 254.00 448.00 250.00 448.00 246.00 C 445.84 247.52 446.75 256.28 447.00 259.00 Z"
  }))), _g426 || (_g426 = /*#__PURE__*/React.createElement("g", {
    fill: "#355948",
    fillOpacity: 0.54,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 91.00 253.00  C 92.28 251.49 93.38 250.79 95.00 250.00 C 95.00 250.00 94.91 249.48 95.00 249.00 C 95.11 248.40 95.58 247.45 96.00 247.00 C 93.72 248.95 92.58 250.44 91.00 253.00 Z"
  }))), _g427 || (_g427 = /*#__PURE__*/React.createElement("g", {
    fill: "#9A9CA7",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 158.00 254.00  C 158.67 251.90 160.42 249.48 161.00 247.00 C 159.20 249.25 158.60 251.08 158.00 254.00 Z"
  }))), _g428 || (_g428 = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBAC7",
    fillOpacity: 0.07,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 292.00 283.00  C 292.00 282.00 292.00 281.00 292.00 280.00 C 290.11 271.40 290.13 258.53 292.00 250.00 C 292.00 249.01 291.94 247.99 292.00 247.00 C 289.24 254.11 286.63 276.39 292.00 283.00 Z"
  }))), _g429 || (_g429 = /*#__PURE__*/React.createElement("g", {
    fill: "#A0A5AF",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 322.00 254.00  C 321.64 250.78 321.33 248.56 318.00 247.00 C 319.79 248.09 321.70 252.42 322.00 254.00 Z"
  }))), _g430 || (_g430 = /*#__PURE__*/React.createElement("g", {
    fill: "#B4B7BE",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 212.00 252.00  C 212.82 258.05 212.81 265.02 212.00 271.00 C 212.00 272.33 211.99 273.67 212.00 275.00 C 213.75 265.78 213.98 257.31 212.00 248.00 C 212.00 249.33 212.00 250.67 212.00 252.00 Z"
  }))), _g431 || (_g431 = /*#__PURE__*/React.createElement("g", {
    fill: "#A1A4AF",
    fillOpacity: 0.21,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 334.00 281.00  C 335.89 272.89 336.86 257.05 334.00 249.00 C 335.67 258.21 335.04 271.68 334.00 281.00 Z"
  }))), _g432 || (_g432 = /*#__PURE__*/React.createElement("g", {
    fill: "#AEC3B6",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 91.00 253.00  C 88.71 256.70 85.86 260.03 84.00 264.00 C 86.94 259.05 91.44 254.66 95.00 250.00 C 93.38 250.79 92.28 251.49 91.00 253.00 Z"
  }))), _g433 || (_g433 = /*#__PURE__*/React.createElement("g", {
    fill: "#1D2438",
    fillOpacity: 0.58,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 292.00 280.00  C 292.00 270.00 292.00 260.00 292.00 250.00 C 290.13 258.53 290.11 271.40 292.00 280.00 Z"
  }))), _g434 || (_g434 = /*#__PURE__*/React.createElement("g", {
    fill: "#0F1925",
    fillOpacity: 0.75,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 212.00 271.00  C 212.81 265.02 212.82 258.05 212.00 252.00 C 212.00 258.33 212.00 264.67 212.00 271.00 Z"
  }))), _g435 || (_g435 = /*#__PURE__*/React.createElement("g", {
    fill: "#676778",
    fillOpacity: 0.21,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 304.00 278.00  C 304.00 270.03 302.23 259.74 304.00 252.00 C 302.27 256.57 300.85 273.75 304.00 278.00 Z"
  }))), _g436 || (_g436 = /*#__PURE__*/React.createElement("g", {
    fill: "#244C38",
    fillOpacity: 0.79,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 66.00 257.00  C 66.00 259.67 66.00 262.33 66.00 265.00 C 68.35 261.83 66.30 257.15 66.00 254.00 C 66.00 255.00 66.00 256.00 66.00 257.00 Z"
  }))), _g437 || (_g437 = /*#__PURE__*/React.createElement("g", {
    fill: "#969CAA",
    fillOpacity: 0.08,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 134.00 256.00  C 132.63 257.57 125.88 260.13 126.00 256.00 C 124.54 256.32 124.95 258.13 124.00 259.00 C 128.82 259.36 131.71 259.66 134.00 256.00 Z"
  }))), _g438 || (_g438 = /*#__PURE__*/React.createElement("g", {
    fill: "#819F95",
    fillOpacity: 0.05,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 66.00 266.00  C 66.00 266.00 66.00 265.50 66.00 265.00 C 66.00 262.33 66.00 259.67 66.00 257.00 C 65.31 260.14 65.70 262.93 66.00 266.00 Z"
  }))), _g439 || (_g439 = /*#__PURE__*/React.createElement("g", {
    fill: "#838A95",
    fillOpacity: 0.24,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 166.00 271.00  C 166.00 266.33 166.00 261.67 166.00 257.00 C 165.58 261.34 165.57 266.60 166.00 271.00 Z"
  }))), _g440 || (_g440 = /*#__PURE__*/React.createElement("g", {
    fill: "#A2ABC1",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 282.00 265.00  C 284.27 263.26 283.85 260.72 284.00 258.00 C 283.78 259.56 282.67 263.11 282.00 265.00 Z"
  }))), _g441 || (_g441 = /*#__PURE__*/React.createElement("g", {
    fill: "#D8D8FF",
    fillOpacity: 0.02,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 448.00 259.00  C 454.00 259.00 460.00 259.00 466.00 259.00 C 466.50 259.00 467.00 259.00 467.00 259.00 C 464.45 256.34 451.96 257.64 448.00 258.00 C 448.00 258.00 448.25 258.75 448.00 259.00 Z"
  }))), _g442 || (_g442 = /*#__PURE__*/React.createElement("g", {
    fill: "#1E2336",
    fillOpacity: 0.66,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 466.00 260.00  C 466.00 259.50 466.00 259.00 466.00 259.00 C 460.00 259.00 454.00 259.00 448.00 259.00 C 448.00 259.00 447.00 259.04 447.00 259.00 C 449.55 261.66 462.04 260.36 466.00 260.00 Z"
  }))), _g443 || (_g443 = /*#__PURE__*/React.createElement("g", {
    fill: "#798087",
    fillOpacity: 0.39,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 466.00 260.00  C 466.00 262.05 467.10 268.38 466.00 270.00 C 467.92 268.10 467.26 261.86 467.00 259.00 C 467.00 259.00 466.50 259.00 466.00 259.00 C 466.00 259.00 466.00 259.50 466.00 260.00 Z"
  }))), _g444 || (_g444 = /*#__PURE__*/React.createElement("g", {
    fill: "#767986",
    fillOpacity: 0.16,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 158.00 284.00  C 157.55 276.21 156.68 268.14 157.00 260.00 C 155.72 268.06 156.47 276.21 158.00 284.00 Z"
  }))), _g445 || (_g445 = /*#__PURE__*/React.createElement("g", {
    fill: "#B8BCC6",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 276.00 275.00  C 276.18 270.89 281.18 270.22 282.00 266.00 C 280.27 268.70 273.34 271.58 276.00 275.00 Z"
  }))), _g446 || (_g446 = /*#__PURE__*/React.createElement("g", {
    fill: "#C9C7D7",
    fillOpacity: 0.05,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 85.00 280.00  C 86.76 276.52 89.47 272.91 91.00 269.00 C 87.69 271.06 86.27 276.55 85.00 280.00 Z"
  }))), _g447 || (_g447 = /*#__PURE__*/React.createElement("g", {
    fill: "#A99AB5",
    fillOpacity: 0.24,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 447.00 283.00  C 449.33 283.00 451.67 283.00 454.00 283.00 C 454.07 282.99 454.00 282.00 454.00 282.00 C 452.00 282.00 450.00 282.00 448.00 282.00 C 448.00 278.33 448.00 274.67 448.00 271.00 C 446.78 272.11 445.81 281.31 447.00 283.00 Z"
  }))), _g448 || (_g448 = /*#__PURE__*/React.createElement("g", {
    fill: "#A4C3B8",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 68.00 281.00  C 67.57 278.70 66.30 275.86 66.00 274.00 C 66.20 276.96 67.28 278.64 68.00 281.00 Z"
  }))), _g449 || (_g449 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 114.00 294.00  C 113.94 296.77 115.72 308.11 114.00 310.00 C 117.19 311.27 124.84 310.40 126.00 308.00 C 126.59 306.54 124.23 300.84 125.00 298.00 C 125.77 295.16 124.94 290.05 125.00 287.00 C 125.05 284.48 125.74 281.83 126.00 280.00 C 126.02 278.26 125.79 276.40 127.00 275.00 C 124.37 273.26 121.03 274.26 118.00 274.00 C 115.91 280.51 114.14 286.95 114.00 294.00 Z"
  }))), _g450 || (_g450 = /*#__PURE__*/React.createElement("g", {
    fill: "#646778",
    fillOpacity: 0.12,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 256.00 294.00  C 256.32 293.76 257.00 294.00 257.00 294.00 C 257.00 287.67 257.00 281.33 257.00 275.00 C 259.98 274.42 262.56 275.63 264.00 278.00 C 263.55 273.48 259.84 273.64 256.00 274.00 C 256.45 280.63 255.40 287.39 256.00 294.00 Z"
  }))), _g451 || (_g451 = /*#__PURE__*/React.createElement("g", {
    fill: "#A8ABB6",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 280.00 284.00  C 278.82 281.13 278.53 277.94 276.00 276.00 C 277.19 278.90 278.57 281.43 280.00 284.00 Z"
  }))), _g452 || (_g452 = /*#__PURE__*/React.createElement("g", {
    fill: "#7E8791",
    fillOpacity: 0.19,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 318.00 284.00  C 321.44 283.12 321.75 278.72 322.00 276.00 C 321.76 277.46 319.28 283.34 318.00 284.00 Z"
  }))), _g453 || (_g453 = /*#__PURE__*/React.createElement("g", {
    fill: "#8D929B",
    fillOpacity: 0.21,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 170.00 289.00  C 168.97 285.03 166.72 280.49 166.00 277.00 C 166.45 281.28 168.54 285.36 170.00 289.00 Z"
  }))), _g454 || (_g454 = /*#__PURE__*/React.createElement("g", {
    fill: "#ADB4BC",
    fillOpacity: 0.12,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 315.00 284.00  C 308.75 284.17 307.98 282.82 304.00 279.00 C 306.15 284.97 309.97 285.10 315.00 284.00 Z"
  }))), _g455 || (_g455 = /*#__PURE__*/React.createElement("g", {
    fill: "#A4A6AB",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 125.00 287.00  C 125.00 286.96 126.00 287.00 126.00 287.00 C 126.00 284.67 125.93 282.33 126.00 280.00 C 125.74 281.83 125.05 284.48 125.00 287.00 Z"
  }))), _g456 || (_g456 = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBBBB",
    fillOpacity: 0.02,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 454.00 283.00  C 457.02 283.00 466.64 281.35 469.00 283.00 C 466.71 280.71 457.45 281.69 454.00 282.00 C 454.00 282.00 454.07 282.99 454.00 283.00 Z"
  }))), _g457 || (_g457 = /*#__PURE__*/React.createElement("g", {
    fill: "#BFC3D6",
    fillOpacity: 0.03,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 349.00 292.00  C 346.80 289.80 343.89 285.69 343.00 283.00 C 343.28 286.98 345.95 289.59 349.00 292.00 Z"
  }))), _g458 || (_g458 = /*#__PURE__*/React.createElement("g", {
    fill: "#191E2C",
    fillOpacity: 0.53,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 470.00 294.00  C 470.39 291.30 470.82 284.82 469.00 283.00 C 466.64 281.35 457.02 283.00 454.00 283.00 C 451.67 283.00 449.33 283.00 447.00 283.00 C 453.34 285.33 461.83 283.34 469.00 284.00 C 468.56 287.47 469.16 291.19 470.00 294.00 Z"
  }))), _g459 || (_g459 = /*#__PURE__*/React.createElement("g", {
    fill: "#A6A9B4",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 302.00 295.00  C 297.75 292.83 295.18 287.25 292.00 284.00 C 292.97 288.40 297.74 293.31 302.00 295.00 Z"
  }))), _g460 || (_g460 = /*#__PURE__*/React.createElement("g", {
    fill: "#404654",
    fillOpacity: 0.25,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 367.00 284.00  C 365.08 284.59 362.02 284.00 360.00 284.00 C 362.18 285.61 364.79 285.12 367.00 284.00 Z"
  }))), _g461 || (_g461 = /*#__PURE__*/React.createElement("g", {
    fill: "#9CA0AF",
    fillOpacity: 0.18,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 268.00 288.00  C 267.74 286.78 267.16 286.76 266.00 285.00 C 266.53 286.21 267.53 287.04 268.00 288.00 Z"
  }))), _g462 || (_g462 = /*#__PURE__*/React.createElement("g", {
    fill: "#ADB0C5",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 206.00 295.00  C 207.40 292.20 208.86 289.16 210.00 286.00 C 208.58 288.88 207.18 291.80 206.00 295.00 Z"
  }))), _g463 || (_g463 = /*#__PURE__*/React.createElement("g", {
    fill: "#6A707B",
    fillOpacity: 0.34,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 126.00 308.00  C 128.21 303.44 126.00 292.17 126.00 287.00 C 126.00 287.00 125.00 286.96 125.00 287.00 C 124.94 290.05 125.77 295.16 125.00 298.00 C 124.23 300.84 126.59 306.54 126.00 308.00 Z"
  }))), _g464 || (_g464 = /*#__PURE__*/React.createElement("g", {
    fill: "#202738",
    fillOpacity: 0.54,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 271.00 294.00  C 273.44 295.87 279.70 295.30 283.00 295.00 C 283.00 295.00 282.76 294.31 283.00 294.00 C 282.78 293.05 283.39 291.26 282.00 291.00 C 283.09 295.05 273.47 295.13 271.00 294.00 Z"
  }))), _g465 || (_g465 = /*#__PURE__*/React.createElement("g", {
    fill: "#A6ABB3",
    fillOpacity: 0.14,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 323.00 295.00  C 325.60 294.01 326.03 292.93 328.00 291.00 C 326.54 292.07 324.40 294.29 323.00 295.00 Z"
  }))), _g466 || (_g466 = /*#__PURE__*/React.createElement("g", {
    fill: "#EBEBED",
    fillOpacity: 0.04,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 283.00 295.00  C 279.70 295.30 273.44 295.87 271.00 294.00 C 270.81 293.85 269.18 292.25 269.00 292.00 C 271.74 298.25 282.80 294.71 283.00 295.00 Z"
  }))), _g467 || (_g467 = /*#__PURE__*/React.createElement("g", {
    fill: "#727885",
    fillOpacity: 0.27,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 80.00 299.00  C 80.61 297.33 80.70 295.74 81.00 294.00 C 81.23 293.33 80.14 298.34 80.00 299.00 Z"
  }))), _g468 || (_g468 = /*#__PURE__*/React.createElement("g", {
    fill: "#DADBEA",
    fillOpacity: 0.02,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 113.00 296.00  C 112.55 299.62 112.55 304.38 113.00 308.00 C 113.12 308.97 113.01 309.60 114.00 310.00 C 115.72 308.11 113.94 296.77 114.00 294.00 C 113.89 294.52 113.12 294.99 113.00 296.00 Z"
  }))), _g469 || (_g469 = /*#__PURE__*/React.createElement("g", {
    fill: "#F7F7F7",
    fillOpacity: 0.01,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 245.00 295.00  C 246.75 296.29 256.23 297.60 257.00 294.00 C 257.00 294.00 256.32 293.76 256.00 294.00 C 253.76 295.66 248.09 295.44 245.00 295.00 Z"
  }))), _g470 || (_g470 = /*#__PURE__*/React.createElement("g", {
    fill: "#2C2F3E",
    fillOpacity: 0.33,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 439.00 295.00  C 443.24 295.64 446.98 295.16 451.00 295.00 C 456.65 294.78 462.35 295.00 468.00 295.00 C 468.00 295.00 468.50 295.05 469.00 295.00 C 459.17 292.06 446.70 295.12 436.00 294.00 C 436.84 295.39 437.55 294.78 439.00 295.00 Z"
  }))), _g471 || (_g471 = /*#__PURE__*/React.createElement("g", {
    fill: "#ACADB5",
    fillOpacity: 0.15,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 178.00 304.00  C 176.06 300.88 173.76 297.91 172.00 295.00 C 173.51 298.31 174.82 301.93 178.00 304.00 Z"
  }))), _g472 || (_g472 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillOpacity: 0.01,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 415.00 295.00  C 411.38 295.00 407.60 295.33 404.00 295.00 C 405.94 296.94 412.93 296.53 415.00 295.00 Z"
  }))), _g473 || (_g473 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 468.00 295.00  C 462.35 295.00 456.65 294.78 451.00 295.00 C 455.15 295.29 463.94 298.01 468.00 295.00 Z"
  }))), _g474 || (_g474 = /*#__PURE__*/React.createElement("g", {
    fill: "#0A1322",
    fillOpacity: 0.69,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 113.00 308.00  C 112.55 304.38 112.55 299.62 113.00 296.00 C 111.59 299.47 111.56 304.47 113.00 308.00 Z"
  }))), _g475 || (_g475 = /*#__PURE__*/React.createElement("g", {
    fill: "#8D8F9E",
    fillOpacity: 0.21,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 318.00 296.00  C 314.47 296.26 310.53 296.26 307.00 296.00 C 310.72 296.69 314.22 296.70 318.00 296.00 Z"
  }))), _g476 || (_g476 = /*#__PURE__*/React.createElement("g", {
    fill: "#ABAEBB",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 187.00 316.00  C 184.86 312.54 181.36 307.19 178.00 305.00 C 179.52 309.21 183.46 313.25 187.00 316.00 Z"
  }))), _g477 || (_g477 = /*#__PURE__*/React.createElement("g", {
    fill: "#999FA6",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 97.00 324.00  C 92.54 317.61 84.51 313.44 80.00 307.00 C 83.65 313.92 90.89 319.33 97.00 324.00 Z"
  }))), _g478 || (_g478 = /*#__PURE__*/React.createElement("g", {
    fill: "#A5B0BB",
    fillOpacity: 0.14,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 188.00 317.00  C 190.97 318.92 197.15 309.53 199.00 307.00 C 196.98 309.18 190.94 316.38 188.00 317.00 Z"
  }))), _g479 || (_g479 = /*#__PURE__*/React.createElement("g", {
    fill: "#A2B9A8",
    fillOpacity: 0.18,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 247.00 314.00  C 247.50 313.99 248.00 314.00 248.00 314.00 C 248.00 313.50 248.00 313.00 248.00 313.00 C 247.84 312.77 246.34 313.23 246.00 313.00 C 242.91 310.91 252.35 310.78 254.00 312.00 C 254.41 311.81 255.00 312.00 255.00 312.00 C 253.02 308.14 247.50 310.77 244.00 310.00 C 243.71 312.87 244.06 314.07 247.00 314.00 Z"
  }))), _g480 || (_g480 = /*#__PURE__*/React.createElement("g", {
    fill: "#B6D1B7",
    fillOpacity: 0.08,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 257.00 315.00  C 256.72 313.73 257.21 312.29 257.00 311.00 C 259.67 311.00 262.33 311.00 265.00 311.00 C 262.15 308.92 252.83 309.79 257.00 315.00 Z"
  }))), _g481 || (_g481 = /*#__PURE__*/React.createElement("g", {
    fill: "#ADBCAF",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 272.00 313.00  C 274.88 309.51 276.44 312.04 278.00 315.00 C 276.42 310.65 275.11 307.81 272.00 313.00 Z"
  }))), _g482 || (_g482 = /*#__PURE__*/React.createElement("g", {
    fill: "#A3B8A9",
    fillOpacity: 0.14,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 283.00 311.00  C 287.70 310.36 287.56 316.35 290.00 319.00 C 292.59 317.36 289.34 312.57 292.00 311.00 C 294.24 315.09 292.40 321.16 293.00 326.00 C 295.31 321.66 293.35 315.16 294.00 310.00 C 289.54 308.70 289.65 312.85 290.00 316.00 C 288.84 314.89 285.46 307.14 283.00 311.00 Z"
  }))), _g483 || (_g483 = /*#__PURE__*/React.createElement("g", {
    fill: "#C1CDC3",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 302.00 321.00  C 300.88 317.83 297.12 319.10 297.03 314.97 C 296.94 310.84 300.27 310.60 304.00 311.00 C 300.95 308.62 297.08 309.80 296.01 313.99 C 294.94 318.18 300.77 318.71 302.00 321.00 Z"
  }))), _g484 || (_g484 = /*#__PURE__*/React.createElement("g", {
    fill: "#BDCAC0",
    fillOpacity: 0.12,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 309.00 311.00  C 309.00 310.96 310.00 311.00 310.00 311.00 C 312.00 311.00 314.00 311.00 316.00 311.00 C 314.30 309.74 310.69 309.24 309.00 311.00 Z"
  }))), _g485 || (_g485 = /*#__PURE__*/React.createElement("g", {
    fill: "#AEBCB1",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 321.00 313.00  C 322.99 310.17 327.07 311.20 330.00 311.00 C 329.73 312.28 330.77 313.72 332.00 314.00 C 330.50 309.94 322.51 307.21 321.00 313.00 Z"
  }))), _g486 || (_g486 = /*#__PURE__*/React.createElement("g", {
    fill: "#B6C7B9",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 335.00 311.00  C 337.21 311.45 339.83 310.40 342.00 311.00 C 340.40 310.21 336.52 308.83 335.00 311.00 Z"
  }))), _g487 || (_g487 = /*#__PURE__*/React.createElement("g", {
    fill: "#B0BFB2",
    fillOpacity: 0.16,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 350.00 314.00  C 350.00 313.50 350.00 313.00 350.00 313.00 C 349.84 312.77 348.34 313.23 348.00 313.00 C 344.51 310.63 354.66 311.00 356.00 311.00 C 356.50 311.00 357.00 311.00 357.00 311.00 C 354.32 308.73 349.50 310.62 346.00 310.00 C 345.27 312.97 346.96 314.91 350.00 314.00 Z"
  }))), _g488 || (_g488 = /*#__PURE__*/React.createElement("g", {
    fill: "#A9B7AB",
    fillOpacity: 0.18,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 365.00 313.00  C 368.68 306.74 375.15 315.02 370.00 319.00 C 371.68 320.87 373.30 318.48 375.00 320.00 C 374.72 318.77 373.28 317.73 372.00 318.00 C 376.20 312.09 367.79 306.15 365.00 313.00 Z"
  }))), _g489 || (_g489 = /*#__PURE__*/React.createElement("g", {
    fill: "#BBC7BC",
    fillOpacity: 0.08,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 383.00 326.00  C 384.31 322.55 380.37 311.68 385.00 311.00 C 385.25 310.75 386.00 311.00 386.00 311.00 C 385.50 309.24 383.28 310.28 382.00 310.00 C 383.61 313.74 379.41 323.49 383.00 326.00 Z"
  }))), _g490 || (_g490 = /*#__PURE__*/React.createElement("g", {
    fill: "#ADC0B6",
    fillOpacity: 0.05,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 391.00 323.00  C 390.82 323.97 391.15 325.03 391.00 326.00 C 393.74 325.09 390.63 323.18 394.00 324.00 C 395.18 319.80 389.76 311.02 398.00 310.00 C 391.01 310.41 391.96 317.87 391.00 323.00 Z"
  }))), _g491 || (_g491 = /*#__PURE__*/React.createElement("g", {
    fill: "#4B6456",
    fillOpacity: 0.65,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 394.00 324.00  C 395.48 324.36 398.44 329.86 401.92 325.92 C 405.39 321.97 406.42 309.51 398.00 310.00 C 389.76 311.02 395.18 319.80 394.00 324.00 M 400.00 314.00  C 402.95 315.66 400.92 324.67 397.32 322.66 C 393.72 320.65 396.72 312.15 400.00 314.00 Z"
  }))), _g492 || (_g492 = /*#__PURE__*/React.createElement("g", {
    fill: "#A7B5AD",
    fillOpacity: 0.17,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 407.00 313.00  C 409.11 309.84 418.19 309.56 417.00 315.00 C 416.00 315.00 415.00 315.00 414.00 315.00 C 414.50 316.76 416.72 315.72 418.00 316.00 C 419.60 309.22 409.53 307.72 407.00 313.00 Z"
  }))), _g493 || (_g493 = /*#__PURE__*/React.createElement("g", {
    fill: "#BCC2BB",
    fillOpacity: 0.06,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 421.00 311.00  C 421.96 310.80 423.03 311.16 424.00 311.00 C 424.00 316.00 424.00 321.00 424.00 326.00 C 426.31 321.66 424.35 315.16 425.00 310.00 C 423.34 309.87 422.06 309.92 421.00 311.00 Z"
  }))), _g494 || (_g494 = /*#__PURE__*/React.createElement("g", {
    fill: "#A4B6A9",
    fillOpacity: 0.18,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 433.00 323.00  C 436.13 320.96 427.81 318.55 428.03 314.97 C 428.24 311.39 434.94 308.14 436.00 314.00 C 434.51 315.23 432.48 313.75 432.00 317.00 C 434.37 317.62 435.60 319.43 437.00 321.00 C 437.39 318.67 434.66 317.93 434.00 316.00 C 440.29 315.04 434.22 306.18 428.26 311.26 C 422.30 316.34 434.08 319.86 433.00 323.00 Z"
  }))), _g495 || (_g495 = /*#__PURE__*/React.createElement("g", {
    fill: "#B7CABE",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 439.00 311.00  C 440.40 310.38 447.60 310.38 449.00 311.00 C 447.88 309.28 440.15 309.24 439.00 311.00 Z"
  }))), _g496 || (_g496 = /*#__PURE__*/React.createElement("g", {
    fill: "#485F4F",
    fillOpacity: 0.66,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 452.00 326.00  C 456.89 325.77 456.80 310.21 452.00 310.00 C 452.00 315.33 452.00 320.67 452.00 326.00 Z"
  }))), _g497 || (_g497 = /*#__PURE__*/React.createElement("g", {
    fill: "#C5D9CB",
    fillOpacity: 0.04,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 458.00 311.00  C 458.00 310.96 459.00 311.00 459.00 311.00 C 463.12 311.61 458.90 317.51 463.00 316.00 C 461.79 314.64 461.67 307.23 458.00 311.00 Z"
  }))), _g498 || (_g498 = /*#__PURE__*/React.createElement("g", {
    fill: "#A0B5A4",
    fillOpacity: 0.19,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 463.00 316.00  C 466.04 314.88 464.44 309.98 469.00 311.00 C 465.77 307.70 463.36 313.16 463.00 316.00 Z"
  }))), _g499 || (_g499 = /*#__PURE__*/React.createElement("g", {
    fill: "#2C4839",
    fillOpacity: 0.79,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 246.00 313.00  C 246.76 310.39 251.99 312.70 253.00 313.00 C 253.35 312.93 253.74 312.12 254.00 312.00 C 252.35 310.78 242.91 310.91 246.00 313.00 Z"
  }))), _g500 || (_g500 = /*#__PURE__*/React.createElement("g", {
    fill: "#385142",
    fillOpacity: 0.76,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 257.00 315.00  C 257.00 315.00 257.00 315.50 257.00 316.00 C 258.53 318.07 258.50 321.97 257.00 324.00 C 257.00 324.00 256.94 324.99 257.00 325.00 C 260.86 325.46 259.00 322.76 261.00 321.00 C 261.20 322.71 264.48 329.04 267.00 325.00 C 265.37 324.29 265.71 321.62 264.00 321.00 C 265.16 319.72 265.61 317.86 267.00 317.00 C 267.07 314.21 267.13 312.55 265.00 311.00 C 262.33 311.00 259.67 311.00 257.00 311.00 C 257.21 312.29 256.72 313.73 257.00 315.00 M 263.00 313.00  C 265.57 314.02 263.60 319.57 260.99 317.99 C 258.38 316.41 260.11 311.85 263.00 313.00 Z"
  }))), _g501 || (_g501 = /*#__PURE__*/React.createElement("g", {
    fill: "#456050",
    fillOpacity: 0.65,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 272.00 313.00  C 270.31 317.24 269.70 321.77 268.00 326.00 C 269.31 325.86 270.69 326.18 272.00 326.00 C 272.00 325.00 272.00 324.00 272.00 323.00 C 273.57 323.39 276.22 322.06 277.00 324.00 C 276.57 326.59 279.39 325.99 281.00 326.00 C 280.33 322.18 279.32 318.63 278.00 315.00 C 276.44 312.04 274.88 309.51 272.00 313.00 M 276.00 317.00  C 277.67 319.86 273.17 323.09 273.00 319.00 C 276.49 321.51 272.64 316.11 276.00 317.00 Z"
  }))), _g502 || (_g502 = /*#__PURE__*/React.createElement("g", {
    fill: "#375545",
    fillOpacity: 0.76,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 286.00 326.00  C 286.00 323.33 286.00 320.67 286.00 318.00 C 287.39 318.26 286.78 320.05 287.00 321.00 C 287.95 322.34 290.24 327.62 293.00 326.00 C 292.40 321.16 294.24 315.09 292.00 311.00 C 289.34 312.57 292.59 317.36 290.00 319.00 C 287.56 316.35 287.70 310.36 283.00 311.00 C 283.00 316.00 283.00 321.00 283.00 326.00 C 283.79 325.65 285.26 326.44 286.00 326.00 Z"
  }))), _g503 || (_g503 = /*#__PURE__*/React.createElement("g", {
    fill: "#3D5245",
    fillOpacity: 0.67,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 302.00 321.00  C 302.87 323.48 302.45 322.07 300.00 323.00 C 299.37 323.24 297.93 321.18 297.00 322.00 C 296.59 323.56 297.46 324.69 298.00 326.00 C 303.49 329.76 307.71 323.89 306.00 319.00 C 305.56 318.35 301.86 317.34 301.00 317.00 C 303.22 314.16 300.25 313.50 299.00 316.00 C 298.35 310.90 303.07 313.92 305.00 315.00 C 305.00 313.67 305.00 312.33 305.00 311.00 C 305.00 311.00 304.49 311.05 304.00 311.00 C 300.27 310.60 296.94 310.84 297.03 314.97 C 297.12 319.10 300.88 317.83 302.00 321.00 Z"
  }))), _g504 || (_g504 = /*#__PURE__*/React.createElement("g", {
    fill: "#849A8F",
    fillOpacity: 0.24,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 306.00 319.00  C 305.55 317.46 303.24 317.88 303.00 316.00 C 306.59 317.01 306.71 312.67 305.00 311.00 C 305.00 312.33 305.00 313.67 305.00 315.00 C 303.07 313.92 298.35 310.90 299.00 316.00 C 300.25 313.50 303.22 314.16 301.00 317.00 C 301.86 317.34 305.56 318.35 306.00 319.00 Z"
  }))), _g505 || (_g505 = /*#__PURE__*/React.createElement("g", {
    fill: "#4F6558",
    fillOpacity: 0.28,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 310.00 326.00  C 309.94 325.99 310.00 325.00 310.00 325.00 C 310.00 320.40 310.41 315.58 310.00 311.00 C 310.00 311.00 309.00 310.96 309.00 311.00 C 308.70 314.35 307.70 323.78 310.00 326.00 Z"
  }))), _g506 || (_g506 = /*#__PURE__*/React.createElement("g", {
    fill: "#335040",
    fillOpacity: 0.82,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 310.00 325.00  C 311.55 324.02 311.99 321.72 314.00 321.00 C 314.88 320.68 316.09 321.24 317.00 321.00 C 319.17 319.82 318.22 312.52 317.00 311.00 C 317.00 311.00 316.50 311.00 316.00 311.00 C 314.00 311.00 312.00 311.00 310.00 311.00 C 310.41 315.58 310.00 320.40 310.00 325.00 M 315.00 317.00  C 314.89 317.45 313.42 318.58 313.00 318.00 C 311.23 317.21 312.35 314.53 312.00 313.00 C 314.36 311.87 317.73 315.51 315.00 317.00 Z"
  }))), _g507 || (_g507 = /*#__PURE__*/React.createElement("g", {
    fill: "#A0ACA0",
    fillOpacity: 0.2,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 317.00 321.00  C 320.18 320.16 320.07 311.92 317.00 311.00 C 318.22 312.52 319.17 319.82 317.00 321.00 Z"
  }))), _g508 || (_g508 = /*#__PURE__*/React.createElement("g", {
    fill: "#3E5849",
    fillOpacity: 0.68,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 321.00 313.00  C 321.00 313.00 321.00 313.50 321.00 314.00 C 321.00 316.45 320.45 319.63 321.00 322.00 C 325.20 332.96 335.22 322.72 332.00 314.00 C 330.77 313.72 329.73 312.28 330.00 311.00 C 327.07 311.20 322.99 310.17 321.00 313.00 M 328.00 314.00  C 328.10 314.02 328.00 315.00 328.00 315.00 C 329.32 316.78 329.70 320.28 328.00 322.00 C 327.34 322.67 326.22 323.50 325.00 323.00 C 322.39 321.94 323.60 309.50 328.00 314.00 Z"
  }))), _g509 || (_g509 = /*#__PURE__*/React.createElement("g", {
    fill: "#375342",
    fillOpacity: 0.75,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 338.00 325.00  C 338.55 324.71 337.58 321.54 338.00 321.00 C 339.92 320.49 340.23 322.84 341.00 324.00 C 340.91 323.98 342.98 327.86 344.66 325.68 C 346.35 323.49 343.78 323.68 344.00 322.00 C 343.87 320.51 344.76 315.86 344.00 313.00 C 343.01 311.03 343.91 311.95 342.00 311.00 C 339.83 310.40 337.21 311.45 335.00 311.00 C 335.00 316.00 335.00 321.00 335.00 326.00 C 336.18 326.80 337.45 325.12 338.00 325.00 M 341.00 313.00  C 343.57 314.02 341.60 319.57 338.99 317.99 C 336.38 316.41 338.11 311.85 341.00 313.00 Z"
  }))), _g510 || (_g510 = /*#__PURE__*/React.createElement("g", {
    fill: "#33493B",
    fillOpacity: 0.76,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 348.00 313.00  C 348.50 311.27 354.57 312.06 356.00 311.00 C 354.66 311.00 344.51 310.63 348.00 313.00 Z"
  }))), _g511 || (_g511 = /*#__PURE__*/React.createElement("g", {
    fill: "#3E594A",
    fillOpacity: 0.91,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 348.00 313.00  C 348.34 313.23 349.84 312.77 350.00 313.00 C 352.68 315.58 350.06 321.54 351.00 325.00 C 353.89 321.64 348.82 311.31 357.00 313.00 C 357.24 312.82 357.23 311.16 357.00 311.00 C 357.00 311.00 356.50 311.00 356.00 311.00 C 354.57 312.06 348.50 311.27 348.00 313.00 Z"
  }))), _g512 || (_g512 = /*#__PURE__*/React.createElement("g", {
    fill: "#435D4F",
    fillOpacity: 0.67,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 365.00 313.00  C 363.43 316.87 364.10 322.30 366.00 325.00 C 367.40 325.98 372.33 326.22 373.00 326.00 C 374.00 326.00 375.00 326.00 376.00 326.00 C 374.49 323.73 375.75 321.85 375.00 320.00 C 373.30 318.48 371.68 320.87 370.00 319.00 C 375.15 315.02 368.68 306.74 365.00 313.00 Z"
  }))), _g513 || (_g513 = /*#__PURE__*/React.createElement("g", {
    fill: "#3C5043",
    fillOpacity: 0.63,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 383.00 326.00  C 383.85 326.59 389.96 326.35 391.00 326.00 C 391.15 325.03 390.82 323.97 391.00 323.00 C 390.39 322.20 386.87 323.61 386.00 323.00 C 388.19 326.60 391.12 323.66 384.00 325.00 C 384.64 320.83 382.71 315.34 385.00 312.00 C 385.00 311.50 385.00 311.00 385.00 311.00 C 380.37 311.68 384.31 322.55 383.00 326.00 Z"
  }))), _g514 || (_g514 = /*#__PURE__*/React.createElement("g", {
    fill: "#89A193",
    fillOpacity: 0.35,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 385.00 312.00  C 385.00 315.60 384.29 320.19 386.00 323.00 C 385.73 319.02 386.36 314.97 386.00 311.00 C 386.00 311.00 385.25 310.75 385.00 311.00 C 385.00 311.00 385.00 311.50 385.00 312.00 Z"
  }))), _g515 || (_g515 = /*#__PURE__*/React.createElement("g", {
    fill: "#4A6152",
    fillOpacity: 0.65,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 407.00 313.00  C 405.31 317.72 407.94 322.66 408.00 326.00 C 412.28 327.29 414.70 327.25 417.00 324.00 C 417.66 322.65 418.45 318.84 417.00 318.00 C 411.80 316.82 411.45 320.18 414.00 323.00 C 407.44 321.60 409.38 315.40 414.00 315.00 C 415.00 315.00 416.00 315.00 417.00 315.00 C 418.19 309.56 409.11 309.84 407.00 313.00 Z"
  }))), _g516 || (_g516 = /*#__PURE__*/React.createElement("g", {
    fill: "#2C4A3B",
    fillOpacity: 0.63,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 421.00 312.00  C 421.00 315.26 419.86 320.98 421.00 324.00 C 421.75 325.27 421.60 326.89 424.00 326.00 C 424.00 321.00 424.00 316.00 424.00 311.00 C 423.03 311.16 421.96 310.80 421.00 311.00 C 421.00 311.00 421.00 311.50 421.00 312.00 Z"
  }))), _g517 || (_g517 = /*#__PURE__*/React.createElement("g", {
    fill: "#3D5648",
    fillOpacity: 0.69,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 433.00 323.00  C 432.95 323.15 431.44 323.16 431.00 323.00 C 429.69 322.52 428.59 321.55 427.00 322.00 C 427.73 323.34 428.34 324.64 429.00 326.00 C 433.23 328.26 437.43 325.92 437.00 321.00 C 435.60 319.43 434.37 317.62 432.00 317.00 C 432.48 313.75 434.51 315.23 436.00 314.00 C 434.94 308.14 428.24 311.39 428.03 314.97 C 427.81 318.55 436.13 320.96 433.00 323.00 Z"
  }))), _g518 || (_g518 = /*#__PURE__*/React.createElement("g", {
    fill: "#335242",
    fillOpacity: 0.85,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 439.00 313.00  C 446.45 315.25 440.46 320.28 443.00 326.00 C 443.35 326.23 444.65 326.23 445.00 326.00 C 447.54 320.27 441.51 315.26 449.00 313.00 C 449.24 312.80 449.23 311.35 449.00 311.00 C 447.60 310.38 440.40 310.38 439.00 311.00 C 438.77 311.35 438.76 312.80 439.00 313.00 Z"
  }))), _g519 || (_g519 = /*#__PURE__*/React.createElement("g", {
    fill: "#667F6D",
    fillOpacity: 0.17,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 459.00 325.00  C 457.45 321.51 459.35 314.86 459.00 311.00 C 459.00 311.00 458.00 310.96 458.00 311.00 C 457.74 313.92 457.56 325.41 459.00 325.00 Z"
  }))), _g520 || (_g520 = /*#__PURE__*/React.createElement("g", {
    fill: "#31513E",
    fillOpacity: 0.82,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 459.00 325.00  C 459.46 324.87 460.52 324.91 461.00 325.00 C 461.89 321.98 460.77 319.09 464.00 322.00 C 465.24 323.12 464.46 327.53 468.00 326.00 C 466.49 320.66 463.64 316.11 469.00 312.00 C 469.00 312.00 469.11 311.02 469.00 311.00 C 464.44 309.98 466.04 314.88 463.00 316.00 C 458.90 317.51 463.12 311.61 459.00 311.00 C 459.35 314.86 457.45 321.51 459.00 325.00 Z"
  }))), _g521 || (_g521 = /*#__PURE__*/React.createElement("g", {
    fill: "#3E5D4D",
    fillOpacity: 0.96,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 246.00 313.00  C 246.34 313.23 247.84 312.77 248.00 313.00 C 250.02 314.94 249.26 322.09 249.00 325.00 C 252.29 321.81 246.91 314.14 253.00 313.00 C 251.99 312.70 246.76 310.39 246.00 313.00 Z"
  }))), _g522 || (_g522 = /*#__PURE__*/React.createElement("g", {
    fill: "#6D8375",
    fillOpacity: 0.38,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 253.00 313.00  C 246.91 314.14 252.29 321.81 249.00 325.00 C 248.74 325.25 248.00 325.00 248.00 325.00 C 248.00 325.50 248.00 326.00 248.00 326.00 C 249.00 326.00 250.00 326.00 251.00 326.00 C 251.00 322.00 251.00 318.00 251.00 314.00 C 253.67 314.48 254.13 313.81 255.00 312.00 C 255.00 312.00 254.41 311.81 254.00 312.00 C 253.74 312.12 253.35 312.93 253.00 313.00 Z"
  }))), _g523 || (_g523 = /*#__PURE__*/React.createElement("g", {
    fill: "#3B5949",
    fillOpacity: 0.96,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 386.00 323.00  C 384.29 320.19 385.00 315.60 385.00 312.00 C 382.71 315.34 384.64 320.83 384.00 325.00 C 391.12 323.66 388.19 326.60 386.00 323.00 Z"
  }))), _g524 || (_g524 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 421.00 324.00  C 419.86 320.98 421.00 315.26 421.00 312.00 C 419.12 314.53 419.45 321.37 421.00 324.00 Z"
  }))), _g525 || (_g525 = /*#__PURE__*/React.createElement("g", {
    fill: "#96B4A2",
    fillOpacity: 0.17,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 468.00 326.00  C 471.05 324.68 466.49 320.59 466.36 318.70 C 466.23 316.81 468.51 314.13 469.00 312.00 C 463.64 316.11 466.49 320.66 468.00 326.00 Z"
  }))), _g526 || (_g526 = /*#__PURE__*/React.createElement("g", {
    fill: "#395143",
    fillOpacity: 0.73,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 248.00 314.00  C 248.00 317.67 248.00 321.33 248.00 325.00 C 248.00 325.00 248.74 325.25 249.00 325.00 C 249.26 322.09 250.02 314.94 248.00 313.00 C 248.00 313.00 248.00 313.50 248.00 314.00 Z"
  }))), _g527 || (_g527 = /*#__PURE__*/React.createElement("g", {
    fill: "#596F65",
    fillOpacity: 0.16,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 263.00 313.00  C 260.11 311.85 258.38 316.41 260.99 317.99 C 263.60 319.57 265.57 314.02 263.00 313.00 Z"
  }))), _g528 || (_g528 = /*#__PURE__*/React.createElement("g", {
    fill: "#829D92",
    fillOpacity: 0.15,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 313.00 318.00  C 312.37 317.13 313.49 314.98 313.00 314.00 C 315.03 313.36 315.06 315.69 315.00 317.00 C 317.73 315.51 314.36 311.87 312.00 313.00 C 312.35 314.53 311.23 317.21 313.00 318.00 Z"
  }))), _g529 || (_g529 = /*#__PURE__*/React.createElement("g", {
    fill: "#AEC7B4",
    fillOpacity: 0.1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 323.00  C 325.00 320.00 325.00 317.00 325.00 314.00 C 326.00 314.00 327.00 314.00 328.00 314.00 C 323.60 309.50 322.39 321.94 325.00 323.00 Z"
  }))), _g530 || (_g530 = /*#__PURE__*/React.createElement("g", {
    fill: "#5A6C61",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 341.00 313.00  C 338.11 311.85 336.38 316.41 338.99 317.99 C 341.60 319.57 343.57 314.02 341.00 313.00 Z"
  }))), _g531 || (_g531 = /*#__PURE__*/React.createElement("g", {
    fill: "#8DA093",
    fillOpacity: 0.22,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 344.00 322.00  C 344.45 318.56 345.53 316.05 344.00 313.00 C 344.76 315.86 343.87 320.51 344.00 322.00 Z"
  }))), _g532 || (_g532 = /*#__PURE__*/React.createElement("g", {
    fill: "#4B6253",
    fillOpacity: 0.52,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 350.00 314.00  C 350.00 318.00 350.00 322.00 350.00 326.00 C 355.79 326.16 351.85 317.71 353.00 314.00 C 354.70 314.34 355.89 313.82 357.00 313.00 C 348.82 311.31 353.89 321.64 351.00 325.00 C 350.06 321.54 352.68 315.58 350.00 313.00 C 350.00 313.00 350.00 313.50 350.00 314.00 Z"
  }))), _g533 || (_g533 = /*#__PURE__*/React.createElement("g", {
    fill: "#819C8C",
    fillOpacity: 0.3,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 443.00 326.00  C 440.46 320.28 446.45 315.25 439.00 313.00 C 439.27 314.47 441.00 313.89 442.00 314.00 C 443.14 316.96 440.05 324.08 443.00 326.00 Z"
  }))), _g534 || (_g534 = /*#__PURE__*/React.createElement("g", {
    fill: "#99AD9F",
    fillOpacity: 0.29,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 445.00 326.00  C 447.28 322.99 445.37 317.83 446.00 314.00 C 447.41 314.35 448.16 313.68 449.00 313.00 C 441.51 315.26 447.54 320.27 445.00 326.00 Z"
  }))), _g535 || (_g535 = /*#__PURE__*/React.createElement("g", {
    fill: "#D1E1D6",
    fillOpacity: 0.06,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 248.00 326.00  C 248.00 326.00 248.00 325.50 248.00 325.00 C 248.00 321.33 248.00 317.67 248.00 314.00 C 248.00 314.00 247.50 313.99 247.00 314.00 C 246.74 316.92 245.98 324.06 248.00 326.00 Z"
  }))), _g536 || (_g536 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 313.00 318.00  C 313.42 318.58 314.89 317.45 315.00 317.00 C 315.06 315.69 315.03 313.36 313.00 314.00 C 313.49 314.98 312.37 317.13 313.00 318.00 Z"
  }))), _g537 || (_g537 = /*#__PURE__*/React.createElement("g", {
    fill: "#C7D2CA",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 321.00 322.00  C 320.45 319.63 321.00 316.45 321.00 314.00 C 319.21 316.42 320.06 319.54 321.00 322.00 Z"
  }))), _g538 || (_g538 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 325.00 323.00  C 326.22 323.50 327.34 322.67 328.00 322.00 C 328.77 320.77 328.00 316.51 328.00 315.00 C 328.00 315.00 328.10 314.02 328.00 314.00 C 327.00 314.00 326.00 314.00 325.00 314.00 C 325.00 317.00 325.00 320.00 325.00 323.00 Z"
  }))), _g539 || (_g539 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 400.00 314.00  C 396.72 312.15 393.72 320.65 397.32 322.66 C 400.92 324.67 402.95 315.66 400.00 314.00 Z"
  }))), _g540 || (_g540 = /*#__PURE__*/React.createElement("g", {
    fill: "#BDDBCA",
    fillOpacity: 0.06,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 328.00 322.00  C 329.70 320.28 329.32 316.78 328.00 315.00 C 328.00 316.51 328.77 320.77 328.00 322.00 Z"
  }))), _g541 || (_g541 = /*#__PURE__*/React.createElement("g", {
    fill: "#456051",
    fillOpacity: 0.47,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 257.00 324.00  C 258.50 321.97 258.53 318.07 257.00 316.00 C 257.00 318.67 257.00 321.33 257.00 324.00 Z"
  }))), _g542 || (_g542 = /*#__PURE__*/React.createElement("g", {
    fill: "#94A398",
    fillOpacity: 0.18,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 267.00 325.00  C 266.74 325.41 266.99 317.29 267.00 317.00 C 265.61 317.86 265.16 319.72 264.00 321.00 C 265.71 321.62 265.37 324.29 267.00 325.00 Z"
  }))), _g543 || (_g543 = /*#__PURE__*/React.createElement("g", {
    fill: "#A8C7B3",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 276.00 317.00  C 272.64 316.11 276.49 321.51 273.00 319.00 C 273.17 323.09 277.67 319.86 276.00 317.00 Z"
  }))), _g544 || (_g544 = /*#__PURE__*/React.createElement("g", {
    fill: "#C7D0CA",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 417.00 318.00  C 418.45 318.84 417.66 322.65 417.00 324.00 C 418.71 321.58 419.90 318.20 417.00 318.00 Z"
  }))), _g545 || (_g545 = /*#__PURE__*/React.createElement("g", {
    fill: "#ECF1EE",
    fillOpacity: 0.03,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 286.00 326.00  C 287.56 325.07 287.08 322.68 287.00 321.00 C 286.78 320.05 287.39 318.26 286.00 318.00 C 286.00 320.67 286.00 323.33 286.00 326.00 Z"
  }))), _g546 || (_g546 = /*#__PURE__*/React.createElement("g", {
    fill: "#CDCBCE",
    fillOpacity: 0.07,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 175.00 328.00  C 176.36 327.34 177.66 326.73 179.00 326.00 C 179.43 323.00 176.45 321.82 175.00 320.00 C 176.03 321.96 178.05 323.60 178.00 326.00 C 176.21 325.29 175.90 327.32 175.00 328.00 Z"
  }))), _g547 || (_g547 = /*#__PURE__*/React.createElement("g", {
    fill: "#C2E7CF",
    fillOpacity: 0.06,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 461.00 325.00  C 463.55 325.48 460.22 320.40 464.00 322.00 C 460.77 319.09 461.89 321.98 461.00 325.00 Z"
  }))), _g548 || (_g548 = /*#__PURE__*/React.createElement("g", {
    fill: "#8EA698",
    fillOpacity: 0.21,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 257.00 325.00  C 257.50 326.76 259.72 325.72 261.00 326.00 C 261.00 324.33 261.00 322.67 261.00 321.00 C 259.00 322.76 260.86 325.46 257.00 325.00 Z"
  }))), _g549 || (_g549 = /*#__PURE__*/React.createElement("g", {
    fill: "#99AA9D",
    fillOpacity: 0.13,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 298.00 326.00  C 297.46 324.69 296.59 323.56 297.00 322.00 C 297.93 321.18 299.37 323.24 300.00 323.00 C 300.99 322.95 296.35 318.97 296.01 321.99 C 295.67 325.01 296.14 324.73 298.00 326.00 Z"
  }))), _g550 || (_g550 = /*#__PURE__*/React.createElement("g", {
    fill: "#797C78",
    fillOpacity: 0.15,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 310.00 325.00  C 310.00 325.00 309.94 325.99 310.00 326.00 C 314.71 326.56 311.48 322.73 314.00 321.00 C 311.99 321.72 311.55 324.02 310.00 325.00 Z"
  }))), _g551 || (_g551 = /*#__PURE__*/React.createElement("g", {
    fill: "#A3BAA7",
    fillOpacity: 0.03,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 338.00 325.00  C 340.39 324.46 338.30 323.52 341.00 324.00 C 340.23 322.84 339.92 320.49 338.00 321.00 C 337.58 321.54 338.55 324.71 338.00 325.00 Z"
  }))), _g552 || (_g552 = /*#__PURE__*/React.createElement("g", {
    fill: "#A5B8AB",
    fillOpacity: 0.16,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 429.00 326.00  C 428.34 324.64 427.73 323.34 427.00 322.00 C 428.59 321.55 429.69 322.52 431.00 323.00 C 427.59 318.88 424.41 323.55 429.00 326.00 Z"
  }))), _g553 || (_g553 = /*#__PURE__*/React.createElement("g", {
    fill: "#7B9082",
    fillOpacity: 0.4,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 272.00 326.00  C 273.88 325.74 274.12 323.99 277.00 324.00 C 276.22 322.06 273.57 323.39 272.00 323.00 C 272.00 324.00 272.00 325.00 272.00 326.00 Z"
  }))), _g554 || (_g554 = /*#__PURE__*/React.createElement("g", {
    fill: "#B8B9C0",
    fillOpacity: 0.07,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 107.00 330.00  C 104.06 328.36 101.46 325.25 98.00 324.00 C 100.56 326.67 103.65 328.50 107.00 330.00 Z"
  }))), _g555 || (_g555 = /*#__PURE__*/React.createElement("g", {
    fill: "#9AA9A1",
    fillOpacity: 0.16,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 373.00 326.00  C 372.33 326.22 367.40 325.98 366.00 325.00 C 367.04 326.48 369.36 327.52 373.00 326.00 Z"
  }))), _g556 || (_g556 = /*#__PURE__*/React.createElement("g", {
    fill: "#A2B4BD",
    fillOpacity: 0.11,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 125.00 336.00  C 123.81 335.78 121.62 334.33 120.00 334.00 C 121.67 334.51 122.72 335.76 125.00 336.00 Z"
  }))), _g557 || (_g557 = /*#__PURE__*/React.createElement("g", {
    fill: "#B5B6C7",
    fillOpacity: 0.09,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 153.00 336.00  C 155.31 335.73 156.27 334.52 158.00 334.00 C 156.29 334.34 154.29 335.75 153.00 336.00 Z"
  }))), _g558 || (_g558 = /*#__PURE__*/React.createElement("g", {
    fill: "#696C73",
    fillOpacity: 0.26,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 146.00 336.00  C 141.00 336.00 136.00 336.00 131.00 336.00 C 135.65 336.45 141.28 336.45 146.00 336.00 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordicRoute);
export default __webpack_public_path__ + "static/media/NordicRoute.b0d3fef3755aa2a4dedab794988c367a.svg";
export { ForwardRef as ReactComponent };